var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3710 3710",
    style: {
      enableBackground: "new 0 0 3710 3710"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 3710,
    height: 3710
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4F7FA"
    },
    d: "M2483.751,820.598c88.14,123.392-11.553,325.994,118.276,418.126 c126.378,89.685,278.885-61.104,397.909,15.988c176.567,114.361,150.14,646.437-102.747,979.514 c-76.051,100.167-140.064,139.503-167.412,252.171c-58.726,241.926,158.097,383.19,118.378,502.955 c-89.432,269.667-1505.924,510.063-2083.732-291.469c-269.859-374.348-315.373-918.532-82.158-1334.659 C1103.68,611.289,2285.978,543.728,2483.751,820.598z"
  }), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M2877.802,710.127c88.14,123.392,12.365,277.569,142.193,369.701 c126.378,89.684-139.083,97.792-20.059,174.884c176.567,114.361,150.14,646.437-102.747,979.514 c-76.051,100.167-140.064,139.503-167.412,252.171c-58.726,241.926,158.097,383.19,118.378,502.955 c-89.432,269.667-1505.924,510.063-2083.732-291.469c-228.344-316.758-296.059-755.116-170.2-1134.599 c22.883-68.994-55.823-220.368-19.946-284.386c90.097-160.761-57.166-487.751,113.754-597.21 C1316.564,279.17,2722.312,492.452,2877.802,710.127z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000044890867600813783630000010462495825906075320_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044890867600813783630000010462495825906075320_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047760715078787358870000015495306774034428811_",
    gradientUnits: "userSpaceOnUse",
    x1: 1157.3313,
    y1: 2068.0127,
    x2: 1477.2292,
    y2: 2068.0127
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1157.331,
    y: 1908.064,
    style: {
      fill: "url(#SVGID_00000047760715078787358870000015495306774034428811_)"
    },
    width: 319.898,
    height: 319.898
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000156561492420575441950000009561042003578326918_",
    gradientUnits: "userSpaceOnUse",
    x1: -220.4517,
    y1: 1780.5226,
    x2: -173.3178,
    y2: 1780.5226,
    gradientTransform: "matrix(-0.9987 -0.0516 -0.0516 0.9987 2596.4365 20.3958)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000156561492420575441950000009561042003578326918_)"
    },
    d: "M2687.884,1789.144 c-3.206,4.715-7.103,11.75-9.307,20.929c-0.965,4.022-1.433,7.736-1.621,10.989c2.005,4.294,12.153,19.56,28.213,25.503 c9.934,3.677,27.963-2.352,11.01-17.149c-16.954-14.797-19.315-18.083-8.948-47.288c2.667-7.514,2.562-10.437,1.433-11.177 C2706.027,1769.224,2696.029,1779.799,2687.884,1789.144z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145739182595056126100000000847369209998648212_",
    gradientUnits: "userSpaceOnUse",
    x1: -130.4553,
    y1: 1794.2286,
    x2: -83.3199,
    y2: 1794.2286,
    gradientTransform: "matrix(-0.9987 -0.0516 -0.0516 0.9987 2596.4365 20.3958)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145739182595056126100000000847369209998648212_)"
    },
    d: "M2597.297,1798.189 c-3.206,4.714-7.104,11.75-9.308,20.929c-0.965,4.022-1.432,7.735-1.622,10.989c2.007,4.294,12.155,19.559,28.214,25.503 c9.934,3.677,27.964-2.353,11.01-17.15c-16.955-14.797-19.316-18.082-8.949-47.288c2.668-7.514,2.562-10.436,1.433-11.176 C2615.439,1778.267,2605.443,1788.843,2597.297,1798.189z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044872154627023352450000007994101718748280734_",
    gradientUnits: "userSpaceOnUse",
    x1: -297.5299,
    y1: 1441.5924,
    x2: -10.98,
    y2: 1441.5924,
    gradientTransform: "matrix(-0.9987 -0.0516 -0.0516 0.9987 2596.4365 20.3958)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000044872154627023352450000007994101718748280734_)"
    },
    d: "M2564.999,1169.5 c-7.619,38.185-15.239,76.37-22.857,114.555c12.568,36.799,24.058,76.819,33.479,119.939 c34.028,155.757,28.506,294.553,13.389,400.087c8.053,4.465,16.104,8.927,24.157,13.393 c24.596-55.38,55.543-137.985,72.896-241.899c20.502-122.767,12.724-219.555,18.405-219.7 c5.445-0.138,17.644,88.644,14.226,189.439c-3.614,106.55-23.566,193.643-41.133,253.232 c10.144,2.255,20.288,4.509,30.432,6.764c41.273-75.908,84.798-180.071,103.719-307.875 c13.14-88.755,29.099-206.713-26.25-330.865c-5.527-12.398-25.353-40.176-29.014-46.999 C2687.742,1130.299,2633.706,1158.774,2564.999,1169.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011032725610338847700000006983589863047079300_",
    gradientUnits: "userSpaceOnUse",
    x1: -372.5755,
    y1: 1558.9863,
    x2: -95.7797,
    y2: 1558.9863,
    gradientTransform: "matrix(-0.9976 0.069 0.069 0.9976 2352.0005 -76.9363)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.25,
      fill: "url(#SVGID_00000011032725610338847700000006983589863047079300_)"
    },
    d: "M2575.621,1403.996 c-9.421-43.12-20.911-83.14-33.479-119.94c7.619-38.185,15.238-76.371,22.857-114.555 c68.707-10.727,122.743-39.201,191.45-49.928c3.662,6.822,23.487,34.601,29.014,46.999 c18.658,41.852,29.19,82.994,34.482,122.557c-132.012-5.958-171.17,20.235-182.558,45.224 c-18.13,39.78,31.412,82.442,10.596,163.491c-6.26,24.376-14.769,36.201-16.771,66.935 c-2.628,40.332,10.415,44.698,11.074,85.839c0.722,45.015-14.218,81.953-26.477,112.266 c-7.621,18.845-15.422,33.91-21.225,44.291c-1.858-1.03-3.716-2.06-5.575-3.091 C2604.126,1698.548,2609.648,1559.752,2575.621,1403.996z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078040050283027287370000004256562995073877892_",
    gradientUnits: "userSpaceOnUse",
    x1: 241.4939,
    y1: 970.074,
    x2: -296.5478,
    y2: 686.5347,
    gradientTransform: "matrix(-1 0 0 1 2490.627 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6B3976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078040050283027287370000004256562995073877892_)"
    },
    d: "M2681.768,638.482 c-4.797,5.196,0.68,13.4-0.921,41.037c-0.731,12.641-2.583,23.112-4.208,30.518c-0.941,6.755-1.976,13.001-3.08,18.5 c-0.81,4.035-1.556,7.175-2.492,10.504c-1.735,6.174-3.935,12.246-6.537,18.05c-0.172,0.384-0.02,0.83,0.341,1.032 c0.022,0.012,0.043,0.023,0.066,0.033c0.406,0.183,0.883,0.001,1.065-0.406c2.635-5.875,4.861-12.022,6.619-18.271 c0.948-3.37,1.702-6.548,2.521-10.624c0.581-2.898,1.143-6.016,1.683-9.286c0.001,8.763-0.807,18.36-5.214,30.83 c-13.378,37.847,14.103,66.518,37.743,70.007c27.262,4.022,48.074-15.755,54.551-22.261 c26.104-26.225,35.392-72.41,17.165-108.78C2757.192,641.718,2693.526,625.749,2681.768,638.482z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044894415477854476100000004595982340854744213_",
    gradientUnits: "userSpaceOnUse",
    x1: 235.3533,
    y1: 981.7269,
    x2: -302.6874,
    y2: 698.1882,
    gradientTransform: "matrix(-1 0 0 1 2490.627 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6B3976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000044894415477854476100000004595982340854744213_)"
    },
    d: "M2747.144,683.027 c-0.722-4.46-4.188-22.7-19.231-35.469c-28.543-24.226-79.538-12.444-110.34,9.411c-32.232,22.867-21.803,42.079-53.829,67.861 c-34.784,28.002-55.506,12.052-102.478,37.716c-18.476,10.095-68.271,37.299-76.552,86.93 c-7.157,42.886,18.891,89.275,54.516,109.821c60.988,35.177,146.352-7.512,188.994-50.485 c40.898-41.215,17.588-54.757,78.11-136.271C2728.215,743.067,2752.539,716.356,2747.144,683.027z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000086673212865445864400000016457632481022932619_",
    gradientUnits: "userSpaceOnUse",
    x1: -188.7308,
    y1: 1151.561,
    x2: 373.0959,
    y2: 1507.5696,
    gradientTransform: "matrix(-0.9893 0.146 0.146 0.9893 2380.3286 -128.4262)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000086673212865445864400000016457632481022932619_)"
    },
    d: "M2780.182,813.7 c20.909,26.064,24.252,55.149,24.776,68.045c0.256,6.294-0.022,11.726-0.766,16.841c-4.437,30.464-15.533,49.946-20.992,62.001 c-6.988,15.43-3.94,42.617,2.441,96.355c4.244,35.732,8.453,58.412,16.607,105.574c4.123,23.844,9.878,57.557,16.607,98.454 c-68.186-12.299-122.244-10.144-158.953-5.929c-52.461,6.026-79.011,17.366-155.394,22.536 c-37.443,2.534-71.644,2.555-110.318-10.675c-8.245-2.823-68.168-23.323-67.614-49.821c0.065-3.121,0.962-6.026,24.911-32.028 c30.619-33.244,36.783-36.775,42.703-39.145c17.604-7.052,20.92,1.007,37.959-5.932c22.75-9.268,21.935-25.714,43.89-36.771 c20.564-10.359,30.389-0.521,45.076-7.117c23.894-10.732,30.622-51.469,30.973-137.033c0.171-41.762-1.166-96.779-7.109-161.72 c14.099-8.101,35.481-17.981,62.802-24.869c29.266-7.378,65.171-10.627,102.63-0.09 C2729.077,777.627,2758.158,786.242,2780.182,813.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137810596100284543820000002027338395437819534_",
    gradientUnits: "userSpaceOnUse",
    x1: 3273.0249,
    y1: 700.6976,
    x2: 3281.6074,
    y2: 472.0903,
    gradientTransform: "matrix(0.9962 0.0867 -0.0867 0.9962 -511.5689 -81.7878)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137810596100284543820000002027338395437819534_)"
    },
    d: "M2697.479,723.19 c5.285,14.278,9.176,31.856,0.625,42.49c-5.209,6.479-13.041,9.578-20.757,12.463c-18.235,6.819-25.921,2.485-29.887,7.357 c-8.727,10.724,8.059,56.837,42.464,64.255c34.239,7.382,69.492-27.103,65.93-43.581 c-3.213-14.869-37.774-13.893-41.985-32.698c-2.121-9.467,4.549-19.046,10.192-25.416l4.042,0.779L2697.479,723.19z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054239058337482854890000003308138156406267573_",
    gradientUnits: "userSpaceOnUse",
    x1: -199.6382,
    y1: 868.1981,
    x2: -192.6096,
    y2: 680.9812,
    gradientTransform: "matrix(-1 0 0 1 2490.627 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "url(#SVGID_00000054239058337482854890000003308138156406267573_)"
    },
    d: "M2647.46,785.5 c3.965-4.871,11.651-0.54,29.887-7.358c7.716-2.885,15.548-5.984,20.757-12.463c8.55-10.634,4.66-28.212-0.625-42.489 l30.623,25.649l-4.042-0.779c-4.478,5.056-9.531,12.139-10.394,19.578c-2.565,1.407-4.775,3.014-6.39,4.629 c3.527,10.268,4.191,18.886,4.215,24.417c0.038,8.626,0.065,15.032-4.215,20.638c-4.669,6.116-11.728,7.698-17.899,9.081 c-13.713,3.072-25.944,0.312-33.878-2.48C2645.708,808.702,2642.56,791.522,2647.46,785.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106145827808505650410000010194885363500887468_",
    gradientUnits: "userSpaceOnUse",
    x1: 3097.2065,
    y1: 728.4688,
    x2: 3094.8921,
    y2: 914.9489,
    gradientTransform: "matrix(1 -0.0041 0.0043 1.043 -378.149 -42.6284)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106145827808505650410000010194885363500887468_)"
    },
    d: "M2706.239,737.791 c0,0,1.741,17.487,19.057,17.578c21.337,0.112,23.704-56.188,18.516-59.405c-6.016-3.731-11.28,5.407-25.283,2.22 c-5.897-1.341-10.994-8.925-13.983-0.752c-3.4,9.299-0.528,25.758-0.528,25.758s-5.07-4.18-5.848,0.85 C2697.153,730.622,2702.091,734.736,2706.239,737.791z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034790635501975491070000013180271772366143391_",
    gradientUnits: "userSpaceOnUse",
    x1: 253.3335,
    y1: 947.6058,
    x2: -284.7055,
    y2: 664.0681,
    gradientTransform: "matrix(-1 0 0 1 2490.627 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6B3976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000034790635501975491070000013180271772366143391_)"
    },
    d: "M2739.99,676.616 c6.771,6.905,10.505,20.302,5.813,27.036c-6.742,9.675-26.683-0.426-34.838,11.408c-3.575,5.188-3.368,12.39-5.222,12.273 c-1.535-0.096-2.443-5.087-3.327-9.192c-4.875-22.633-10.517-25.173-8.798-31.653 C2697.112,673.317,2726.087,662.437,2739.99,676.616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2E3E4"
    },
    d: "M2731.821,906.417h141.547c7.437,0,12.486,7.364,9.639,14.056l-66.978,157.447 c-1.616,3.797-5.419,6.274-9.639,6.274l-136.259,1.482c-7.336,0-13.423-8.663-10.769-15.325l62.731-157.446 C2723.652,908.993,2727.515,906.417,2731.821,906.417z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4F7FA"
    },
    d: "M2735.745,907.9h137.892c7.245,0,12.163,7.363,9.39,14.056l-65.248,157.447 c-1.574,3.797-5.28,6.273-9.39,6.273h-133.756c-7.146,0-12.062-7.18-9.476-13.842l61.112-157.447 C2727.787,910.476,2731.55,907.9,2735.745,907.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036252687297467050340000011670333175643304863_",
    gradientUnits: "userSpaceOnUse",
    x1: 2798.3235,
    y1: 892.8467,
    x2: 2818.8252,
    y2: 930.7609
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6B3976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000036252687297467050340000011670333175643304863_)"
    },
    d: "M2777.079,907.366 c0.657-2.253,2.722-3.801,5.069-3.801h54.73c1.728,0,3.065,1.517,2.846,3.231l-2.955,8.775 c-0.585,1.737-2.227,2.896-4.061,2.865l-53.057-0.885c-2.778-0.046-4.75-2.722-3.972-5.388L2777.079,907.366z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000094576335944708103610000010177030673768626581_",
    gradientUnits: "userSpaceOnUse",
    x1: 2803.3677,
    y1: 890.1846,
    x2: 2823.4004,
    y2: 927.2314
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6B3976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000094576335944708103610000010177030673768626581_)"
    },
    d: "M2796.715,909.064l4.933-12.109 c0.868-2.13,2.939-3.523,5.239-3.523h13.274c2.117,0,3.595,2.097,2.883,4.091l-4.329,12.12L2796.715,909.064z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000135662127045721273550000016530957212207918474_",
    gradientUnits: "userSpaceOnUse",
    x1: 2329.656,
    y1: 744.4386,
    x2: 2377.6567,
    y2: 744.4386,
    gradientTransform: "matrix(0.9885 0.1509 -0.1509 0.9885 490.7888 -103.4061)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000135662127045721273550000016530957212207918474_)"
    },
    d: "M2679.631,995.068l19.735-22.49 c2.659-3.03,6.677-4.495,10.662-3.887l21.678,3.31c0,0-3.092,10.146-14.003,10.88c-10.911,0.734-14.295,13.417-21.723,17.683 c-7.427,4.266-7.427,4.266-7.427,4.266L2679.631,995.068z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091716843815537800360000009967521217381524135_",
    gradientUnits: "userSpaceOnUse",
    x1: 2508.405,
    y1: 788.8466,
    x2: 2618.7227,
    y2: 1126.9176
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000091716843815537800360000009967521217381524135_)"
    },
    d: "M2552.549,807.837 c19.897-15.135,32.389-16.302,40.925-14.235c25.562,6.196,41.926,47.81,40.331,82.443 c-3.016,65.512-69.966,99.01-59.904,118.62c4.644,9.049,25.641,15.055,105.426-5.338c4.745,5.633,9.489,11.27,14.235,16.903 c-6.618,10.016-33.497,48.153-84.963,61.387c-40.314,10.367-95.898,5.495-125.887-28.469 C2427.234,976.317,2493.588,852.685,2552.549,807.837z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109738693380334397350000001171256233764897153_",
    gradientUnits: "userSpaceOnUse",
    x1: 188.7977,
    y1: 931.5084,
    x2: -283.6811,
    y2: 682.5198,
    gradientTransform: "matrix(-1 0 0 1 2490.627 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6B3976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109738693380334397350000001171256233764897153_)"
    },
    d: "M2704.545,697.432 c4.721,5.161-5.635,22.245-26.54,56.205c-12.866,20.903-19.301,31.354-23.436,35.875 c-22.267,24.33-59.832,43.069-97.825,40.959c-26.072-1.453-29.89-11.472-51.26-7.907c-32.239,5.38-22.854-57.289-39.491-23.2 c-0.994,2.036,6.595,17.901,48.401-11.263c34.208-23.865,43.509-16.668,97.27-49.717c3.9-2.398,20.411-12.615,43.588-24.115 C2682.499,700.754,2699.849,692.299,2704.545,697.432z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018951844935790258820000002604767533662378931_",
    gradientUnits: "userSpaceOnUse",
    x1: 1438.0896,
    y1: 2275.8877,
    x2: 1461.5476,
    y2: 2698.1367,
    gradientTransform: "matrix(1 -6.000000e-04 6.000000e-04 1 -1.8682 1.9237)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018951844935790258820000002604767533662378931_)"
    },
    d: "M1496.437,2427.058 c0,0,2.947,23.34,0.984,31.16c-1.967,7.822-69.825,13.514-92.863,10.81c-23.036-2.703,13.705-26.257,28.379-30.68 C1447.61,2433.922,1496.437,2427.058,1496.437,2427.058z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001650913333307280450000007800073096961112252_",
    gradientUnits: "userSpaceOnUse",
    x1: 1482.391,
    y1: 2483.9768,
    x2: 1469.9298,
    y2: 1913.8922,
    gradientTransform: "matrix(1 -6.000000e-04 6.000000e-04 1 -1.8682 1.9237)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000001650913333307280450000007800073096961112252_)"
    },
    d: "M1462.251,2388.143l7.182,46.824 c0,0,18.245,8.186,27.008,0.079l0.935-49.017L1462.251,2388.143z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031902295655445070780000015239389192532760973_",
    gradientUnits: "userSpaceOnUse",
    x1: 1862.6578,
    y1: 2252.3052,
    x2: 1886.1141,
    y2: 2674.5217,
    gradientTransform: "matrix(1 -6.000000e-04 6.000000e-04 1 -1.8682 1.9237)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031902295655445070780000015239389192532760973_)"
    },
    d: "M1844.815,2385.813 c0,0-14.395,10.694-10.547,23.488c3.846,12.794,37.477,64.049,61.432,78.587c23.953,14.539,16.429-15.777,9.45-34.656 c-6.98-18.881-24.813-60.468-31.767-67.436C1866.429,2378.829,1844.815,2385.813,1844.815,2385.813z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000056387683673511585850000004646406216647774087_",
    gradientUnits: "userSpaceOnUse",
    x1: 1856.1901,
    y1: 2475.7976,
    x2: 1843.729,
    y2: 1905.7212,
    gradientTransform: "matrix(1 -6.000000e-04 6.000000e-04 1 -1.8682 1.9237)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000056387683673511585850000004646406216647774087_)"
    },
    d: "M1818.881,2334.383 c6.973,19.397,13.679,35.345,18.922,47.106c11.601,26.024,17.941,35.788,25.117,44.25c6.26,7.371,21.076,23.1,25.053,20.478 c4.041-2.658-6.805-21.787-27.716-77.813c-3.039-8.129-12.631-34.039-12.631-34.039l0,0L1818.881,2334.383z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000006702535465061444500000010138580775048440737_",
    gradientUnits: "userSpaceOnUse",
    x1: 1301.3875,
    y1: 2113.4473,
    x2: 1538.1418,
    y2: 1795.6978,
    gradientTransform: "matrix(1 -6.000000e-04 6.000000e-04 1 -1.8682 1.9237)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6B3976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000006702535465061444500000010138580775048440737_)"
    },
    d: "M1319.596,1523.966 c-4.936,48.772-9.655,124.468-2.473,216.329c9.36,119.682,58.845,176.312,88.937,303.91 c18.392,77.978,17.674,211.844,40.128,355.389c5.192,2.967,20.464,10.767,40.12,7.84c11.004-1.642,19.234-6.021,24.092-9.171 c58.571-179.354,41.171-290.465,12.806-359.679c-12.088-29.502-26.739-52.775-34.589-98.134 c-10.391-60.011,2.389-93.57,20.555-232.604c12.947-99.096,10.686-114.412,2.021-129.267 C1476.556,1519.187,1370.722,1520.414,1319.596,1523.966z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000015344528474367927790000007456733150717008306_",
    gradientUnits: "userSpaceOnUse",
    x1: 602.9201,
    y1: 887.9201,
    x2: 688.8815,
    y2: 1413.6088,
    gradientTransform: "matrix(0.9809 -0.1946 0.1946 0.9809 122.6772 238.6015)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000015344528474367927790000007456733150717008306_)"
    },
    d: "M954.336,1022.414 c0,0-8.257-32.299-21.97-40.818c-13.711-8.517-33.089-17.622-37.531-21.363c-4.442-3.744-9.619,7.456,3.178,16.016 c12.794,8.56,12.794,8.56,12.794,8.56c0.269,2.363-0.089,4.201-0.52,5.496c-2.023,6.066-8.932,10.228-17.474,11.02 c-32.816,6.894-45.639,7.237-50.644,5.775c-0.745-0.218-3.598-1.141-4.803,0.128c-1.93,2.035,1.546,8.479,3.029,10.738 c8.889,13.556,39.714,19.436,62.785,8.814c8.429-3.876,11.652-8.039,17.804-6.997c9.768,1.65,15.777,14.533,19.331,25.199 L954.336,1022.414z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096048400706636472770000017976621898270264233_",
    gradientUnits: "userSpaceOnUse",
    x1: 1477.2678,
    y1: 2152.8713,
    x2: 2031.7638,
    y2: 1635.7574,
    gradientTransform: "matrix(1 -6.000000e-04 6.000000e-04 1 -1.8682 1.9237)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6B3976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096048400706636472770000017976621898270264233_)"
    },
    d: "M1521.597,1544.695 c36.065,185.63,71.41,283.116,98.144,338.251c6.594,13.596,28.591,57.465,49.398,120.363 c18.421,55.675,26.109,96.633,30.044,114.661c12.43,56.9,43.111,139.973,125.601,248.905c1.027,0.605,15.087,8.544,28.518,1.45 c6.797-3.593,10.184-9.313,11.53-11.979c-10.841-104.191-23.265-191.741-34.042-259.31 c-2.265-14.172-12.223-76.174-27.833-158.09c-6.108-32.057-15.059-79.026-25.776-127.269 c-13.343-60.076-33.799-141.806-65.307-239.736C1648.45,1562.856,1585.023,1553.78,1521.597,1544.695z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122702120611523458460000000257592305989727396_",
    gradientUnits: "userSpaceOnUse",
    x1: 929.1216,
    y1: 980.018,
    x2: 1373.8906,
    y2: 980.018,
    gradientTransform: "matrix(1 -6.000000e-04 6.000000e-04 1 -1.8682 1.9237)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000122702120611523458460000000257592305989727396_)"
    },
    d: "M927.872,1032.673 c9.339-8.314,18.68-16.626,28.02-24.938c3.423,3.454,53.343,52.106,123.076,37.306c48.013-10.191,75.685-49.643,93.411-74.824 c53.24-75.636,21.336-131.09,78.68-182.499c15.924-14.274,47.168-31.568,67.606-26.312 c48.695,12.52,76.817,158.922,29.766,274.121c-9.497,23.251-61.79,151.28-180.583,165.22 C1071.934,1212.003,970.175,1144.481,927.872,1032.673z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108302328279644517240000004318893532603041154_",
    gradientUnits: "userSpaceOnUse",
    x1: 2384.6929,
    y1: 363.2859,
    x2: 1837.8406,
    y2: 923.9833,
    gradientTransform: "matrix(1 -6.000000e-04 6.000000e-04 1 -1.8682 1.9237)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000108302328279644517240000004318893532603041154_)"
    },
    d: "M1490.517,810.382 c-20.4-18.833-59.418-40.534-79.012-91.025c-5.9-15.198-26.793-69.047,3.955-110.267c18.251-24.47,52.17-41.097,82.078-35.237 c25.558,5.008,29.565,22.804,73.011,58.598c16.91,13.932,44.094,36.326,74.34,48.766c51.819,21.318,82.93,1.21,134.941,3.469 c63.896,2.777,138.143,38.389,173.935,90.221c63.53,91.994-28.357,185.412,41.231,293.185 c22.804,35.307,34.026,27.383,88.023,95.728c54.07,68.434,81.104,102.647,76.326,144.602 c-6.637,58.227-69.314,113.882-128.365,117.698c-57.683,3.733-94.382-41.63-123.737-21.758 c-20.896,14.136-8.927,41.611-31.106,74.648c-28.591,42.596-84.836,51.116-93.919,52.486 c-84.312,12.773-198.063-86.031-246.424-203.139C1448.593,1117.179,1601.418,912.767,1490.517,810.382z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016780873325934184880000001749745416847773072_",
    gradientUnits: "userSpaceOnUse",
    x1: 1331.5876,
    y1: 2135.9495,
    x2: 1568.3419,
    y2: 1818.2002,
    gradientTransform: "matrix(1 -6.000000e-04 6.000000e-04 1 -1.8682 1.9237)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6B3976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000016780873325934184880000001749745416847773072_)"
    },
    d: "M1523.207,2038.584 c-12.088-29.504-26.739-52.778-34.589-98.134c-10.391-60.011,2.389-93.57,20.555-232.604 c12.947-99.096,10.686-114.412,2.021-129.267c-18.823-32.276-58.681-46.577-99.35-52.403c0.544,2.085,1.093,4.174,1.536,6.192 c21.398,97.43-59.998,156.936-23.2,264.029c18.143,52.8,47.046,64.879,53.815,126.135 c6.343,57.381-16.524,69.349-11.605,121.502c7.351,77.961,62.748,96.796,77.198,156.492 c9.389,38.791,1.537,95.524-66.808,177.68c1.14,7.074,2.279,14.17,3.408,21.389c5.195,2.967,20.464,10.767,40.12,7.84 c11.004-1.642,19.234-6.021,24.092-9.171C1568.972,2218.909,1551.571,2107.798,1523.207,2038.584z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000061466483308372649990000005779205165749564308_",
    gradientUnits: "userSpaceOnUse",
    x1: 929.1216,
    y1: 1034.722,
    x2: 1373.8882,
    y2: 1034.722,
    gradientTransform: "matrix(1 -6.000000e-04 6.000000e-04 1 -1.8682 1.9237)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "url(#SVGID_00000061466483308372649990000005779205165749564308_)"
    },
    d: "M1307.848,901.598 c-87.761,69.406-77.904,202.415-131.877,209.191c-16.486,2.071-15.588-10.57-54.921-23.329 c-57.529-18.664-84.537,0.241-125.007-13.941c-16.761-5.874-38.565-18.429-60.051-48.072c-2.707,2.41-5.414,4.818-8.119,7.227 c42.303,111.807,144.062,179.329,239.976,168.073c118.793-13.94,171.086-141.969,180.583-165.22 c22.075-54.053,27.602-114.975,22.217-165.713C1350.385,875.74,1328.375,885.365,1307.848,901.598z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000161592026566648656900000005344356831669776808_",
    gradientUnits: "userSpaceOnUse",
    x1: 1264.7919,
    y1: 857.8096,
    x2: 1804.7258,
    y2: 1736.934,
    gradientTransform: "matrix(1 -6.000000e-04 6.000000e-04 1 -1.8682 1.9237)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000161592026566648656900000005344356831669776808_)"
    },
    d: "M1244.088,796.499 c5.374-8.362,22.467-31.529,95.05-48.642c26.032-6.139,67.876-15.408,121.299-13.482c8.954,0.323,37.81,1.779,68.913,8.5 c66.291,14.32,198.455,64.704,203.104,133.448c3.318,49.092-62.137,52.287-99.115,139.22 c-26.941,63.335-26.717,142.434,2.755,203.945c23.653,49.367,65.466,86.41,97.221,114.552 c47.632,42.201,72.29,48.675,88.273,86.501c17.406,41.191-0.095,61.293,21.506,89.486 c23.198,30.277,50.349,16.18,89.657,46.788c40.266,31.352,25.961,57.184,62.608,91.837 c53.253,50.345,123.796,33.939,127.094,56.606c2.839,19.498-47.287,45.989-89.882,56.743 c-84.352,21.302-157.962-14.318-179.85-25.299c-60.604-30.4-50.151-50.105-96.358-73.283 c-77.368-38.802-130.199,4.464-306.359,9.024c-95.396,2.474-143.633,3.047-170.08-29.212 c-24.153-29.469-11.486-61.813,2.911-201.19c0,0,0-0.003,0.001-0.016c4.624-46.546,14.309-144.002,14.334-199.534 c0.015-32.82-11.4-86.437-34.232-193.671c-1.348-6.323-13.703-64.256-23.706-141.651 C1230.226,837.473,1231.511,816.071,1244.088,796.499z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000123443068721470047560000000915822066396838040_",
    gradientUnits: "userSpaceOnUse",
    x1: 1689.1399,
    y1: 744.6265,
    x2: 1823.3048,
    y2: 1565.0991,
    gradientTransform: "matrix(1 -6.000000e-04 6.000000e-04 1 -1.8682 1.9237)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000123443068721470047560000000915822066396838040_)"
    },
    d: "M1995.359,1648.65 c-36.648-34.653-22.34-60.486-62.608-91.835c-39.308-30.609-66.459-16.512-89.657-46.788 c-21.602-28.193-4.1-48.295-21.506-89.484c-15.983-37.826-40.641-44.299-88.273-86.504 c-31.754-28.141-73.567-65.185-97.222-114.551c-41.052-85.669-12.443-177.179-2.754-203.946 c31.134-86.038,94.082-131.417,116.894-146.291c-2.199-2.366-108.753,92.613-111.528,89.775 c-150.34,20.755-133.99,10.015-144.816,35.749c-25.025,59.48,14.665,81.304,15.796,252.806 c0.537,81.976-8.283,114.35,18.335,148.549c30.445,39.113,65.494,26.981,109.513,78.12 c33.824,39.288,28.427,64.215,59.998,80.757c33.946,17.784,55.549-2.982,93.83,5.157 c63.954,13.596,77.67,87.319,119.969,127.632c31.986,30.484,91.103,51.773,207.653,28.809c2.693-3.927,3.994-7.759,3.47-11.35 C2119.152,1682.591,2048.612,1698.996,1995.359,1648.65z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000162335949731930878710000018269089901277077909_",
    gradientUnits: "userSpaceOnUse",
    x1: 1055.7213,
    y1: 572.3002,
    x2: 1446.6993,
    y2: 1208.8933,
    gradientTransform: "matrix(0.9288 0.3704 -0.3704 0.9288 787.1494 -228.7481)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000162335949731930878710000018269089901277077909_)"
    },
    d: "M1436.66,848.678 c-27.417,25.607,11.516,126.241,73.434,191.348c1.062,1.118,2.68,2.821,4.792,4.986 c12.235,12.539,96.876,98.042,167.426,74.209c59.347-20.047,77.109-106.826,77.886-152.809 c0.85-50.207-17.962-86.347-23.134-95.745c-47.419-86.174-155.001-117.501-166.197-102.575 c-3.835,5.114,9.764,26.091,36.961,68.045c31.548,48.665,46.477,63.9,41.475,83.102c-3.744,14.364-18.469,30.303-35.636,32.267 c-36.308,4.153-75.952-55.075-128.747-95.915c-6.95-5.379-21.818-16.296-37.121-12.63 C1443.613,843.966,1439.783,845.763,1436.66,848.678z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129185354993391971230000011380873221515199111_",
    gradientUnits: "userSpaceOnUse",
    x1: 1462.1664,
    y1: 764.0124,
    x2: 1607.0244,
    y2: 553.7344,
    gradientTransform: "matrix(1 -6.000000e-04 6.000000e-04 1 -1.8682 1.9237)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129185354993391971230000011380873221515199111_)"
    },
    d: "M1480.491,649.962 c0,0,7.62,60.614,30.002,74.49c22.384,13.867,58.565,31.987,62.551,36.911c3.988,4.915-138.589,20.335-209.272-15.279l0,0 c23.283-4.87,29.613-6.66,29.613-6.66c6.319-1.791,18.107-5.12,29.921-11.864c8.041-4.585,21.003-13.542,32.885-30.448 l-0.281-33.565L1480.491,649.962z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013916046582696731530000008409605949518471060_",
    gradientUnits: "userSpaceOnUse",
    x1: 1449.0348,
    y1: 657.3538,
    x2: 1678.0005,
    y2: 519.507,
    gradientTransform: "matrix(1 -6.000000e-04 6.000000e-04 1 -1.8682 1.9237)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013916046582696731530000008409605949518471060_)"
    },
    d: "M1483.907,671.43 c0,0-14.576,20.031-37.457,11.701c-20.49-7.458-8.297-60.371,7.947-66.417c5.418-2.015,15.37-1.131,22.026,3.015 c4.681,2.915,17.185,18.429,10.034,35.827c5.174-1.503,9.729-0.144,10.87,2.419c1.451,3.249-2.929,7.679-3.919,8.681 C1489.97,670.135,1485.82,671.11,1483.907,671.43z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067958825976860871240000003237521818711376317_",
    gradientUnits: "userSpaceOnUse",
    x1: 1508.213,
    y1: 836.4724,
    x2: 1555.9105,
    y2: 1113.2538,
    gradientTransform: "matrix(1 -6.000000e-04 6.000000e-04 1 -1.8682 1.9237)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.36,
      fill: "url(#SVGID_00000067958825976860871240000003237521818711376317_)"
    },
    d: "M1594.095,1107.408 c-0.264,0-0.534-0.06-0.785-0.198c-134.204-72.487-165.601-214.486-165.902-215.912c-0.298-1.333-7.142-33.13,14.873-41.317 c22.235-8.276,34.732-4.467,60.785,18.512c6.379,5.625,14.144,13.794,22.367,22.441c25.625,26.945,60.705,63.864,87.941,58.95 c0.873-0.193,1.757,0.434,1.92,1.332c0.16,0.898-0.437,1.757-1.335,1.918c-28.924,5.245-63.323-30.898-90.924-59.923 c-8.171-8.593-15.886-16.706-22.155-22.238c-26.788-23.628-37.832-25.191-57.446-17.898 c-19.342,7.194-12.865,37.219-12.796,37.521c0.304,1.426,31.425,141.966,164.246,213.705c0.802,0.435,1.102,1.437,0.668,2.241 C1595.251,1107.093,1594.684,1107.408,1594.095,1107.408z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000009558511257378988890000007800018325840319149_",
    gradientUnits: "userSpaceOnUse",
    x1: 1408.5679,
    y1: 814.4476,
    x2: 1482.7913,
    y2: 1268.3535,
    gradientTransform: "matrix(1 -6.000000e-04 6.000000e-04 1 -1.8682 1.9237)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000009558511257378988890000007800018325840319149_)"
    },
    d: "M1457.728,850.135 c0,0-72.122-64.279-81.681-53.849c-16.992,18.539-15.69,37.413,0.287,47.6c15.976,10.185,22.21,14.075,34.672,15.624 c12.461,1.551,12.461,1.551,12.461,1.551l16.362,8.711C1439.828,869.771,1460.854,867.266,1457.728,850.135z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000161595500938339218730000000021137375999709849_",
    gradientUnits: "userSpaceOnUse",
    x1: 1125.0278,
    y1: 547.5623,
    x2: 1152.5133,
    y2: 818.7543,
    gradientTransform: "matrix(0.997 0.077 -0.077 0.997 -90.4582 -4.5583)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000161595500938339218730000000021137375999709849_)"
    },
    d: "M1013.147,830.927 c-31.48,17.342-47.219,26.012-59.093,27.106c-23.235,2.139-52.754-9.887-61.016-30.044 c-6.958-16.978,6.099-27.689-2.893-44.557c-8.793-16.493-24.97-13.183-29.536-27.613c-4.191-13.247,8.484-19.063,9.698-43.586 c0.824-16.654-4.86-17.227-3.866-31.965c1.186-17.592,11.032-42.698,29.071-48.423c18.199-5.776,33.945,11.6,44.071,3.402 c7.094-5.743,0.869-15.487,8.24-24.698c10.007-12.505,37.224-14.219,50.853-2.408c13.174,11.417,7.742,30.349,16.457,32.937 c10.601,3.148,18.511-24.897,40.206-28.564c19.517-3.298,39.387,14.959,48.423,29.071c3.278,5.121,13.608,21.254,9.676,38.747 c-2.711,12.061-10.228,15.988-8.24,24.698c2.298,10.068,13.541,10.07,17.43,20.346c3.358,8.872-1.551,18.039-8.726,30.993 c-7.028,12.69-16.042,28.966-34.881,41.641c-13.005,8.75-16.288,6.093-46.016,21.782 C1023.849,824.626,1023.364,825.298,1013.147,830.927z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108270154634542396800000002535381485201244551_",
    gradientUnits: "userSpaceOnUse",
    x1: -53.1693,
    y1: 2012.5942,
    x2: -31.4235,
    y2: 2404.021,
    gradientTransform: "matrix(-0.9893 -0.1456 -0.1456 0.9893 1349.0945 202.6325)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000108270154634542396800000002535381485201244551_)"
    },
    d: "M1034.507,2331.198 c0,0-5.841,21.01-5.091,28.446c0.75,7.438,62.226,21.782,83.718,22.398c21.493,0.615-9.04-25.925-21.903-31.956 C1078.367,2344.055,1034.507,2331.198,1034.507,2331.198z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000069376526108252911840000017778695370083368356_",
    gradientUnits: "userSpaceOnUse",
    x1: 803.4293,
    y1: 2420.6682,
    x2: 835.9891,
    y2: 2420.6682,
    gradientTransform: "matrix(-0.9939 0.1104 0.1104 0.9939 1596.0035 -168.9714)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A03976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000069376526108252911840000017778695370083368356_)"
    },
    d: "M1062.24,2303.329l-1.795,43.875 c0,0-15.966,9.421-24.874,2.854l-5.907-45.062L1062.24,2303.329z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101091307154953399350000018269181831538197909_",
    gradientUnits: "userSpaceOnUse",
    x1: 785.9751,
    y1: 2381.448,
    x2: 775.1027,
    y2: 1961.0623,
    gradientTransform: "matrix(-0.9939 0.1104 0.1104 0.9939 1596.0035 -168.9714)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000101091307154953399350000018269181831538197909_)"
    },
    d: "M1104.691,1492.514 c9.57,44.423,21.708,113.672,24.551,199.039c3.698,111.222-10.598,183.451-25.184,304.099 c-8.914,73.733-19.931,182.018-25.842,316.571c-4.477,3.269-17.744,12.028-36.151,11.353 c-10.309-0.378-18.34-3.568-23.139-5.967c-72.424-159.2-67.834-263.353-48.829-330.037 c8.099-28.427,19.199-51.375,21.762-93.97c3.392-56.354-11.834-85.955-42.883-212.171 c-22.133-89.959-21.627-104.302-15.171-118.878C959.598,1504.271,1057.223,1494.506,1104.691,1492.514z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000071547513277909125680000003648245247369822616_",
    gradientUnits: "userSpaceOnUse",
    x1: 91.5858,
    y1: 2050.6028,
    x2: 113.3317,
    y2: 2442.0325,
    gradientTransform: "matrix(-0.9893 -0.1456 -0.1456 0.9893 1349.0945 202.6325)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000071547513277909125680000003648245247369822616_)"
    },
    d: "M885.766,2347.725 c0,0-5.841,21.01-5.09,28.446c0.75,7.438,62.225,21.782,83.718,22.398c21.492,0.615-9.04-25.925-21.903-31.956 C929.626,2360.582,885.766,2347.725,885.766,2347.725z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052092996236934111940000012955074366871234733_",
    gradientUnits: "userSpaceOnUse",
    x1: 953.0831,
    y1: 2420.6733,
    x2: 985.6429,
    y2: 2420.6733,
    gradientTransform: "matrix(-0.9939 0.1104 0.1104 0.9939 1596.0035 -168.9714)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A03976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052092996236934111940000012955074366871234733_)"
    },
    d: "M913.5,2319.855l-1.795,43.875 c0,0-15.966,9.421-24.873,2.854l-5.907-45.062L913.5,2319.855z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000120521783013277286720000008333973450720103332_",
    gradientUnits: "userSpaceOnUse",
    x1: 935.6291,
    y1: 2381.4531,
    x2: 924.7567,
    y2: 1961.0674,
    gradientTransform: "matrix(-0.9939 0.1104 0.1104 0.9939 1596.0035 -168.9714)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000120521783013277286720000008333973450720103332_)"
    },
    d: "M955.95,1509.041 c9.57,44.423,21.708,113.672,24.551,199.039c3.698,111.222-10.598,183.45-25.184,304.099 c-8.914,73.733-19.931,182.018-25.842,316.571c-4.477,3.269-17.744,12.027-36.151,11.353 c-10.309-0.378-18.34-3.568-23.139-5.968c-72.425-159.2-67.834-263.352-48.83-330.036c8.1-28.427,19.2-51.375,21.763-93.97 c3.391-56.354-11.834-85.955-42.884-212.171c-22.133-89.959-21.627-104.302-15.171-118.879 C810.857,1520.797,908.483,1511.033,955.95,1509.041z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165202526896199765090000010577662262619008415_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.5987,
    y1: 2445.896,
    x2: 245.5754,
    y2: 1901.8744,
    gradientTransform: "matrix(-0.997 -0.077 -0.077 0.997 1399.0319 109.9041)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165202526896199765090000010577662262619008415_)"
    },
    d: "M1251.928,1023.183 c10.752-34.639-57.587-85.174-116.927-111.873c-67.401-30.326-132.255-22.005-175.502-17.468 c-111.44,11.693-184.287,63.547-211.897,85.574c83.451,53.982,96.278,104.869,99.08,125.453 c3.153,23.16-1.401,44.579-57.992,155.556c-55.546,108.926-56.412,98.593-64.845,124.268 c-33.426,101.766-7.85,227.674,47.541,243.065c39.614,11.007,70.616-41.139,129.268-28.325 c35.638,7.786,32.168,28.781,75.249,44.562c66.879,24.499,137.904-3.143,158.991-11.35 c31.885-12.409,48.012-18.686,58.703-34.538c23.566-34.944-9.501-71.613-32.184-155.697 c-10.518-38.991,0.231-17.617-17.916-131.952l0,0c3.018-39.103-15.84-114.517,6.938-175.378 c8.495-22.7,12.743-34.05,21.687-46.149C1204.322,1045.374,1244.422,1047.363,1251.928,1023.183z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158736800232656622970000012719090884750142859_",
    gradientUnits: "userSpaceOnUse",
    x1: -594.7072,
    y1: 1534.8831,
    x2: -620.0737,
    y2: 1602.5275,
    gradientTransform: "matrix(-0.8996 0.4368 0.4368 0.8996 -256.4657 -277.3696)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A03976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158736800232656622970000012719090884750142859_)"
    },
    d: "M1011.108,813.056 c0,0-11.334,55.485-33.003,66.725c-21.67,11.234-56.394,25.423-60.428,29.69c-4.034,4.26,126.656,28.604,194.509,0.688l0,0 c-21.177-6.15-26.901-8.253-26.901-8.253c-5.713-2.102-16.371-6.013-26.815-13.081c-7.109-4.807-18.453-14.004-28.24-30.47 l2.636-31.003L1011.108,813.056z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116919575366018234900000012817131047326627987_",
    gradientUnits: "userSpaceOnUse",
    x1: -603.3445,
    y1: 1449.264,
    x2: -689.1078,
    y2: 1555.5623,
    gradientTransform: "matrix(-0.8996 0.4368 0.4368 0.8996 -256.4657 -277.3696)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A03976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116919575366018234900000012817131047326627987_)"
    },
    d: "M1006.431,832.656 c0,0,12.054,19.547,33.794,13.467c19.464-5.444,11.939-55.215-2.646-61.951c-4.865-2.247-14.128-2.134-20.572,1.228 c-4.534,2.365-17.189,15.817-11.81,32.404c-4.676-1.756-8.982-0.821-10.219,1.466c-1.57,2.9,2.164,7.305,3.01,8.302 C1000.92,831.032,1004.686,832.226,1006.431,832.656z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000028320837876978146410000012386431824224908431_",
    gradientUnits: "userSpaceOnUse",
    x1: 1659.139,
    y1: 1001.2598,
    x2: 1639.5913,
    y2: 936.2338,
    gradientTransform: "matrix(0.9556 0.2948 -0.2948 0.9556 -331.1556 -53.6467)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A03976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000028320837876978146410000012386431824224908431_)"
    },
    d: "M917.328,1348.659 c0,0,27.945,2.855,34.833-0.785c6.888-3.641,25.928-9.297,32.816-12.938c6.888-3.64,3.64,6.888-3.247,10.529 c-6.888,3.64-19.04,5.657-15.4,12.545c3.64,6.888,31.977,27.159,42.506,30.407c10.528,3.247-15.399,12.545-20.664,10.921 c-5.264-1.624-27.944-2.855-36.848-11.367c-8.905-8.512-21.449-23.912-44.13-25.143L917.328,1348.659z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003825341626637416080000002573134352767151028_",
    gradientUnits: "userSpaceOnUse",
    x1: -1034.8534,
    y1: 1366.5928,
    x2: -1054.4021,
    y2: 1301.5634,
    gradientTransform: "matrix(-0.9999 -0.0133 -0.0133 0.9999 9.9798 -4.4489)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A03976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000003825341626637416080000002573134352767151028_)"
    },
    d: "M1079.756,1347.129 c0,0-27.469-5.876-32.904-11.457c-5.435-5.582-21.814-16.819-27.249-22.401c-5.435-5.582-5.582,5.436-0.147,11.017 c5.435,5.582,16.379,11.237,10.797,16.672c-5.582,5.435-38.779,16.011-49.796,15.865 c-11.017-0.147,10.796,16.672,16.305,16.745s27.469,5.875,38.559,0.514c11.09-5.362,27.762-16.158,49.723-10.357 L1079.756,1347.129z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000017495083178929063080000001513203073057381557_",
    gradientUnits: "userSpaceOnUse",
    x1: 221.3642,
    y1: 2450.1858,
    x2: 283.3401,
    y2: 1906.171,
    gradientTransform: "matrix(-0.997 -0.077 -0.077 0.997 1399.0319 109.9041)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000017495083178929063080000001513203073057381557_)"
    },
    d: "M1050.821,1602.65 c-18.745-17.256-8.824-37.396-33.054-71.617c-41.163-58.137-99.143-41.456-115.687-82.633 c-19.228-47.857,50.031-92.794,27.544-148.74c-12.171-30.281-35.773-25.394-44.071-55.09 c-12.841-45.953,38.994-74.437,27.544-121.195c-6.923-28.274-33.303-48.194-55.089-55.089 c-7.827-2.478-16.138-3.511-24.66-3.354c9.189,17.306,12.157,31.298,13.333,39.938c3.153,23.16-1.401,44.579-57.992,155.555 c-55.546,108.927-56.412,98.593-64.845,124.268c-33.426,101.765-7.85,227.674,47.541,243.065 c39.613,11.008,70.616-41.139,129.268-28.325c35.638,7.786,32.168,28.781,75.249,44.562 c66.879,24.498,137.904-3.144,158.992-11.35c31.884-12.409,48.012-18.686,58.702-34.538c1.753-2.6,3.157-5.213,4.311-7.85 C1108.053,1627.274,1069.154,1619.525,1050.821,1602.65z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183211848195616597190000005129286820958378374_",
    gradientUnits: "userSpaceOnUse",
    x1: 731.3253,
    y1: 1597.858,
    x2: 793.3003,
    y2: 1053.8513
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183211848195616597190000005129286820958378374_)"
    },
    d: "M794.657,949.844 c-35.124,16.708-93.052,44.263-137.723,110.179c-17.345,25.594-55.846,82.406-49.58,137.722 c10.035,88.587,134.677,171.541,308.499,181.795c5.509-11.018,11.018-22.036,16.527-33.054 c-122.96-74.551-143.118-120.384-137.722-148.741c7.983-41.962,71.154-41.614,99.16-104.668 c26.553-59.783,7.146-144.248-33.054-159.759C843.793,926.769,827.183,934.372,794.657,949.844z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000063626175716763865000000010686988341575138998_",
    gradientUnits: "userSpaceOnUse",
    x1: 1153.3115,
    y1: 1645.9316,
    x2: 1215.2863,
    y2: 1101.9268
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000063626175716763865000000010686988341575138998_)"
    },
    d: "M1064.593,1335.467 c1.836,11.018,3.673,22.036,5.509,33.054c6.493,2.325,112.016,38.181,192.811-27.545 c81.564-66.352,64.737-176.692,60.598-203.83c-10.675-69.992-57.329-176.378-126.705-176.285 c-39.736,0.053-86.269,35.037-93.652,77.125c-12.828,73.136,101.567,116.406,93.652,187.303 C1193.592,1254.075,1169.433,1294.407,1064.593,1335.467z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000076597836160554398450000008596050452776951201_",
    gradientUnits: "userSpaceOnUse",
    x1: 1994.4159,
    y1: 2243.1282,
    x2: 2106.5427,
    y2: 2243.1282,
    gradientTransform: "matrix(0.9989 0.0458 -0.0458 0.9989 154.7604 -56.8246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000076597836160554398450000008596050452776951201_)"
    },
    d: "M2136.927,2221.519 c19.96,16.111,21.095,27.568,20.454,33.151c-1.035,9.001-7.817,12.497-24.042,29.496 c-21.945,22.994-18.584,26.068-29.766,34.386c-24.674,18.356-59.584,17.164-61.692,10.928 c-1.481-4.379,14.304-7.958,32.258-28.778c16.568-19.211,22.168-38.244,23.664-43.827c2.722-10.153,3.424-18.928,3.554-25 L2136.927,2221.519z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101101954468019402170000011587692338531226537_",
    gradientUnits: "userSpaceOnUse",
    x1: 2081.5625,
    y1: 2109.0251,
    x2: 2025.2388,
    y2: 2212.0562,
    gradientTransform: "matrix(0.9989 0.0458 -0.0458 0.9989 154.7604 -56.8246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000101101954468019402170000011587692338531226537_)"
    },
    d: "M2070.084,2172.426l39.327,68.431 c9.462,4.18,18.508,2.061,26.89-10.149l-15.379-83.21L2070.084,2172.426z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000051359559867791929570000011517601053380733092_",
    gradientUnits: "userSpaceOnUse",
    x1: 1871.4247,
    y1: 2228.9824,
    x2: 2069.7166,
    y2: 1364.0895,
    gradientTransform: "matrix(0.9989 0.0458 -0.0458 0.9989 154.7604 -56.8246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000051359559867791929570000011517601053380733092_)"
    },
    d: "M2021.92,1294.472 c-38.232,64.629-100.232,189.356-112.687,357.97c-12.294,166.426,29.765,293.23,47.379,340.52 c33.003,88.604,90.36,181.628,123.673,225.963c22.443-9.403,35.649-24.135,58.092-33.538 c-3.379-12.213-13.813-52.545-20.38-76.567c-5.089-18.612-14.471-53.048-16.4-60.408 c-16.157-61.626-3.461-107.885-7.944-184.112c-5.229-88.899-25.591-78.555-22.561-131.929 c4.525-79.698,49.672-98.333,101.445-213.727c35.437-78.982,72.657-161.94,38.373-207.262 C2167.758,1254.337,2036.564,1290.301,2021.92,1294.472z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059303051642568280330000000897678719880228013_",
    gradientUnits: "userSpaceOnUse",
    x1: 2161.2615,
    y1: 2319.8232,
    x2: 2315.5549,
    y2: 2319.8232,
    gradientTransform: "matrix(1 -6.000000e-04 6.000000e-04 1 -1.8682 1.9237)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000059303051642568280330000000897678719880228013_)"
    },
    d: "M2299.472,2284.025 c11.971,7.603,19.204,25.688,13.76,37.081c-5.353,11.199-19.016,7.67-52.189,17.889 c-35.533,10.944-42.558,21.984-68.756,21.977c-10.584-0.006-29.775-1.813-31.382-8.931c-1.13-5.001,7.014-9.989,33.825-28.027 c38.06-25.603,37.665-26.32,46.162-30.248C2262.234,2283.896,2283.667,2273.986,2299.472,2284.025z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000130636638850233566420000002546254567835066503_",
    gradientUnits: "userSpaceOnUse",
    x1: 2245.2283,
    y1: 2311.9873,
    x2: 2304.6895,
    y2: 2188.916,
    gradientTransform: "matrix(1 -6.000000e-04 6.000000e-04 1 -1.8682 1.9237)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000130636638850233566420000002546254567835066503_)"
    },
    d: "M2242.593,2229.845l14.629,66.622 c2.04,2.981,22.815,10.095,37.36-0.023l-5.405-66.628L2242.593,2229.845z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000055686572153279220100000005372885436814605209_",
    gradientUnits: "userSpaceOnUse",
    x1: 1874.1699,
    y1: 2229.6118,
    x2: 2072.4619,
    y2: 1364.7189,
    gradientTransform: "matrix(0.9989 0.0458 -0.0458 0.9989 154.7604 -56.8246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000055686572153279220100000005372885436814605209_)"
    },
    d: "M2210.911,1311.381 c-43.153-57.044-174.347-21.08-188.992-16.909c-15.709,26.555-35.414,63.412-54.063,109.134 c46.499-9.174,66.689-0.885,76.1,10.138c36.535,42.786-77.713,137.379-54.119,280.793 c9.228,56.091,33.237,81.323,28.889,149.836c-3.234,50.988-19.056,76.804-29.981,114.137 c-6.556,22.401-11.627,49.943-11.848,83.225c32.921,72.252,76.172,140.968,103.386,177.188 c22.443-9.403,35.649-24.135,58.092-33.536c-3.379-12.213-13.813-52.546-20.38-76.569c-5.089-18.612-14.471-53.048-16.4-60.408 c-16.157-61.626-3.461-107.885-7.944-184.112c-5.229-88.899-25.591-78.555-22.561-131.929 c4.525-79.698,49.672-98.333,101.445-213.727C2207.976,1439.661,2245.196,1356.704,2210.911,1311.381z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000167373581324199626580000012167493777655675815_",
    gradientUnits: "userSpaceOnUse",
    x1: 2154.2258,
    y1: 1881.1899,
    x2: 2504.5105,
    y2: 1328.9762,
    gradientTransform: "matrix(1 -6.000000e-04 6.000000e-04 1 -1.8682 1.9237)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000167373581324199626580000012167493777655675815_)"
    },
    d: "M2124.421,1329.424 c-3.61,148.67,2.104,320.933,26.686,510.8c20.011,154.571,49.06,294.024,81.037,416.368 c4.414,2.489,19.894,10.496,39.712,6.729c14.033-2.665,23.419-9.939,27.594-13.636c-3.497-24.994-7.049-62.814-4.188-108.521 c4.916-78.568,23.405-94.585,31.293-175.896c6.918-71.302-0.454-129.543-4.026-156.549 c-10.997-83.122-25.857-84.823-26.183-134.606c-0.502-76.661,34.531-104.134,53.755-177.186 c12.824-48.732,19.594-121.478-12.793-221.209C2266.347,1293.619,2195.385,1311.524,2124.421,1329.424z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168080085541470176370000001385609492821305740_",
    gradientUnits: "userSpaceOnUse",
    x1: 1891.0676,
    y1: 673.517,
    x2: 2004.8787,
    y2: 1077.1898,
    gradientTransform: "matrix(1 -6.000000e-04 6.000000e-04 1 -1.8682 1.9237)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168080085541470176370000001385609492821305740_)"
    },
    d: "M2048.2,736.289 c-26.055,14.653-62.244,38.924-95.965,77.589c-77.772,89.173-125.812,235.859-75.76,283.811 c34.052,32.623,114.76,22.684,142.539-16.076c20.431-28.508,5.69-63.498-1.403-113.238 C2009.98,914.853,2010.205,837.227,2048.2,736.289z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106868156033079682620000000283860907136480131_",
    gradientUnits: "userSpaceOnUse",
    x1: 2087.6248,
    y1: 618.9402,
    x2: 2311.1646,
    y2: 1411.807,
    gradientTransform: "matrix(1 -6.000000e-04 6.000000e-04 1 -1.8682 1.9237)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106868156033079682620000000283860907136480131_)"
    },
    d: "M2350.778,1311.566 c-29.053-379.836-121.03-535.276-113.028-581.44c-11.568-8.306-57.263-21.493-160.755-7.805 c-8.843,3.254-32.447,12.797-55.833,34.202c0,0-5.436,4.963-12.87,13.682c72.719,13.685,146.81,55.042,173.508,113.681 c46.254,112.134-39.439,237.545,0.209,336.488c20.836,51.995,54.145,98.072,93.903,141.144 C2321.331,1350.16,2352.452,1333.459,2350.778,1311.566z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142887014370654220050000006251675717561711019_",
    gradientUnits: "userSpaceOnUse",
    x1: 2199.3479,
    y1: 1909.8113,
    x2: 2549.6321,
    y2: 1357.5981,
    gradientTransform: "matrix(1 -6.000000e-04 6.000000e-04 1 -1.8682 1.9237)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000142887014370654220050000006251675717561711019_)"
    },
    d: "M2337.309,1275.718 c-20.773,5.241-41.547,10.482-62.319,15.723c10.888,37.429,21.36,93.604,8.854,157.394 c-17.27,88.087-62.032,107.439-68.568,186.866c-5.88,71.454,27.861,86.005,44.071,181.298 c16.611,97.655-8.409,143.602-13.597,225.29c-3.551,55.906,2.314,129.039,36.384,218.027 c8.401-3.329,14.266-7.928,17.319-10.631c-3.497-24.994-7.049-62.814-4.188-108.521c4.916-78.568,23.405-94.585,31.293-175.896 c6.918-71.302-0.454-129.543-4.026-156.549c-10.997-83.122-25.857-84.823-26.183-134.606 c-0.502-76.661,34.531-104.134,53.755-177.186C2362.925,1448.195,2369.696,1375.449,2337.309,1275.718z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000017514362856698526290000013049695517354677175_",
    gradientUnits: "userSpaceOnUse",
    x1: 1959.1122,
    y1: 545.5446,
    x2: 2182.6577,
    y2: 1338.4315,
    gradientTransform: "matrix(1 -6.000000e-04 6.000000e-04 1 -1.8682 1.9237)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000017514362856698526290000013049695517354677175_)"
    },
    d: "M2021.161,756.524 c0,0-27.523,25.076-43.557,61.901c-24.157,55.479,1.925,103.076,9.797,193.646c8.633,99.352-3.389,264.878-31.306,324.192 c-0.486,1.033-1.695,3.982-1.199,7.72c7.592,57.306,401.733,44.073,395.883-32.417 c-29.053-379.836-121.03-535.276-113.028-581.439c-11.568-8.307-57.263-21.494-160.755-7.806 C2068.152,725.575,2044.548,735.119,2021.161,756.524z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000073685745402027738300000017807061773817921426_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.5077,
    y1: 1024.4038,
    x2: 61.6456,
    y2: 834.2746,
    gradientTransform: "matrix(-0.9168 0.3994 0.3994 0.9168 1805.4456 -183.7369)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000073685745402027738300000017807061773817921426_)"
    },
    d: "M2138.24,626.896 c0,0,25.504,79.878,33.752,89.486c8.249,9.609-33.064,34.764-64.752,23.453c-29.099-10.386-0.011-54.746-0.011-54.746 L2138.24,626.896z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132776581275167531470000016533322536030416795_",
    gradientUnits: "userSpaceOnUse",
    x1: 1381.2811,
    y1: 1080.7159,
    x2: 1291.4261,
    y2: 852.5009,
    gradientTransform: "matrix(0.8671 -0.4981 0.4981 0.8671 499.0904 498.4206)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6B3976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132776581275167531470000016533322536030416795_)"
    },
    d: "M2037.782,670.427 c-17.163-7.261-30.795-29.404-27.859-50.097c2.527-17.805,16.649-28.319,25.101-34.615 c24.495-18.247,63.972-26.483,89.495-8.997c15.124,10.363,17.597,48.673,18.383,55.361c0.887,7.566-2.659,12.392-4.4,19.51 c-2.413,9.87-6.099,25.476-11.879,51.353c-4.094-4.275-9.5-9.37-16.29-14.357c-2.611-1.918-12.944-9.341-24.595-13.708 C2062.385,666.121,2054.051,677.311,2037.782,670.427z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000140698306675296905030000017252507468576397721_",
    gradientUnits: "userSpaceOnUse",
    x1: 152.7303,
    y1: 876.4445,
    x2: 148.5982,
    y2: 1209.3595,
    gradientTransform: "matrix(-0.8959 0.4442 0.4442 0.8959 1832.2819 -209.0738)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000140698306675296905030000017252507468576397721_)"
    },
    d: "M2140.592,675.903 c0,0-0.852,38.315-36.509,55.991c-31.926,15.826-76.412-50.554-65.247-76.583c3.726-8.683,15.68-18.319,28.09-21.515 c7.329-1.888,10.983-0.505,22.899-3.82c10.992-3.059,13.077-5.682,17.367-4.927c5.369,0.946,12.325,6.859,17.989,30.518 c2.426-9.344,8.148-15.709,14.506-16.244c1.014-0.085,3.961,0.128,6.411,1.617 C2154.966,646.328,2153.601,660.562,2140.592,675.903z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145772102248320494910000010202871549187013031_",
    gradientUnits: "userSpaceOnUse",
    x1: 1353.8396,
    y1: 1091.6523,
    x2: 1263.8855,
    y2: 863.1854,
    gradientTransform: "matrix(0.8671 -0.4981 0.4981 0.8671 499.0904 498.4206)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6B3976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145772102248320494910000010202871549187013031_)"
    },
    d: "M2106.193,620.114 c-0.842,1.967,6.901,4.877,11.779,12.513c9.47,14.827,4.655,42.001-10.151,52.651c-8.755,6.295-14.549,2.177-30.836,9.45 c-10.084,4.503-17.294,10.294-21.641,14.266c4.843,19.473,19.019,33.474,34.637,34.728 c16.819,1.35,29.229-12.572,34.419-18.394c3.473-3.896,14.612-16.347,14.491-33.11c-0.128-17.468-12.056-21.127-8.62-34.983 c1.734-6.99,6.297-12.226,6.809-24.108c0.138-3.228-0.067-5.894-0.265-7.651 C2124.002,621.666,2107.413,617.268,2106.193,620.114z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103250949321794328360000016484298443740785842_",
    gradientUnits: "userSpaceOnUse",
    x1: 1265.8051,
    y1: 953.9998,
    x2: 1270.4819,
    y2: 995.6942,
    gradientTransform: "matrix(0.8671 -0.4981 0.4981 0.8671 499.0904 498.4206)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103250949321794328360000016484298443740785842_)"
    },
    d: "M2070.097,708.706 c0,0,8.657-0.381,19.764-7.679c0.541-0.356,1.251-0.548,1.489-0.3c0.896,0.935-3.641,10.088-11.533,12.113 c-5.605,1.438-11.999-0.951-12.023-2.487C2067.785,709.704,2068.915,709.135,2070.097,708.706z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049929766697519526670000002349476100603814327_",
    gradientUnits: "userSpaceOnUse",
    x1: 1983.251,
    y1: 538.7355,
    x2: 2206.7979,
    y2: 1331.627,
    gradientTransform: "matrix(1 -6.000000e-04 6.000000e-04 1 -1.8682 1.9237)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000049929766697519526670000002349476100603814327_)"
    },
    d: "M2239.432,976.231 c-43.003,15.128-100.051,57.597-103.844,111.972c-5.828,83.513,118.564,129.256,102.031,187.78 c-4.508,15.957-18.784,30.356-111.867,64.017c-37.665,13.621-72.657,24.732-104.427,33.927 c113.937,16.721,333.833-5.083,329.453-62.36c-11.122-145.406-31.466-257.83-51.891-343.927 C2278.246,966.841,2258.18,969.635,2239.432,976.231z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000112621884089401993760000007172812989793433272_",
    gradientUnits: "userSpaceOnUse",
    x1: 2663.522,
    y1: 189.5317,
    x2: 2827.3538,
    y2: 770.6218,
    gradientTransform: "matrix(0.9426 0.3339 -0.3339 0.9426 -133.1304 -483.1728)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000112621884089401993760000007172812989793433272_)"
    },
    d: "M2104.12,1147.179 c70.008,70.984,169.906,93.296,246.678,57.715c106.615-49.413,123.021-189.34,98.101-276.891 c-41.605-146.164-222.578-231.303-279.55-192.324c-41.201,28.188-40.74,137.154,8.416,191.666 c44.186,48.999,111.999,36.572,130.475,86.507c13.84,37.402-12.833,75.114-15.125,78.254 c-29.67,40.669-94.375,54.503-155.596,26.625C2126.385,1128.214,2115.253,1137.697,2104.12,1147.179z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096741375253364168950000009141820802603426208_",
    gradientUnits: "userSpaceOnUse",
    x1: 2008.1991,
    y1: 1097.7489,
    x2: 2013.2537,
    y2: 963.1135,
    gradientTransform: "matrix(1 -6.000000e-04 6.000000e-04 1 -1.8682 1.9237)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096741375253364168950000009141820802603426208_)"
    },
    d: "M1965.52,1024.855 c5.686-18.305,24.189-27.694,38.75-29.731c14.253-1.995,37.741,1.23,47.104,19.858c8.757,17.42,1.895,41.808-18.203,55.039 c-2.834-7.019-7.91-16.252-16.842-19.048c-16.428-5.142-30.649,16.268-42.789,10.685 C1963.865,1057.208,1961.347,1038.289,1965.52,1024.855z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000171711011570601657330000014904679991822544037_",
    gradientUnits: "userSpaceOnUse",
    x1: 1950.9629,
    y1: 918.9902,
    x2: 2096.4563,
    y2: 1146.387,
    gradientTransform: "matrix(1 -6.000000e-04 6.000000e-04 1 -1.8682 1.9237)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000171711011570601657330000014904679991822544037_)"
    },
    d: "M2032.771,1135.748l53.846,9.327 c10.431,1.807,19.379-7.515,17.147-17.864l-19.644-91.069c-1.422-6.589-7.08-11.408-13.81-11.765l-64.464-3.408 c-10.638-0.562-18.428,9.876-14.86,19.914l30.261,85.152C2023.054,1131.116,2027.458,1134.829,2032.771,1135.748z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124129853970529702210000013599881904840117170_",
    gradientUnits: "userSpaceOnUse",
    x1: 2076.0415,
    y1: 1170.4562,
    x2: 2080.3328,
    y2: 1056.1493,
    gradientTransform: "matrix(1 -6.000000e-04 6.000000e-04 1 -1.8682 1.9237)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124129853970529702210000013599881904840117170_)"
    },
    d: "M2126.734,1127.917 c-4.438-31.711-17.812-40.004-22.653-42.359c-8.115-3.949-12.112-0.875-40.436-1.307c-25.303-0.386-31.3-2.977-34.498,1.353 c-6.054,8.202,6.414,29.739,20.537,42.36c19.799,17.695,44.338,19.198,54.436,19.215L2126.734,1127.917z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181055675633572087150000003360489862569848982_",
    gradientUnits: "userSpaceOnUse",
    x1: 1163.8918,
    y1: 3009.5115,
    x2: 1163.8918,
    y2: 2957.23,
    gradientTransform: "matrix(0.935 -0.3546 0.3546 0.935 404.7507 210.5589)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A03976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000181055675633572087150000003360489862569848982_)"
    },
    d: "M2529.708,2571.756 c0,0,20.855,22.803,22.563,35.777c11.374-4.571,18.235-8.843,18.235-8.843s-9.25-10.5-12.449-16.225 c-4.323-7.737-9.262-21.032-9.262-21.032L2529.708,2571.756z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#26264F"
    },
    d: "M2576.669,2601.446c1.007,0.572,2.892,1.848,3.888,4.168c0.542,1.26,0.649,2.425,0.648,3.534 c-0.003,5.479-2.623,7.195-3.78,13.446c-0.706,3.819,0.004,4.621-1.191,6.677c-1.575,2.71-4.288,3.859-6.664,4.792 c-4.014,1.575-9.875,3.632-17.515,5.533c1.959-6.389,4.13-12.949,6.542-19.655c1.057-2.941,2.132-5.829,3.22-8.664 l9.819-8.076C2573.315,2602.617,2574.992,2602.032,2576.669,2601.446z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444B8C"
    },
    d: "M2559.354,2589.251c3.065-1.108,6.218,0.469,10.118,5.672c3.901,5.203,13.95,7.304,4.044,9.646 c-9.906,2.344-11.689,18.311-13.185,24.532c-1.496,6.222-8.878,14.045-10.486,9.129c-1.607-4.916,1.529-8.687,0.778-14.056 C2549.873,2618.804,2552.366,2591.777,2559.354,2589.251z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#26264F"
    },
    d: "M2231.084,2659.867c0.657,0.793,1.823,2.449,1.921,4.695c0.052,1.22-0.226,2.223-0.577,3.145 c-1.732,4.558-4.452,5.159-7.388,9.995c-1.792,2.955-1.454,3.846-3.098,5.181c-2.166,1.758-4.785,1.858-7.056,1.884 c-3.837,0.044-9.363-0.094-16.32-0.922c3.645-4.698,7.522-9.472,11.645-14.29c1.808-2.113,3.614-4.178,5.414-6.192 l10.718-3.622C2227.925,2659.783,2229.504,2659.826,2231.084,2659.867z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000086681509983028838060000017187415216810042538_",
    gradientUnits: "userSpaceOnUse",
    x1: 1296.551,
    y1: 2656.2324,
    x2: 1296.551,
    y2: 2600.165,
    gradientTransform: "matrix(1 0 0 1 917.4274 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A03976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000086681509983028838060000017187415216810042538_)"
    },
    d: "M2222.171,2607.829 c0,0-6.126,31.967,1.67,40.919c6.64,8.951-3.208,2.566-3.208,2.566l-11.761,10.265l-7.057,12.189 c0,0,6.497-31.289,4.763-43.705c-1.732-12.416-2.598-20.79-2.598-20.79L2222.171,2607.829z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444B8C"
    },
    d: "M2220.527,2644.257c2.898,0.046,5.025,2.352,6.629,7.912c1.604,5.559,9.302,10.479,0.32,9.302 c-8.981-1.176-15.504,11.548-18.711,16.252c-3.208,4.705-11.819,8.885-11.605,4.287c0.214-4.597,4.014-6.746,5.083-11.451 C2203.312,2665.855,2213.915,2644.153,2220.527,2644.257z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#26264F"
    },
    d: "M2028.934,1638.933c-3.364,44.133-6.484,103.087-6.193,172.652 c0.296,70.949,1.159,173.837,22.925,300.89c15.806,92.267,35.689,156.726,67.342,259.339 c31.538,102.242,62.904,186.773,87.402,248.595c0.958,0.779,5.344,4.167,11.462,3.58c8.667-0.831,12.677-8.856,12.896-9.314 c2.313-56.029,4.87-128.783,6.957-218.179c0.003-0.108,0.154-6.653,0.206-8.921c2.271-98.386,4.652-201.502,5.732-240.713 c1.5-54.491,4.554-133.378,11.462-234.982c16.045,35.319,39.361,89.596,63.044,157.609 c28.129,80.781,42.596,140.221,48.716,163.34c20.57,77.708,65.176,192.148,172.551,346.511 c1.657,0.359,5.638,0.976,10.001-0.845c7.355-3.069,9.556-10.459,9.842-11.482c-0.905-74.847-5.457-174.524-20.456-291.199 c-18.06-140.484-42.519-237.559-60.178-306.621c-9.614-37.597-55.298-212.797-117.491-286.564 c-48.24-57.217-108.136-91.769-108.136-91.769C2240.499,1586.776,2218.381,1573.154,2028.934,1638.933z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000149351151798754165140000016424112635525105044_",
    gradientUnits: "userSpaceOnUse",
    x1: 1277.9696,
    y1: 827.9897,
    x2: 1512.9497,
    y2: 1263.5625
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A03976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000149351151798754165140000016424112635525105044_)"
    },
    d: "M1515.749,1268.776 c-5.92-2.204-15.024-6.145-24.912-12.991c-11.535-7.986-33.6-26.901-29.364-36.357c2.821-6.299,16.719-6.135,44.515-5.806 c3.462,0.041,5.163,0.142,7.258,0.967c14.902,5.876,15.601,34.978,15.61,43.244 C1524.605,1261.636,1519.866,1264.818,1515.749,1268.776z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124120318447900565110000003835138143717990029_",
    gradientUnits: "userSpaceOnUse",
    x1: 1279.7313,
    y1: 756.5948,
    x2: 2460.3704,
    y2: 2101.5293
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124120318447900565110000003835138143717990029_)"
    },
    d: "M1900.9,1161.698 c-47.369-16.852-126.82,140.211-203.409,119.744c-31.486-8.415-40.47-40.951-88.834-50.148 c-28.214-5.366-53.158,0.383-69.554,5.914c-11.432,11.4-23.547,22.4-34.906,35.089c4.833,22.615,19.123,74.356,64.341,119.472 c20.574,20.528,66.42,66.27,123.222,63.044c48.24-2.74,62.001-38.39,159.043-96c31.512-18.707,58.652-31.921,76.827-40.226 C1935.576,1199.464,1918.448,1167.941,1900.9,1161.698z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000092453342057440520830000013548936061023263673_",
    gradientUnits: "userSpaceOnUse",
    x1: 1388.1021,
    y1: 661.4621,
    x2: 2568.74,
    y2: 2006.3953
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000092453342057440520830000013548936061023263673_)"
    },
    d: "M1957.043,1128.871 c-24.382,8.565-91.076,32.782-113.876,94.045c-11.837,31.807,7.798,35.013,4.77,121.569 c-0.876,25.053-2.816,37.547,5.732,51.582c15.664,25.72,44.645,20.643,68.775,40.119 c31.085,25.089,28.975,70.631,31.521,106.028c3.488,48.474,18.563,117.599,71.641,203.46 c14.641,10.711,36.839,27.353,63.044,48.716c68.959,56.215,97.68,93.264,117.491,106.03 c146.689,94.523,434.887-52.778,426.978-94.567c-4.358-23.033-94.476,8.104-159.676-55.595 c-30.227-29.529-50.787-68.288-88.034-150.049c-28.18-61.859-29.987-80.398-56.047-126.769 c-25.566-45.495-52.727-79.071-71.64-100.296c7.066-33.404,2.317-56.867-2.865-71.641 c-19.189-54.704-67.399-56.077-138.998-137.99c-17.698-20.247-22.155-27.923-37.11-36.886 C2064.27,1117.949,2030.028,1103.231,1957.043,1128.871z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080193952940607873120000002978153536203292089_",
    gradientUnits: "userSpaceOnUse",
    x1: 1947.4332,
    y1: 1281.897,
    x2: 1945.5228,
    y2: 1062.1997
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A03976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080193952940607873120000002978153536203292089_)"
    },
    d: "M1898.578,1096.066 c-4.269-3.694-15.588-14.452-19.261-32.102c-3.958-19.021,1.583-42.966,11.604-45.205c3.273-0.732,6.257,1.023,8.15,2.217 c21.519,13.575,41.396,39.962,52.818,63.348c5.965,12.212,13.044,19.148,19.62,23.334c9.75,6.207,14.818,6.013,21.219,9.852 c19.453,11.668,29.358,53.234,12.341,70.799c-16.292,16.815-49.182,3.302-71.164-5.732c-6.484-2.663-32.913-13.524-32-25.313 c0.325-4.199,3.936-6.163,17.194-18.149c7.603-6.874,13.58-12.706,17.408-16.523c-0.873-1.906-1.592-4.633-3.82-6.533 c-2.477-2.11-5.335-4.228-6.114-6.584C1920.399,1108.287,1909.096,1105.167,1898.578,1096.066z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000051374104944792505510000009213158448655636884_",
    gradientUnits: "userSpaceOnUse",
    x1: 1452.3506,
    y1: 614.3055,
    x2: 2628.1265,
    y2: 1953.7001
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.25,
      fill: "url(#SVGID_00000051374104944792505510000009213158448655636884_)"
    },
    d: "M2060.129,1544.173 c66.181,71.19,108.492,24.964,202.999,108.75c74.879,66.382,71.089,115.447,137.516,158.563 c67.082,43.542,145.216,41.708,198.236,34.341c22.944-16.01,36.009-30.631,34.24-39.976 c-4.358-23.033-94.476,8.106-159.676-55.594c-30.227-29.529-50.787-68.289-88.034-150.049 c-28.181-61.858-29.987-80.398-56.046-126.769c-25.568-45.495-52.728-79.072-71.641-100.295 c7.066-33.404,2.317-56.867-2.865-71.643c-19.189-54.703-67.399-56.076-138.999-137.989 c-17.697-20.247-22.154-27.923-37.109-36.885c-18.685-11.197-66.221-19.377-121.706,2.244 c-31.933,12.443-61.77,24.071-68.107,48.361c-7.838,30.042,25.504,59.412,49.581,86.999 C2036.524,1376.528,1977.737,1455.545,2060.129,1544.173z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182509100902421700070000000291521674156327812_",
    gradientUnits: "userSpaceOnUse",
    x1: 1887.7725,
    y1: 729.6058,
    x2: 2368.6333,
    y2: 1392.8624
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6B3976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000182509100902421700070000000291521674156327812_)"
    },
    d: "M1934.529,1076.147 c-5.285-9.799-12.419-17.967-12.419-17.967c-3.572-4.145-6.087-6.354-6.087-6.354c-13.658-13.327-20.62-12.608-28.553-22.736 c-12.839-16.393-10.133-38.098-9.517-42.302c3.58-24.454,21.638-38.621,31.725-46.532c4.84-3.796,16.102-12.454,32.783-16.92 c14.86-3.977,34.588-5.639,74.025,7.404c47.89,15.84,80.807,38.623,84.601,41.242 c99.886,68.954,103.884,81.975,136.577,100.268c101.803,56.967,165.894-11.73,229.25,40.119 c62.03,50.765,56.534,162.168,37.253,226.385c-7.286,24.266-43.001,130.667-140.416,166.207 c-132.046,48.173-271.197-72.619-331.03-153.218c-41.329-55.673-59.158-111.493-67.524-147.107 C1965.197,1204.637,1957.943,1119.562,1934.529,1076.147z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121280610521867819330000008676240919177131687_",
    gradientUnits: "userSpaceOnUse",
    x1: 1930.9021,
    y1: 1282.0431,
    x2: 1928.9917,
    y2: 1062.3428
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A03976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121280610521867819330000008676240919177131687_)"
    },
    d: "M1918.913,1050.05 c1.763-7.723,14.415-7.384,18.665,1.396c4.251,8.78,3.442,23.453-7.884,25.875 C1918.366,1079.743,1916.542,1060.442,1918.913,1050.05z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116914943787317093630000000590384345524208261_",
    gradientUnits: "userSpaceOnUse",
    x1: 2700.6614,
    y1: 285.0602,
    x2: 2476.9971,
    y2: 253.2345,
    gradientTransform: "matrix(0.4865 0.8737 -0.764 0.6768 938.419 -506.4655)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000116914943787317093630000000590384345524208261_)"
    },
    points: "1877.613,1780.884  1883.965,1759.686 2006.781,1837.161 2019.041,1871.86 1924.483,1827.021  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065795255227190774250000000070955916900816551_",
    gradientUnits: "userSpaceOnUse",
    x1: 2359.0881,
    y1: 89.0468,
    x2: 2353.7839,
    y2: 614.1772,
    gradientTransform: "matrix(0.4865 0.8737 -0.8737 0.4865 1020.7476 -363.0768)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000065795255227190774250000000070955916900816551_)"
    },
    points: "1883.965,1759.686  1641.534,1945.604 1657.774,2070.776 1846.588,1882.759 1894.841,1784.653  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000140001024352576884630000017207542630342973365_",
    gradientUnits: "userSpaceOnUse",
    x1: 2405.4907,
    y1: 420.48,
    x2: 2690.5403,
    y2: 420.48,
    gradientTransform: "matrix(0.4865 0.8737 -0.764 0.6768 938.419 -506.4655)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000140001024352576884630000017207542630342973365_)"
    },
    d: "M1894.841,1784.653 c41.401,29.069,82.8,58.138,124.2,87.207c-50.582,117.469-79.099,172.077-129.682,289.546 c-77.117-7.655-165.614-33.732-231.585-90.629C1732.928,1981.135,1819.686,1874.294,1894.841,1784.653z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057837744121224016710000017122598143681204636_",
    gradientUnits: "userSpaceOnUse",
    x1: 2690.4829,
    y1: 918.453,
    x2: 2457.6685,
    y2: 885.3252,
    gradientTransform: "matrix(0.7861 0.6181 -0.6181 0.7861 597.2126 -365.1764)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB316D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#792D3D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000057837744121224016710000017122598143681204636_)"
    },
    points: "1885.824,1827.152  1886.295,1806.453 2048.062,1841.157 2072.655,1868.687 1952.748,1855.186  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155121563048946518120000010851673756674777225_",
    gradientUnits: "userSpaceOnUse",
    x1: 2332.6409,
    y1: 1092.5403,
    x2: 2443.9919,
    y2: 1092.5403,
    gradientTransform: "matrix(0.7861 0.6181 -0.6181 0.7861 597.2126 -365.1764)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB316D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#792D3D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000155121563048946518120000010851673756674777225_)"
    },
    points: "1886.295,1806.453  1673.124,2040.371 1730.514,2147.532 1883.002,1926.776 1906.292,1825.686  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176032234896063309360000003176728502843946645_",
    gradientUnits: "userSpaceOnUse",
    x1: 2383.2368,
    y1: 1059.407,
    x2: 2704.8735,
    y2: 1059.407,
    gradientTransform: "matrix(0.7861 0.6181 -0.6181 0.7861 597.2126 -365.1764)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB316D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#792D3D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176032234896063309360000003176728502843946645_)"
    },
    d: "M1906.292,1825.686 c55.455,14.333,110.909,28.668,166.364,43.002c-19.831,119.026-35.314,216.888-55.146,335.915 c-91.681-32.28-195.314-24.791-286.995-57.07C1786.573,2046.452,1850.234,1926.766,1906.292,1825.686z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031930221461332773560000006420182926101080221_",
    gradientUnits: "userSpaceOnUse",
    x1: 2760.8538,
    y1: 2615.1506,
    x2: 2304.8298,
    y2: 1898.5417,
    gradientTransform: "matrix(0.9987 -0.051 0.051 0.9987 -34.699 48.3914)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40447E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#1C2C5A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031930221461332773560000006420182926101080221_)"
    },
    d: "M2431.857,1641.691 c-70.831,13.237-96.02,145-111.521,226.086c-17.453,91.299-36.898,193.011,12.025,291.327 c61.536,123.664,208.843,196.945,373.635,198.433c-0.547-10.705-1.094-21.411-1.64-32.116 c-160.383-82.045-198.28-158.779-204.072-212.822c-12.318-114.927,115.553-173.974,97.772-299.085 C2584.659,1719.24,2494.575,1629.969,2431.857,1641.691z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#26264F"
    },
    d: "M2516.454,956.355c7.057,7.641-1,19.71,1.354,60.358c1.076,18.593,3.8,33.994,6.189,44.888 c1.385,9.935,2.907,19.124,4.532,27.211c1.191,5.934,2.287,10.554,3.666,15.448c2.552,9.081,5.788,18.013,9.614,26.55 c0.255,0.565,0.031,1.222-0.5,1.518c-0.031,0.017-0.064,0.033-0.098,0.048c-0.597,0.269-1.297,0.002-1.566-0.596 c-3.874-8.641-7.15-17.683-9.736-26.875c-1.394-4.956-2.503-9.631-3.707-15.626c-0.856-4.263-1.682-8.847-2.476-13.658 c-0.003,12.889,1.185,27.005,7.669,45.347c19.676,55.667-20.745,97.838-55.515,102.969 c-40.098,5.916-70.709-23.173-80.236-32.743c-38.396-38.574-52.056-106.504-25.247-159.999 C2405.517,961.116,2499.159,937.627,2516.454,956.355z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000136403589841729939350000003724488568082888335_",
    gradientUnits: "userSpaceOnUse",
    x1: 2095.8677,
    y1: 2208.3628,
    x2: 2211.636,
    y2: 2600.6882,
    gradientTransform: "matrix(0.9747 -0.2234 0.2234 0.9747 -142.7808 225.0487)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40447E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3C3B6B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000136403589841729939350000003724488568082888335_)"
    },
    d: "M2642.58,1757.5 c-39.706-53.577-78.496-107.832-117.372-162.014c-7.639-10.646-12.333-23.171-14.892-36.418 c-14.031,12.125-27.354,26.496-39.487,43.163c-29.319,129.767-54.9,302.004-49.926,505.892 c3.104,127.235,47.914,510.508,65.826,606.546c5.126,0.83,6.417-12.478,11.66-11.704c6.397,0.945,8.486,12.401,14.728,13.214 c10.297-195.906,24.105-372.91,31.006-463.867c2.34-30.861,9.188-123.43,55.408-199.697 c0.744-1.227,69.555-104.082,93.071-145.008c7.829-13.625,17.597-31.285,28.555-54.813 C2691.637,1824.258,2667.554,1791.198,2642.58,1757.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005255626679946234050000008465619243165253794_",
    gradientUnits: "userSpaceOnUse",
    x1: 2010.1077,
    y1: 2836.8101,
    x2: 2002.4631,
    y2: 3214.3401,
    gradientTransform: "matrix(0.9747 -0.2234 0.2234 0.9747 -142.7808 225.0487)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB316D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#792D3D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005255626679946234050000008465619243165253794_)"
    },
    d: "M2510.039,2610.341 c-3.137-6.482-18.2,10.768-32.146,28.904c2.946,25.142,5.891,50.282,8.837,75.424c-5.35-3.096-12.073-6.442-19.557-7.843 c-8.993-1.68-24.255,2.169-25.26,6.478c-6.201,26.588,59.579,29.584,66.415,21.027c6.838-8.558,4.79-18.152,4.79-18.152 c-8.236-37.594-8.428-63.281-6.015-81.124C2508.798,2622.522,2511.771,2613.919,2510.039,2610.341z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035505076467591692190000005562872368196597127_",
    gradientUnits: "userSpaceOnUse",
    x1: 2050.0007,
    y1: 2837.0662,
    x2: 2042.3069,
    y2: 3217.0361,
    gradientTransform: "matrix(0.9747 -0.2234 0.2234 0.9747 -142.7808 225.0487)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB316D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#792D3D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000035505076467591692190000005562872368196597127_)"
    },
    d: "M2486.73,2714.668 c5.126,0.83,6.417-12.479,11.661-11.704c6.396,0.945,8.486,12.401,14.727,13.214c3.764-71.61,7.997-140.668,12.191-203.949 c-22.187-1.665-44.64-1.386-66.771-0.716C2469.308,2600.746,2479.947,2678.303,2486.73,2714.668z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047052787243038324430000012602381684714599580_",
    gradientUnits: "userSpaceOnUse",
    x1: 2419.1775,
    y1: 1198.6392,
    x2: 2955.1238,
    y2: 1198.6392
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6B3976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047052787243038324430000012602381684714599580_)"
    },
    d: "M2420.297,1021.873 c1.061-6.56,6.16-33.387,28.287-52.168c41.98-35.633,116.986-18.303,162.292,13.841c47.408,33.635,32.07,61.891,79.174,99.812 c51.163,41.189,81.641,17.728,150.73,55.475c27.177,14.848,100.415,54.863,112.596,127.861 c10.527,63.078-27.786,131.309-80.185,161.53c-89.703,51.739-215.261-11.05-277.981-74.256 c-60.154-60.622-25.868-80.539-114.888-200.435C2448.137,1110.184,2412.36,1070.895,2420.297,1021.873z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152251829326244531790000000347144437981889462_",
    gradientUnits: "userSpaceOnUse",
    x1: 1463.9662,
    y1: 2104.2712,
    x2: 1589.6085,
    y2: 2104.2712,
    gradientTransform: "matrix(0.901 -0.4338 0.4338 0.901 -206.4194 449.0136)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000152251829326244531790000000347144437981889462_)"
    },
    d: "M2073.21,1665.446l-9.578,6.493 c0,0-18.702,8.063-28.477,15.122c-9.775,7.059-13.311,15.349-7.978,26.425c5.333,11.077,19.505,5.932,31.829,1.613 c7.499-2.627,14.306-13.299,19.026-22.398c3.319-6.397,14.913-16.281,14.913-16.281L2073.21,1665.446z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111188924139639609030000002145043283671838139_",
    gradientUnits: "userSpaceOnUse",
    x1: 1935.5929,
    y1: 1417.7811,
    x2: 2136.6873,
    y2: 1527.7321,
    gradientTransform: "matrix(0.9978 -0.0657 0.0657 0.9978 83.1294 91.664)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111188924139639609030000002145043283671838139_)"
    },
    d: "M2351.88,1235.453 c-60.502,79.29-36.767,121.687-78.199,187.162c-41.07,64.903-81.38,50.087-156.717,139.935 c-28.607,34.118-47.649,65.896-59.396,87.746c2.506,3.729,5.341,7.651,8.542,11.681c2.172,2.734,5.431,6.673,10.739,12.33 c5.106,5.441,13.163,13.596,24.431,23.452c36.784,0.773,98.814-4.154,150.768-46.292c9.459-7.672,15.828-13.458,24.392-23.627 c28.767-34.154,35.003-71.43,98.272-157.618c47.781-65.088,54.888-69.906,63.867-100.917 c22.194-76.656-3.327-168.587-36.256-174.07C2385.144,1192.377,2368.638,1213.491,2351.88,1235.453z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176731502166078907500000017516985280711276718_",
    gradientUnits: "userSpaceOnUse",
    x1: 2498.3542,
    y1: 1226.5001,
    x2: 3186.8813,
    y2: 1662.7939,
    gradientTransform: "matrix(0.9893 0.146 -0.146 0.9893 110.2982 -128.4262)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176731502166078907500000017516985280711276718_)"
    },
    d: "M2371.702,1214.072 c-30.753,38.34-35.671,81.116-36.442,100.085c-2.396,59.01,25.351,104.065,32.004,115.966 c31.435,56.229,34.121,173.201-87.681,438.306c15.251,10.248,72.629,91.851,91.218,47.942 c25.344-59.865,125.655-472.999,38.016,13.35c-1.155,6.408,12.632,3.714,19.204,5.421 c47.115,12.236,102.869,18.924,164.686,11.739c96.886-11.261,167.401-51.8,204.289-76.984 c-32.9-59.037-69.306-139.778-91.691-240.031c-42.701-191.252-11.767-352.264,12.345-439.858 c-32.086-17.595-133.13-67.711-243.324-36.713C2446.87,1161.017,2404.096,1173.687,2371.702,1214.072z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000009576478114091687090000003306727884434817961_",
    gradientUnits: "userSpaceOnUse",
    x1: 3001.676,
    y1: 1995.1836,
    x2: 2778.0088,
    y2: 1963.3573
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000009576478114091687090000003306727884434817961_)"
    },
    points: "2691.915,2003.293  2679.98,1987.379 2822.756,1917.539 2857.676,1923.727 2759.103,1984.727  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088820678663151524720000008544724829639313295_",
    gradientUnits: "userSpaceOnUse",
    x1: 2657.8779,
    y1: 2162.4236,
    x2: 2764.8499,
    y2: 2162.4236
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000088820678663151524720000008544724829639313295_)"
    },
    points: "2679.98,1987.379  2657.878,2290.613 2764.85,2337.468 2748.937,2080.206 2706.502,1990.032  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000027589324448781760090000016077501011191467676_",
    gradientUnits: "userSpaceOnUse",
    x1: 2706.502,
    y1: 2130.5977,
    x2: 3015.4814,
    y2: 2130.5977
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000027589324448781760090000016077501011191467676_)"
    },
    d: "M2706.502,1990.032 c50.391-22.103,100.783-44.203,151.174-66.304c55.696,101.667,102.11,184.769,157.805,286.436 c-88.406,30.058-162.225,97.247-250.632,127.305C2747.168,2227.844,2724.182,2099.655,2706.502,1990.032z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000033364001795276647360000005958142503087827870_",
    gradientUnits: "userSpaceOnUse",
    x1: 2786.1841,
    y1: 1996.5219,
    x2: 2562.5208,
    y2: 1964.6963,
    gradientTransform: "matrix(1 0 0.2196 0.9968 -165.5209 2.6205)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000033364001795276647360000005958142503087827870_)"
    },
    points: "2751.125,2000.836  2735.695,1984.974 2863.132,1915.359 2899.41,1921.527 2814.236,1982.33  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000076598703409974838630000002400972008977016459_",
    gradientUnits: "userSpaceOnUse",
    x1: 2820.2529,
    y1: 1795.4989,
    x2: 2814.949,
    y2: 2320.6311
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000076598703409974838630000002400972008977016459_)"
    },
    points: "2735.695,1984.974  2780.196,2287.229 2897.459,2333.932 2825.04,2077.501 2762.8,1987.618  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060004429356402411790000017923319719898131081_",
    gradientUnits: "userSpaceOnUse",
    x1: 2491.0159,
    y1: 2131.9312,
    x2: 2776.0847,
    y2: 2131.9312,
    gradientTransform: "matrix(1 0 0.2196 0.9968 -165.5209 2.6205)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000060004429356402411790000017923319719898131081_)"
    },
    d: "M2762.8,1987.618 c45.537-22.031,91.074-44.061,136.611-66.091c78.026,101.339,111.864,152.819,189.89,254.158 c-44.203,63.652-110.037,128.287-191.842,158.248C2855.7,2224.662,2804.559,2096.887,2762.8,1987.618z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000177443372282584651990000011113184994299858582_",
    gradientUnits: "userSpaceOnUse",
    x1: 616.8214,
    y1: 1374.5671,
    x2: 629.4448,
    y2: 1038.3207,
    gradientTransform: "matrix(-0.9962 0.0867 0.0867 0.9962 3002.1958 -81.7878)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000177443372282584651990000011113184994299858582_)"
    },
    d: "M2493.345,1080.947 c-7.774,21.001-13.496,46.856-0.92,62.497c7.662,9.529,19.182,14.087,30.531,18.33c26.822,10.029,38.126,3.656,43.958,10.822 c12.835,15.773-11.853,83.597-62.458,94.508c-50.36,10.859-102.211-39.864-96.973-64.101 c4.726-21.869,55.56-20.434,61.755-48.094c3.119-13.925-6.692-28.014-14.992-37.383l-5.944,1.147L2493.345,1080.947z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000128466749253895202600000018273511397972251816_",
    gradientUnits: "userSpaceOnUse",
    x1: 1146.1016,
    y1: 2791.9587,
    x2: 1271.7427,
    y2: 2791.9587,
    gradientTransform: "matrix(0.598 -0.8015 0.8015 0.598 -176.888 1062.0822)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000128466749253895202600000018273511397972251816_)"
    },
    d: "M2768.009,1751.568l-5.486,10.188 c0,0-12.847,15.803-18.246,26.584c-5.399,10.781-4.698,19.766,5.155,27.118c9.854,7.351,20.036-3.767,28.963-13.299 c5.432-5.8,6.528-18.41,6.502-28.66c-0.018-7.207,5.686-21.334,5.686-21.334L2768.009,1751.568z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000131362682618663628860000007919014908652698016_",
    gradientUnits: "userSpaceOnUse",
    x1: 407.2505,
    y1: 1052.45,
    x2: 403.8463,
    y2: 1326.7317,
    gradientTransform: "matrix(-1 -0.0041 -0.0043 1.043 2868.7759 -42.6284)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000131362682618663628860000007919014908652698016_)"
    },
    d: "M2480.461,1102.422 c0,0-2.56,25.722-28.029,25.855c-31.383,0.165-34.865-82.644-27.233-87.375c8.849-5.488,16.59,7.951,37.187,3.265 c8.674-1.974,16.17-13.127,20.566-1.106c5.002,13.676,0.776,37.885,0.776,37.885s7.457-6.147,8.601,1.25 C2493.827,1091.88,2486.563,1097.929,2480.461,1102.422z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#26264F"
    },
    d: "M2430.819,1012.444c-9.96,10.156-15.453,29.862-8.55,39.766 c9.917,14.229,39.247-0.626,51.241,16.78c5.259,7.631,4.953,18.224,7.68,18.051c2.259-0.142,3.593-7.481,4.894-13.519 c7.172-33.289,15.468-37.025,12.939-46.557C2493.885,1007.591,2451.267,991.591,2430.819,1012.444z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137825092019020691040000005282379282188810912_",
    gradientUnits: "userSpaceOnUse",
    x1: 2736.3379,
    y1: 982.3018,
    x2: 3021.0005,
    y2: 1307.8556,
    gradientTransform: "matrix(0.9888 0.1605 -0.1506 1.119 113.7743 -217.9914)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137825092019020691040000005282379282188810912_)"
    },
    d: "M2621.056,1183.416 c35.78-32.601,162.832,58.743,235.873,174.387c23.181,36.702,49.161,78.951,53.926,141.122 c5.563,72.583-21.04,129.95-34.355,158.663c-23.471,50.612-53.004,84.311-72.412,103.461 c-7.979,0.156-17.412-0.297-27.88-2.073c-9.58-1.625-18.006-4.015-25.114-6.527c-10.301-26.143-22.702-66.5-23.3-116.54 c-0.379-31.733,4.219-48.068,10.152-91.503c12.192-89.254,18.288-133.88,10.393-157.649 c-26.01-78.295-121.834-69.614-136.152-147.111C2611.18,1234.195,2604.986,1198.06,2621.056,1183.416z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000159440488489100087320000012881570737957062043_",
    gradientUnits: "userSpaceOnUse",
    x1: 2481.2939,
    y1: 1157.0039,
    x2: 2852.5132,
    y2: 1157.0039
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6B3976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000159440488489100087320000012881570737957062043_)"
    },
    d: "M2482.951,1043.062 c-6.944,7.589,8.289,32.719,39.037,82.671c18.926,30.745,28.389,46.117,34.47,52.763 c32.75,35.787,88.005,63.351,143.886,60.244c38.348-2.132,43.963-16.871,75.395-11.627 c47.419,7.911,74.495,48.101,76.645,45.986c2.375-2.338-28.259-53.779-89.75-96.679c-50.313-35.1-63.994-24.513-143.068-73.125 c-5.737-3.528-30.021-18.557-64.112-35.468C2515.379,1047.946,2489.86,1035.511,2482.951,1043.062z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083777316000015957760000018132108605951507099_",
    gradientUnits: "userSpaceOnUse",
    x1: 2423.7905,
    y1: 2290.5007,
    x2: 2711.0649,
    y2: 2561.6965,
    gradientTransform: "matrix(0.9987 -0.051 0.051 0.9987 -34.699 48.3914)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB316D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#792D3D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083777316000015957760000018132108605951507099_)"
    },
    d: "M2704.356,2325.421 c-39.158-20.032-70.969-39.742-96.84-58.887c-10.534,23.88-17.044,50.316-19.468,77.049 c37.563,8.817,77.218,13.587,117.948,13.955C2705.449,2346.832,2704.903,2336.127,2704.356,2325.421z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093178442528934785870000014088489131137039795_",
    gradientUnits: "userSpaceOnUse",
    x1: 2437.2546,
    y1: 2276.2319,
    x2: 2724.5334,
    y2: 2547.4321,
    gradientTransform: "matrix(0.9987 -0.051 0.051 0.9987 -34.699 48.3914)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB316D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#792D3D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000093178442528934785870000014088489131137039795_)"
    },
    d: "M2700.008,2331.368l4.348-5.947 c0,0,6.991-3.219,9.212,5.254c2.221,8.473,15.225,52.888,14.068,72.267c-5.877,11.033-17.897-0.16-19.744-8.293 c-1.847-8.135-8.035-38.229-8.035-38.229L2700.008,2331.368z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145760808056265828540000003248388821078235274_",
    gradientUnits: "userSpaceOnUse",
    x1: 1388.8104,
    y1: 2636.0876,
    x2: 1461.3861,
    y2: 2411.2456,
    gradientTransform: "matrix(0.997 -0.0771 0.0771 0.997 59.3692 95.2789)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB316D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#792D3D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145760808056265828540000003248388821078235274_)"
    },
    d: "M1653.355,2473.13 c-6.531,38.047-13.063,76.091-19.594,114.136c2.967,4.278,10.193,13.294,21.467,14.474c12.62,1.322,22.791-7.964,26.563-11.797 c3.208-52.748,12.132-89.981,22.477-116.814H1653.355z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178889199992577581400000000676790361730105779_",
    gradientUnits: "userSpaceOnUse",
    x1: 1663.4629,
    y1: 2315.9126,
    x2: 2118.2026,
    y2: 1057.9928
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3E4177"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000178889199992577581400000000676790361730105779_)"
    },
    d: "M1829.314,1495.405 c-52.697,110.649-79.9,271.244-117.117,453.569c-33.43,163.769-50.213,421.431-61.653,535.264 c10.49,7.363,49.404,31.224,53.51,16.153c144.373-530.043,228.147-690.365,258.858-722.227 c18.883-19.592,62.915-61.372,66.502-120.092c0.161-2.649,0.068-5.037-0.119-7.363 C2022.752,1569.434,1866.33,1508.792,1829.314,1495.405z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000014617232016427921370000003508948264895812533_",
    gradientUnits: "userSpaceOnUse",
    x1: 1788.2424,
    y1: 1901.3302,
    x2: 1578.5879,
    y2: 3206.4983
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3E4177"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000014617232016427921370000003508948264895812533_)"
    },
    d: "M1877.1,1514.717 c-20.774-9.261-38.251-15.865-47.786-19.312c-52.697,110.649-79.9,271.244-117.118,453.569 c-33.428,163.769-50.212,421.429-61.652,535.264c2.411,1.692,6.358,4.265,11.001,7.026 c66.219-242.385,50.895-490.701,197.473-717.896C1911.726,1691.909,1898.215,1604.432,1877.1,1514.717z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000066494074832736621630000007985655671794753925_",
    gradientUnits: "userSpaceOnUse",
    x1: 2803.2578,
    y1: 2095.4536,
    x2: 2868.7366,
    y2: 2095.4536,
    gradientTransform: "matrix(0.9913 0.1317 -0.1317 0.9913 -79.4686 -179.8778)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40447E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3C3B6B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000066494074832736621630000007985655671794753925_)"
    },
    d: "M2457.219,2197.509 c10.237-4.26,22.845-3.842,31.19,5.837c16.365,18.976-3.143,59.196-11.632,76.773c-9.633,19.944-28.248,74.896-55.24,63.417 c-12.017-5.11-2.854-41.313,3.382-52.29c7.823-13.77,9.468-29.462,10.827-45.531c0.546-6.461,2.915-15.207,5.371-21.438 C2444.813,2214.906,2446.982,2201.77,2457.219,2197.509z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103250189889338059610000004437426792423415993_",
    gradientUnits: "userSpaceOnUse",
    x1: 2769.5876,
    y1: 2044.3348,
    x2: 2842.0144,
    y2: 2044.3348,
    gradientTransform: "matrix(0.9913 0.1317 -0.1317 0.9913 -79.4686 -179.8778)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB316D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#792D3D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103250189889338059610000004437426792423415993_)"
    },
    d: "M2465.284,2237.858 c-8.875,15.65-39.286-7.877-54.781-14.068c-15.493-6.189-17.874-0.508-10.944-13.105c6.93-12.595,16.04-24.912,32.924-17.434 C2449.368,2200.728,2474.158,2222.207,2465.284,2237.858z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150073264024203586390000014288875265797686166_",
    gradientUnits: "userSpaceOnUse",
    x1: 1945.4208,
    y1: 1915.2905,
    x2: 2506.0381,
    y2: 1915.2905,
    gradientTransform: "matrix(0.9998 0.0217 -0.0217 0.9998 -20.664 -33.3988)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40447E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3C3B6B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150073264024203586390000014288875265797686166_)"
    },
    d: "M1893.282,1660.137 c-0.896,1.463-5.946-0.645-4.688,9.1c8.561,66.231,216.049,465.997,253.391,477.172 c4.255,1.274,215.442,65.654,277.605,96.058c30.555-26.429,14.14-50.479,6.058-60.575 c-22.636-16.502-219.701-128.119-232.945-129.766c-20.165-69.731-9.536-394.45-100.961-427.567 C2073.479,1617.942,1922.906,1611.771,1893.282,1660.137z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000094617306825200952350000007470041494533558146_",
    gradientUnits: "userSpaceOnUse",
    x1: 2141.1257,
    y1: 1263.6471,
    x2: 3006.8447,
    y2: 1812.2207,
    gradientTransform: "matrix(0.9913 0.1317 -0.1317 0.9913 -79.4686 -179.8778)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000094617306825200952350000007470041494533558146_)"
    },
    d: "M1824.134,1071.84 c-20.414,18.662-30.328,37.033-42.98,61.002c-20.064,38.006-31.517,59.698-34.184,88.151 c-5.125,54.701,25.537,99.002,40.535,117.741c21.533,125.561,26.479,154.929,26.451,155.307l-0.057,0.756 c-3.032,13.642-8.665,35.154-19.248,60.101c-27.612,65.091-55.292,74.277-51.892,99.509 c5.962,44.244,98.932,74.365,172.443,76.279c38.962,1.013,43.571-6.649,76.909-8.04 c140.027-5.847,186.918,123.974,280.557,104.687c66.556-13.711,77.26-87.286,161.877-90.851 c29.545-1.245,61.035,6.175,65.195-4.447c4.058-10.359-20.546-31.065-42.033-43.036 c-46.358-25.826-93.196-19.338-113.597-18.836c-91.398,2.244-170.166-102.952-217.429-166.075 c-133.621-178.455-100.103-397.656-92.186-443.163c-11.4-8.197-53.255-36.201-155.293-22.77 C1870.48,1041.358,1847.204,1050.752,1824.134,1071.84z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101816756108132914100000017708993579269265051_",
    gradientUnits: "userSpaceOnUse",
    x1: 1667.1193,
    y1: 1406.7853,
    x2: 2373.0037,
    y2: 1854.0778
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000101816756108132914100000017708993579269265051_)"
    },
    d: "M2171.777,1674.199 c-83.91-61.027-205.962-45.769-259.36-114.424c-44.013-48.015-75.447-106.511-114.092-157.901 c12.452,72.761,15.655,91.863,15.632,92.167l-0.057,0.756c-3.032,13.642-8.665,35.154-19.248,60.101 c-27.612,65.091-55.292,74.277-51.892,99.509c5.963,44.244,98.932,74.365,172.444,76.279 c38.962,1.013,43.571-6.649,76.909-8.04c140.027-5.847,186.918,123.974,280.557,104.687 c66.556-13.711,77.26-87.286,161.877-90.851c29.545-1.245,61.035,6.175,65.195-4.447c4.058-10.359-20.546-31.065-42.033-43.036 c-22.693-12.642-45.481-17.518-65.247-19.167C2318.129,1710.023,2244.953,1731.113,2171.777,1674.199z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145765228601419804720000017146970450368011962_",
    gradientUnits: "userSpaceOnUse",
    x1: 1982.2599,
    y1: 1606.8358,
    x2: 2020.1553,
    y2: 1663.8757
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB316D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#792D3D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145765228601419804720000017146970450368011962_)"
    },
    d: "M1999.363,1570.797 c0,0-50.732,36.346-56.034,64.363c-5.3,28.017,46.19,57.547,62.092,29.53c15.901-28.016,26.503-82.535,26.503-82.535 L1999.363,1570.797z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000125590583419198073790000005747801713643217566_",
    gradientUnits: "userSpaceOnUse",
    x1: 1986.3014,
    y1: 1217.8418,
    x2: 2200.2568,
    y2: 1539.8866
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000125590583419198073790000005747801713643217566_)"
    },
    d: "M1990.276,1078.866 c0,0,19.415-24.676,44.217-17.942c14.31,3.885,25.265,9.404,30.023,13.269c106.752,86.712,160.128,130.066,171.126,152.622 c36.505,74.87,43.255,185.254-9.667,257.913c0,0-20.764,28.508-195.314,119.132l-50.482-28.269 c108.304-99.13,124.125-168.949,116.412-215.626c-16.588-100.385-152.941-159.887-132.918-239.603 C1968.659,1100.52,1981.498,1086.714,1990.276,1078.866z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#26264F"
    },
    d: "M1835.958,953.111c-3.643-0.485-9.528-1.76-15.555-5.584 c-11.513-7.305-15.43-18.689-16.752-22.734c-3.184-9.744-2.071-17.648-0.398-29.516c1.444-10.248,2.166-15.372,5.85-20.474 c5.903-8.175,11.314-5.631,21.271-13.827c13.146-10.821,10.309-20.682,20.209-23.931c6.896-2.263,8.963,2.295,23.665,1.596 c9.356-0.446,9.434-2.336,16.751-2.394c10.566-0.083,13.312,3.833,27.919,7.978c19.147,5.431,22.834,1.086,27.92,6.381 c8.298,8.64-0.247,21.527,8.776,30.313c5.999,5.844,11.482,1.804,17.55,7.978c6.082,6.189,2.044,11.747,7.179,26.855 c4.584,13.49,9.449,13.899,9.573,22.602c0.068,4.824-1.413,5.64-8.377,22.335c-7.272,17.438-6.13,17.685-9.173,21.538 c-6.873,8.705-11.512,5.937-22.733,15.955c-10.763,9.606-10.474,15.703-17.152,16.751c-7.483,1.175-9.591-6.205-20.741-7.179 c-9.769-0.854-12.815,4.404-19.144,2.392c-8.172-2.597-10.191-13.613-13.562-21.538 C1874.433,977.793,1863.657,964.137,1835.958,953.111z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000102510974180650986270000007195671674218078850_",
    gradientUnits: "userSpaceOnUse",
    x1: 1025.6602,
    y1: 1276.6747,
    x2: 1033.8291,
    y2: 1059.083,
    gradientTransform: "matrix(-0.9949 0.1011 0.1011 0.9949 2812.6382 -174.6883)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB316D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#792D3D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000102510974180650986270000007195671674218078850_)"
    },
    d: "M1907.292,946.76 c-9.582,27.085-9.081,52.851,7.341,72.682c14.464,17.465,35.364,15.259,35.976,23.478 c1.209,16.234-93.159,39.617-98.408,27.499c-2.589-5.978,27.24-14.96,29.371-35.308c0.887-8.461-2.154-14.825-19.924-47.678 l-7.604,1.581L1907.292,946.76z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052078157753864827600000014756437350625914021_",
    gradientUnits: "userSpaceOnUse",
    x1: 1898.8348,
    y1: 1035.2656,
    x2: 1849.9084,
    y2: 909.7591
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB316D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#792D3D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052078157753864827600000014756437350625914021_)"
    },
    d: "M1895.139,988.418 c0,0-2.287,26.928-28.91,27.452c-32.805,0.645-37.696-85.867-29.79-90.929c9.168-5.869,17.463,8.062,38.925,2.851 c9.036-2.193,16.705-13.965,21.481-1.466c5.436,14.222,1.385,39.592,1.385,39.592s7.702-6.539,9.01,1.178 C1908.951,977.194,1901.45,983.629,1895.139,988.418z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444B8C"
    },
    d: "M1559.64,2551.494c3.895-6.428,32.814-5.55,47.912,1.289 c25.329,11.472,41.345,34.192,47.82,36.977c14.764,6.351,27.707-1.065,28.944-0.826c0,0,10.955,18.434-5.357,28.972 C1662.646,2628.446,1535.591,2591.177,1559.64,2551.494z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000082347867620984990570000018178608156239050921_",
    gradientUnits: "userSpaceOnUse",
    x1: 1915.4161,
    y1: 1549.0084,
    x2: 2071.9834,
    y2: 2104.3325
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000082347867620984990570000018178608156239050921_)"
    },
    d: "M2185.733,1624.082l-37.672,6.569 c-21.68,3.781-39.676,18.74-47.384,39.352c-31.711,84.804-121.342,307.558-211.401,375.75 c-112.049,84.84-29.695,121.139-29.695,121.139s163.26,52.939,271.044-128.386 C2238.409,1857.18,2185.733,1624.082,2185.733,1624.082z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026131337552805299640000014005365153258023042_",
    gradientUnits: "userSpaceOnUse",
    x1: 2770.1458,
    y1: 2761.9377,
    x2: 2143.5659,
    y2: 1170.5396
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026131337552805299640000014005365153258023042_)"
    },
    d: "M2317.394,1590.017 c53.372-24.029,90.201-1.721,94.355,0c49.875,20.663,144.76,104.683,181.679,189.465 c80.198,184.164,58.756,220.184,32.871,262.606c-37.747,61.862-134.213,74.632-197.65,64.237 c-144.173-23.626-199.515-180.309-205.884-199.297C2181.319,1783.481,2221.494,1633.192,2317.394,1590.017z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031169092351409725550000007293393124215943090_",
    gradientUnits: "userSpaceOnUse",
    x1: 1838.0244,
    y1: 2740.7046,
    x2: 2370.094,
    y2: 3503.4934
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031169092351409725550000007293393124215943090_)"
    },
    d: "M2028.785,2982.628 c-5.952,34.681-11.907,69.361-17.86,104.042c2.705,3.899,9.292,12.119,19.568,13.195c11.504,1.205,20.776-7.26,24.214-10.753 c2.925-48.082,11.059-82.024,20.489-106.483H2028.785z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000906190893750586050000005167702030720925867_",
    gradientUnits: "userSpaceOnUse",
    x1: 2364.9438,
    y1: 1687.6951,
    x2: 2105.9744,
    y2: 2977.8389
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000906190893750586050000005167702030720925867_)"
    },
    d: "M2189.183,2091.371 c-48.036,100.864-72.835,247.254-106.76,413.457c-30.472,149.285-66.558,376.423-76.986,480.188 c9.562,6.712,80.227,34.142,83.969,20.404c131.606-483.167,201.549-670.57,229.542-699.614 c17.214-17.86,49.369-12.628,52.638-66.155c0.147-2.415,0.063-4.593-0.107-6.711 C2365.514,2158.853,2222.926,2103.573,2189.183,2091.371z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122678128346868364220000002503146824341496194_",
    gradientUnits: "userSpaceOnUse",
    x1: 3158.74,
    y1: 2580.6262,
    x2: 3218.4272,
    y2: 2580.6262,
    gradientTransform: "matrix(0.9913 0.1317 -0.1317 0.9913 -79.4686 -179.8778)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40447E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3C3B6B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000122678128346868364220000002503146824341496194_)"
    },
    d: "M2742.723,2731.382 c9.331-3.884,20.823-3.502,28.431,5.319c14.918,17.299-2.865,53.962-10.603,69.984c-8.781,18.181-25.75,68.272-50.355,57.808 c-10.953-4.657-2.6-37.659,3.084-47.665c7.131-12.552,8.63-26.857,9.869-41.505c0.499-5.89,2.657-13.862,4.896-19.542 C2731.414,2747.24,2733.391,2735.265,2742.723,2731.382z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000104694508421819319460000005514962601274814357_",
    gradientUnits: "userSpaceOnUse",
    x1: 2418.7588,
    y1: 2322.4846,
    x2: 2950.8296,
    y2: 3085.2751
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000104694508421819319460000005514962601274814357_)"
    },
    d: "M2750.075,2768.162 c-8.091,14.266-35.813-7.181-49.937-12.823c-14.124-5.642-16.293-0.465-9.976-11.946c6.317-11.482,14.62-22.709,30.012-15.893 C2735.566,2734.316,2758.165,2753.896,2750.075,2768.162z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000042010222434675478730000007761755868495356815_",
    gradientUnits: "userSpaceOnUse",
    x1: 1992.6731,
    y1: 1768.3264,
    x2: 2665.9985,
    y2: 2820.6904
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000042010222434675478730000007761755868495356815_)"
    },
    d: "M2228.659,2241.534 c-0.817,1.334,21.652-1.113,22.8,7.769c7.802,60.374,156.266,435.165,190.303,445.353 c3.881,1.161,210.153,57.821,266.819,85.538c27.854-24.092,19.14-70.057,11.771-79.261 c-20.634-15.042-193.533-113.073-205.607-114.574c-18.382-63.565-21.84-347.067-105.177-377.257 C2392.92,2203.071,2255.663,2197.447,2228.659,2241.534z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000061464906775577950910000001500214288489278378_",
    gradientUnits: "userSpaceOnUse",
    x1: 2250.4658,
    y1: 1901.1573,
    x2: 1992.8141,
    y2: 3184.7356
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000061464906775577950910000001500214288489278378_)"
    },
    d: "M2240.323,2182.152h-85.428 c-27.702,90.292-47.664,201.14-72.472,322.674c-30.472,149.286-66.558,376.423-76.986,480.189 c2.737,1.921,10.491,5.542,20.24,9.407c27.826-79.154,69.389-154.908,98.573-235.973 c29.647-94.87-23.717-207.529,17.789-302.398C2174.765,2366.051,2224.37,2276.047,2240.323,2182.152z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000028324602226301230540000004637782935407266947_",
    gradientUnits: "userSpaceOnUse",
    x1: 2214.605,
    y1: 1483.2069,
    x2: 2461.1965,
    y2: 2357.835
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000028324602226301230540000004637782935407266947_)"
    },
    d: "M2506.075,2246.698 c-31.788-419.024-133.143-590.557-124.285-641.475c-12.756-9.172-63.154-23.751-177.327-8.721 c-9.757,3.584-35.802,14.095-61.614,37.691c0,0-6,5.471-14.207,15.084c80.208,15.147,161.911,60.818,191.322,125.523 c50.947,123.728-43.67,262.013,0,371.187c22.948,57.371,59.661,108.222,103.49,155.763 C2473.564,2289.25,2507.907,2270.849,2506.075,2246.698z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080205978360692176260000008827449109382329518_",
    gradientUnits: "userSpaceOnUse",
    x1: 2072.834,
    y1: 1402.2444,
    x2: 2319.4319,
    y2: 2276.8945
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080205978360692176260000008827449109382329518_)"
    },
    d: "M2142.848,1634.194 c0,0-30.379,27.643-48.091,68.254c-26.687,61.182,2.052,113.707,10.673,213.621c9.457,109.604-3.919,292.189-34.755,357.601 c-0.537,1.139-1.873,4.391-1.328,8.515c8.335,63.22,443.13,48.893,436.728-35.487 c-31.788-419.024-133.143-590.557-124.285-641.475c-12.756-9.172-63.154-23.751-177.327-8.721 C2194.707,1600.086,2168.661,1610.597,2142.848,1634.194z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114790079039470706830000005775988289650950305_",
    gradientUnits: "userSpaceOnUse",
    x1: 2198.7327,
    y1: 1926.1489,
    x2: 2307.1858,
    y2: 2310.8176
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000114790079039470706830000005775988289650950305_)"
    },
    d: "M2232.625,2131.429 c-50.188,0-94.23-32.771-125.616-77.665c-4.014,88.063-16.585,178.013-36.335,219.906c-0.537,1.139-1.873,4.391-1.328,8.515 c8.335,63.221,443.13,48.893,436.728-35.487c-1.749-23.048-3.74-45.217-5.879-66.789 C2417.04,2142.216,2320.698,2125.557,2232.625,2131.429z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444B8C"
    },
    d: "M1929.645,3047.729c4.057-6.695,34.179-5.782,49.906,1.342 c26.383,11.95,43.065,35.615,49.809,38.516c15.378,6.614,28.859-1.111,30.149-0.859c0,0,11.408,19.2-5.582,30.177 C2036.937,3127.882,1904.598,3089.061,1929.645,3047.729z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000084512645066377428400000012662905554242993283_",
    gradientUnits: "userSpaceOnUse",
    x1: -346.3617,
    y1: 1808.3705,
    x2: -337.3423,
    y2: 1568.1229,
    gradientTransform: "matrix(-0.9899 0.1416 0.1416 0.9899 1665.0013 -71.001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB316D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#792D3D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000084512645066377428400000012662905554242993283_)"
    },
    d: "M2275.076,1479.402 c0,0-3.199,81.722,3.926,96.832c7.124,15.11-12.065,37.085-51.577,47.079c-39.513,9.996-12.173-80.764-12.173-80.764 L2275.076,1479.402z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039837885361977069750000005777556794777895814_",
    gradientUnits: "userSpaceOnUse",
    x1: 1846.3306,
    y1: 1866.6351,
    x2: 1727.799,
    y2: 1565.5863,
    gradientTransform: "matrix(0.9794 -0.2019 0.2019 0.9794 178.1296 184.2367)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6B3976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039837885361977069750000005777556794777895814_)"
    },
    d: "M2147.858,1461.665 c-18.507-16.18-26.45-49.549-14.233-74.266c10.511-21.266,32.545-28.612,45.733-33.014 c38.221-12.754,91.083-6.784,115.846,25.658c14.674,19.224,1.966,68.245,0.19,76.949c-2.01,9.847-8.444,14.43-13.563,22.63 c-7.096,11.371-18.154,29.406-36.075,59.442c-3.365-7.046-8.037-15.66-14.487-24.711c-2.48-3.481-12.364-17.046-25.16-27.325 C2180.461,1466.423,2165.402,1477.006,2147.858,1461.665z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003827433409887398090000012114891402142385849_",
    gradientUnits: "userSpaceOnUse",
    x1: -332.0014,
    y1: 1581.9021,
    x2: -337.4522,
    y2: 2021.0697,
    gradientTransform: "matrix(-0.9899 0.1416 0.1416 0.9899 1665.0013 -71.001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB316D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#792D3D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000003827433409887398090000012114891402142385849_)"
    },
    d: "M2274.417,1510.951 c0,0-16.877,47.656-68.848,55.088c-46.532,6.656-74.884-94.871-50.151-122.878c8.25-9.344,27.204-16.483,44.073-15.368 c9.961,0.659,13.969,3.901,30.268,4.664c15.033,0.701,18.729-1.725,23.792,0.993c6.336,3.4,12.612,13.679,9.947,45.661 c6.893-10.708,16.691-16.321,24.877-14.368c1.306,0.311,4.909,1.795,7.365,4.671 C2304.628,1479.825,2297.047,1497.097,2274.417,1510.951z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000100366954798906846180000018024122677732188034_",
    gradientUnits: "userSpaceOnUse",
    x1: 1693.9995,
    y1: 1699.4766,
    x2: 1700.1693,
    y2: 1754.4795,
    gradientTransform: "matrix(0.9794 -0.2019 0.2019 0.9794 178.1296 184.2367)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB316D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#792D3D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000100366954798906846180000018024122677732188034_)"
    },
    d: "M2172.554,1522.963 c0,0,11.002,3.094,27.931-1.467c0.825-0.223,1.794-0.17,1.989,0.239c0.737,1.542-8.725,11.138-19.448,10.418 c-7.615-0.512-14.642-6.143-14.035-8.077C2169.245,1523.257,2170.894,1523.012,2172.554,1522.963z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000007407568873192292150000011134528053953890237_",
    gradientUnits: "userSpaceOnUse",
    x1: 2339.6641,
    y1: 2265.8899,
    x2: 2004.5696,
    y2: 1414.811
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#E38DDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9571F6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000007407568873192292150000011134528053953890237_)"
    },
    d: "M2188.549,1603.273 c0,0-93.687,66.723-80.795,352.417C2107.754,1955.691,2002.737,1671.52,2188.549,1603.273z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000063623494917294063990000002649441841579541689_",
    gradientUnits: "userSpaceOnUse",
    x1: 2655.7361,
    y1: 2557.1375,
    x2: 2145.1697,
    y2: 1260.3912
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#E38DDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9571F6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000063623494917294063990000002649441841579541689_)"
    },
    d: "M2317.393,1590.018h42.08 c-31.811,100.3-17.906,161.951,1.553,200.118c0,0,12.9,25.305,117.143,131.715c0,0,3.973,30.941,11.423,88.943 c-31.913-10.982-63.826-21.961-95.738-32.942c-18.817-13.355-89.191-66.634-113.39-166.355 C2252.542,1696.443,2307.135,1606.294,2317.393,1590.018z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160895623651690214380000000455504812290510264_",
    gradientUnits: "userSpaceOnUse",
    x1: 1814.5219,
    y1: 2089.8489,
    x2: 1843.3875,
    y2: 2192.2314
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB316D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#792D3D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160895623651690214380000000455504812290510264_)"
    },
    d: "M1876.408,2127.326 c-3.681-10.677-14.253-17.327-25.482-16.123c-20.447,2.192-51.307,6.975-62.991,16.534 c-18.117,14.824,4.942,80.467,31.295,77.293c13.177-1.588,30.059-13.506,43.648-25.027 c14.868-12.607,20.246-33.192,13.893-51.622L1876.408,2127.326z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000033336588288541960940000004787833993312280766_",
    gradientUnits: "userSpaceOnUse",
    x1: 2399.1189,
    y1: 1416.5394,
    x2: 2595.0142,
    y2: 2111.3545
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000033336588288541960940000004787833993312280766_)"
    },
    d: "M2361.667,1666.92l20.123-61.697 c0,0,184.506,128.861,252.39,221.098c67.884,92.237-19.959,322.827-19.959,322.827l-69.07-17.568 c0,0,7.58-132.018-18.774-185.697c-26.353-53.679-118.59-101.579-118.59-101.579S2354.856,1783.856,2361.667,1666.92z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163759463883541523120000006144328175573193353_",
    gradientUnits: "userSpaceOnUse",
    x1: 2536.1746,
    y1: 2109.0479,
    x2: 2573.4951,
    y2: 2241.4182
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB316D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#792D3D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163759463883541523120000006144328175573193353_)"
    },
    d: "M2563.71,2136.3l30.388,7.729 c0,0,15.373,92.962-15.194,103.944c-30.567,10.98-59.116-6.589-59.116-30.746C2519.788,2193.07,2563.71,2136.3,2563.71,2136.3z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000149349588498213109760000000342519593135213203_",
    gradientUnits: "userSpaceOnUse",
    x1: 984.0553,
    y1: 1301.0996,
    x2: 1134.4021,
    y2: 1438.705
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#26264F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#444B8C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000149349588498213109760000000342519593135213203_)"
    },
    d: "M936.67,1543.406 c-48.263-0.612-172.011-2.182-207.009-79.226c-20.894-45.994-5.814-109.325,29.476-148.238 c58.85-64.893,129.412-12.83,244.107-72.123c95.511-49.375,104.258-115.296,176.568-117.296 c44.799-1.239,95.731,22.563,117.471,61.817c46.97,84.812-50.71,226.612-149.793,294.039 C1057.433,1543.664,965.821,1543.776,936.67,1543.406z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000079465849675078264150000016230821850593121160_",
    gradientUnits: "userSpaceOnUse",
    x1: 4687.9746,
    y1: 2890.6365,
    x2: 4714.1836,
    y2: 3224.2083,
    gradientTransform: "matrix(-1 0 0 1 5807.3535 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#26264F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#444B8C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000079465849675078264150000016230821850593121160_)"
    },
    d: "M1068.263,3056.995 c0,0,105.503,47.951,107.226,55.605c1.723,7.654-67.849-2.566-96.25-1.462c-28.402,1.104-51.765-7.29-49.195-19.319 c2.572-12.032,12.513-42.288,12.513-42.288L1068.263,3056.995z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000131365924137349685020000015202571463110640780_",
    gradientUnits: "userSpaceOnUse",
    x1: 4755.6367,
    y1: 3076.3472,
    x2: 4750.8716,
    y2: 2730.8669,
    gradientTransform: "matrix(-1 0 0 1 5807.3535 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#893976"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#311944"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000131365924137349685020000015202571463110640780_)"
    },
    d: "M1072.123,3018.082l-6.417,47.501 c0,0-16.703,5.946-27.922-1.084l-4.787-52.098L1072.123,3018.082z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016060033689065213870000004638111836144946564_",
    gradientUnits: "userSpaceOnUse",
    x1: 5183.269,
    y1: 2851.7222,
    x2: 5209.4785,
    y2: 3185.2915,
    gradientTransform: "matrix(-1 0 0 1 5807.3535 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#26264F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#444B8C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016060033689065213870000004638111836144946564_)"
    },
    d: "M575.271,3019.221l-12.272,19.701 c-3.432,5.509-4.454,12.141-2.808,18.42c4.29,16.383,12.862,48.309,16.598,56.635c5.09,11.339,73.364,18.076,73.364,18.076 s6.089-8.567-8.087-18.916c-14.175-10.347-23.287-11.975-28.29-27.247c-5.001-15.269-8.34-58.464-8.34-58.464L575.271,3019.221 z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000048493389233666710500000017680529652754313662_",
    gradientUnits: "userSpaceOnUse",
    x1: 5209.5518,
    y1: 3070.0872,
    x2: 5204.7871,
    y2: 2724.6003,
    gradientTransform: "matrix(-1 0 0 1 5807.3535 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#893976"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#311944"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000048493389233666710500000017680529652754313662_)"
    },
    d: "M626.35,2969.157 c-4.483,3.573-26.411,70.131-26.411,70.131s-7.098,9.076-20.581-4.319c-13.482-13.395-6.102-6.008-6.102-6.008l2.528-65.461 L626.35,2969.157z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000020359716704009236690000004981028675108786353_",
    gradientUnits: "userSpaceOnUse",
    x1: 4046.9238,
    y1: 2516.675,
    x2: 4302.3643,
    y2: 2516.675,
    gradientTransform: "matrix(-1 0 0 1 5181.0908 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000020359716704009236690000004981028675108786353_)"
    },
    d: "M1130.171,2063.749 c5.567,141.696,5.792,295.641-2.361,460.102c-9.178,185.196-27.626,356.363-50.873,511.526 c-8.642,0.276-17.723,0.322-27.21,0.055c-6.406-0.178-12.613-0.49-18.612-0.904c-12.064-32.175-26.325-74.484-39.094-125.021 c-13.424-53.14-21.523-100.807-27.294-146.388c-20.316-160.49,3.492-174.492-12.995-293.431 c-14.602-105.337-35.369-109.45-59.747-259.007c-26.45-162.273-6.76-186.619,2.816-195.413 C935.565,1977.828,1031.316,2003.317,1130.171,2063.749z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150070423403591007080000008811269000766759575_",
    gradientUnits: "userSpaceOnUse",
    x1: 4064.5859,
    y1: 2516.6855,
    x2: 4302.3633,
    y2: 2516.6855,
    gradientTransform: "matrix(-1 0 0 1 5181.0908 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000150070423403591007080000008811269000766759575_)"
    },
    d: "M894.801,2015.269 c38.88-35.712,127.793-14.092,221.703,40.41c-108.035,116.722-119.813,192.442-106.861,241.571 c14.637,55.528,59.139,71.521,58.971,132.238c-0.21,74.615-67.549,94.38-66.119,173.337 c0.948,52.21,30.538,51.668,37.527,116.154c8.268,76.299-30.39,102.59-17.869,159.042 c5.388,24.287,20.762,56.021,64.551,88.713c-3.157,23.181-6.394,46.13-9.769,68.645c-8.638,0.272-17.721,0.321-27.207,0.051 c-6.406-0.176-12.615-0.488-18.611-0.902c-12.065-32.175-26.325-74.483-39.095-125.02 c-13.424-53.142-21.523-100.808-27.294-146.39c-20.315-160.49,3.492-174.492-12.995-293.431 c-14.602-105.337-35.369-109.452-59.746-259.008C865.537,2048.405,885.226,2024.061,894.801,2015.269z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072266976149666688170000003999739784764023470_",
    gradientUnits: "userSpaceOnUse",
    x1: 4117.8389,
    y1: 2491.4954,
    x2: 4632.0684,
    y2: 2491.4954,
    gradientTransform: "matrix(-1 0 0 1 5181.0908 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072266976149666688170000003999739784764023470_)"
    },
    d: "M1063.252,2061.369 c-93.023,136.11-193.357,305.507-283.086,508.267c-67.81,153.228-116.989,297.094-153.096,425.309 c-4.887,2.263-16.411,6.775-31.14,4.829c-20.088-2.656-32.128-15.479-35.275-19.058 c-14.695-91.913-13.077-169.757-8.088-225.938c3.194-35.971,8.846-95.873,31.774-169.821 c25.681-82.834,43.337-87.49,76.84-175.125c34.775-90.962,26.352-113.662,59.654-227.495 c13.68-46.763,36.582-116.353,74.37-199.594C884.555,2008.95,973.904,2035.16,1063.252,2061.369z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163056729662661401200000008250344921630013575_",
    gradientUnits: "userSpaceOnUse",
    x1: 3179.4597,
    y1: 1176.8365,
    x2: 3284.209,
    y2: 1176.8365,
    gradientTransform: "matrix(-1 0 0 1 5181.0908 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#893976"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#311944"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163056729662661401200000008250344921630013575_)"
    },
    d: "M1896.882,1213.964 c0,0,19.876-24.875,32.489-43.36c12.612-18.485,71.489-70.421,71.489-70.421s4.487,8.242-8.188,21.429 c-12.674,13.187-39.347,35.787-33.214,45.348c6.132,9.561,23.397,17.99,10.938,36.044c-12.46,18.054-34.124,5.725-45.2,20.206 c-11.076,14.48-22.422,30.278-22.422,30.278L1896.882,1213.964z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096056073022225986880000012733261003187434650_",
    gradientUnits: "userSpaceOnUse",
    x1: 3657.3167,
    y1: 1481.1305,
    x2: 4264.3911,
    y2: 2655.1628,
    gradientTransform: "matrix(-1 0 0 1 5181.0908 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096056073022225986880000012733261003187434650_)"
    },
    d: "M1889.123,1197.733 c13.407,20.285,26.814,40.562,40.222,60.846c-13.959,40.772-38.017,97.388-80.166,157.122 c-18.592,26.349-76.236,103.648-173.831,165.811c-132.855,84.618-374.895,163.563-445.749,73.516 c-63.224-80.348,38.822-258.445,57.615-290.419c38.034,17.832,100.536,41.485,180.873,47.08 c26.329,1.834,94.858,6.01,172.062-17.706C1783.032,1350.092,1862.357,1239.313,1889.123,1197.733z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052823398274000236990000004852279323021130919_",
    gradientUnits: "userSpaceOnUse",
    x1: 3964.2002,
    y1: 1321.5613,
    x2: 4571.2744,
    y2: 2495.5935,
    gradientTransform: "matrix(-1 0 0 1 5181.0908 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052823398274000236990000004852279323021130919_)"
    },
    d: "M1426.634,1459.828 c-5.839,26.239-97.088,12.167-115.921,59.796c-10.106,25.558,11.35,41.792,12.249,85.198 c1.007,48.592-24.888,76.187-44.754,114.413c-29.094,55.989-29.202,110.873-29.418,220.633 c-0.306,156.245,38.32,187.663,5.349,238.018c-42.918,65.547-145.978,69.731-173.832,70.867 c-95.264,3.87-106.566-41.393-209.934-46.798c-118.054-6.174-134.868,51.218-219.296,26.741 c-77.126-22.361-103.079-81.844-163.134-69.528c-37.536,7.694-47.489,35.053-82.904,32.092 c-35.587-2.977-72.374-34.52-74.882-66.864c-3.117-40.201,46.018-90.846,123.02-90.925 c30.598,10.742,81.319,23.192,137.728,9.363c92.425-22.658,140.497-101.251,193.889-188.54 c36.937-60.384,104.827-171.374,105.637-316.908c0.333-60.016-11.008-77.575,5.349-109.651 c53.113-104.165,259.175-88.621,276.625-87.117C1312.814,1352.724,1433.684,1428.144,1426.634,1459.828z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052077568810513304570000014724562515224758163_",
    gradientUnits: "userSpaceOnUse",
    x1: 3932.9656,
    y1: 1715.8718,
    x2: 3786.5459,
    y2: 1958.5674,
    gradientTransform: "matrix(-1 0 0 1 5181.0908 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#6165D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AA80F9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052077568810513304570000014724562515224758163_)"
    },
    d: "M1472.669,1590.924l-258.826,10.1 c-2.841,0.111-5.332,1.934-6.295,4.609l-121.929,338.245c-1.749,4.852,3.734,16.988,8.861,16.437l255.896-34.812 c2.602-0.28,4.83-1.993,5.769-4.436L1483,1605.353C1484.798,1600.671,1477.68,1590.728,1472.669,1590.924z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000153664440088337752390000006780618466250566064_",
    gradientUnits: "userSpaceOnUse",
    x1: 4036.1951,
    y1: 1704.9376,
    x2: 3663.126,
    y2: 1903.5066,
    gradientTransform: "matrix(-1 0 0 1 5181.0908 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000153664440088337752390000006780618466250566064_)"
    },
    d: "M1476.684,1599.202l-258.825,10.101 c-2.842,0.111-5.331,1.934-6.296,4.608l-121.928,338.245c-1.749,4.852,2.186,9.859,7.313,9.308l257.444-27.684 c2.603-0.279,4.83-1.993,5.769-4.435l123.31-320.662C1485.273,1604.002,1481.696,1599.006,1476.684,1599.202z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062187788024634873730000002856996645756685996_",
    gradientUnits: "userSpaceOnUse",
    x1: 3862.2104,
    y1: 1462.0988,
    x2: 3818.0837,
    y2: 1606.5132,
    gradientTransform: "matrix(-1 0 0 1 5181.0908 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#26264F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#444B8C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062187788024634873730000002856996645756685996_)"
    },
    d: "M1405.909,1611.799l9.974-26.965 c0.9-2.434-0.901-5.021-3.496-5.021h-94.213c-1.624,0-3.061,1.051-3.553,2.6l-9.473,29.825 c-0.778,2.45,1.098,4.933,3.667,4.855l93.711-2.861C1404.044,1614.186,1405.382,1613.224,1405.909,1611.799z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044856577517801296870000001931100188798330761_",
    gradientUnits: "userSpaceOnUse",
    x1: 4022.5139,
    y1: 1679.2333,
    x2: 3649.4443,
    y2: 1877.8025,
    gradientTransform: "matrix(-1 0 0 1 5181.0908 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000044856577517801296870000001931100188798330761_)"
    },
    d: "M1246.583,1879.585 c16.812-54.515-10.856-90.015,17.383-132.379c39.945-59.921,125.758-34.56,152.437-82.909 c7.195-13.037,10.637-32.467,0.93-62.781l59.351-2.312c5.012-0.195,8.588,4.795,6.788,9.48l-123.31,320.662 c-0.939,2.445-3.166,4.153-5.769,4.435l-156.464,16.83C1225.797,1926.306,1239.752,1901.743,1246.583,1879.585z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098929991551310374370000006006894431001094058_",
    gradientUnits: "userSpaceOnUse",
    x1: 3979.083,
    y1: 1832.0737,
    x2: 4123.5146,
    y2: 1832.0737,
    gradientTransform: "matrix(-1 0 0 1 5181.0908 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#893976"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#311944"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098929991551310374370000006006894431001094058_)"
    },
    d: "M1057.576,1839.076 c0,0,39.111-7.781,54.196-17.273c15.085-9.499,31.081-24.753,53.32-23.923c22.239,0.838,44.62,12.141,34.345,14.739 c-10.274,2.592-29.464,22.972-44.125,30.996c-14.66,8.025-48.161,8.748-54.4,8.311c-6.238-0.436-30.866,14.374-30.866,14.374 L1057.576,1839.076z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000153681651633566568090000014732202350069953951_",
    gradientUnits: "userSpaceOnUse",
    x1: 3964.2,
    y1: 1321.561,
    x2: 4571.2759,
    y2: 2495.5967,
    gradientTransform: "matrix(-1 0 0 1 5181.0908 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000153681651633566568090000014732202350069953951_)"
    },
    d: "M453.177,2033.472 c30.598,10.742,81.319,23.192,137.728,9.363c92.425-22.658,140.498-101.251,193.889-188.54 c36.938-60.384,104.827-171.374,105.637-316.908c0.333-60.016-11.008-77.575,5.348-109.651c2.603-5.1,5.67-9.841,8.967-14.385 c40.347,27.273,55.993,54.586,60.566,78.569c11.128,58.371-41.346,106.101-14.041,156.448 c26.155,48.224,90.817,34.882,104.299,76.219c14.545,44.596-57.018,71.494-60.172,140.402 c-3.787,82.698,95.651,123.198,78.224,178.512c-15.106,47.942-98.323,44.486-98.281,70.201 c0.05,30.571,117.773,79.768,218.627,42.12c30.565-11.408,54.072-28.77,71.554-45.435c3.765,26.945,3.086,45.404-11.382,67.499 c-42.918,65.547-145.978,69.731-173.832,70.867c-95.264,3.87-106.566-41.393-209.934-46.798 c-118.054-6.174-134.868,51.218-219.296,26.741c-77.126-22.361-103.079-81.844-163.134-69.528 c-37.536,7.694-47.489,35.053-82.904,32.092c-35.587-2.977-72.374-34.52-74.882-66.864 C327.04,2084.196,376.176,2033.551,453.177,2033.472z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000180351298389027627190000004037123259058656907_",
    gradientUnits: "userSpaceOnUse",
    x1: 4114.688,
    y1: 1295.2723,
    x2: 4744.855,
    y2: 2745.4846,
    gradientTransform: "matrix(-1 0 0 1 5181.0908 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2466,
    style: {
      stopColor: "#FCAF48"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000180351298389027627190000004037123259058656907_)"
    },
    d: "M1058.578,1822.869 c12.034,21.397,24.069,42.786,36.103,64.184c-18.554,9.088-216.918,102.944-360.7,10.029 c-17.778-11.486-65.023-42.019-90.49-101.808c-28.068-65.899-12.324-127.168-2.109-166.963 c25.282-98.509,96.785-201.844,198.235-243.361c38.75-15.858,84.758-23.881,128.034-31.427 c36.699-6.402,94.378-14.244,95.607-8.688c0.6,2.711-12.803,6.174-22.11,11.439c-57.165,32.334,15.414,165.874-51.768,229.917 c-64.358,61.348-147.885,51.217-161.346,106.814c-6.259,25.848,6.696,49.101,12.468,59.459 C872.703,1810.262,959.379,1836.133,1058.578,1822.869z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016785110726796560930000006637679470609771418_",
    gradientUnits: "userSpaceOnUse",
    x1: 4302.021,
    y1: 1934.2338,
    x2: 4471.835,
    y2: 1687.729,
    gradientTransform: "matrix(-0.9787 -0.2054 -0.2054 0.9787 5795.9058 371.9818)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#893976"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#311944"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016785110726796560930000006637679470609771418_)"
    },
    d: "M1193.216,1244.575 c0,0-23.296,67.723-52.31,78.272c-29.014,10.539-74.88,22.644-80.637,27.337c-5.756,4.682,154.144,56.606,243.8,32.709l0,0 c-25.547-11.179-32.38-14.752-32.38-14.752c-6.821-3.573-19.548-10.222-31.485-20.796 c-8.126-7.192-20.849-20.582-30.424-42.834l8.38-38.448L1193.216,1244.575z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000131344271645610884800000015111753604632512391_",
    gradientUnits: "userSpaceOnUse",
    x1: 4286.6284,
    y1: 1809.2012,
    x2: 4555.0444,
    y2: 1647.6035,
    gradientTransform: "matrix(-0.9787 -0.2054 -0.2054 0.9787 5795.9058 371.9818)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#893976"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#311944"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000131344271645610884800000015111753604632512391_)"
    },
    d: "M1184.141,1268.388 c0,0,11.917,26.485,40.171,22.42c25.302-3.639,24.014-67.283,6.825-78.119c-5.731-3.613-17.364-4.989-25.997-1.828 c-6.071,2.22-24.143,17.021-20.115,38.701c-5.576-2.965-11.129-2.501-13.054,0.166c-2.447,3.38,1.517,9.514,2.413,10.903 C1177.495,1265.448,1182.023,1267.564,1184.141,1268.388z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085972515433101216560000010127389462391484328_",
    gradientUnits: "userSpaceOnUse",
    x1: 2230.1807,
    y1: 1347.4402,
    x2: 1918.9937,
    y2: 1950.2635
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40447E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3C3B6B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085972515433101216560000010127389462391484328_)"
    },
    d: "M1469.27,1736.727 c-31.122-21.714,13.257-89.9,16.648-220.596c3.449-132.902-39.635-170.523-4.162-224.757 c43.823-67.001,150.573-72.268,176.199-73.532c52.517-2.592,84.422,9.567,133.189,22.198 c209.152,54.173,261.509-3.894,355.173,54.109c90.49,56.038,50.864,117.416,138.74,183.136 c142.436,106.526,292.219-8.641,394.019,80.469c96.286,84.283,98.505,299.029-2.775,416.218 c-114.815,132.852-321.847,92.934-460.614,66.596c-29.196-5.542-176.659-36.508-330.199-149.839 c-84.938-62.693-143.258-129.639-180.362-178.973c-8.708-9.796-22.295-21.671-40.234-23.586 c-21.536-2.299-38.835,10.876-47.172,16.649C1573.69,1735.304,1496.207,1755.523,1469.27,1736.727z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1546.602,1561.501c-34.793,20.351-64.065,33.986-84.392,42.685 c-41.772,17.876-49.729,22.141-68.31,31.848c-53.648,28.031-115.432,77.111-109.073,90.894 c11.803,25.581,283.947-130.216,339.944-65.444c42.884,49.601-38.18,231.805-181.788,310.858 c-136.606,75.197-351.599,69.054-417.626-48.902c-36.936-65.987-19.232-152.627,10.422-207.419 c41.48-76.646,114.376-106.687,164.273-126.272c42.491-16.677,86.279-23.562,173.852-37.338 c57.863-9.101,106.179-14.72,139.977-18.179C1524.787,1543.323,1535.694,1552.412,1546.602,1561.501z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1619.643,1670.069c0,0,359.174-104.75,396.433,158.201 c35.713,252.028-147.238,367.683-63.995,622.964c9.649,29.589-178.199,7.837-180.314,11.352 c-11.372,18.905-22.816,38.525-34.267,58.953c-233.618-153.391-469.136-176.261-469.136-176.261 c92.554-115.469,114.063-210.729,116.273-276.964c2.423-72.615-18.507-105.62,0-191.461c0,0,20.649-95.78,95.144-178.023 C1490.476,1687.025,1503.226,1674.727,1619.643,1670.069z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AE87F9"
    },
    d: "M1759.156,2456.632c-0.512,0-1.031-0.126-1.499-0.417 c-2.447-1.505-247.443-150.455-445.25-161.547c-1.581-0.088-2.789-1.441-2.7-3.022c0.082-1.568,1.423-2.846,3.016-2.694 c104.197,5.843,220.453,49.692,299.633,85.447c85.719,38.714,147.679,76.555,148.298,76.935 c1.347,0.822,1.771,2.593,0.942,3.933C1761.06,2456.151,1760.117,2456.632,1759.156,2456.632z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1761.376,1672.442c25.418-31.93,99.597-27.083,146.984-9.138 c73.114,27.687,93.486,90.73,147.248,85.439c25.343-2.496,54.703-19.84,56.354-38.174 c2.554-28.341-84.362-80.094-362.661-152.468c5.453-18.786,11.81-20.229,17.264-39.016 c61.552-9.193,182.595-27.099,298.133-4.848c93.404,17.991,162.37,31.273,218.146,87.259 c80.379,80.683,127.191,243.854,43.628,354.486c-89.282,118.204-266.388,95.659-363.575,50.901 C1800.821,1932.243,1716.226,1729.162,1761.376,1672.442z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035516701588844179960000001467284958821191846_",
    gradientUnits: "userSpaceOnUse",
    x1: 428.753,
    y1: 2047.3391,
    x2: 444.558,
    y2: 1626.3445,
    gradientTransform: "matrix(-0.984 0.1784 0.1784 0.984 1748.4363 -244.2395)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000035516701588844179960000001467284958821191846_)"
    },
    d: "M1697.65,1512.483 c-3.292,15.372-20.039,97.859,13.709,119.084c7.316,4.6,21.374,7.236,49.49,12.504c18.405,3.449,33.85,5.565,44.742,6.868 c-1.571,13.833-6.231,36.348-22.194,56.827c-44.748,57.408-134.471,42.552-147.266,40.222 c-45.13-8.22-89.541-22.162-100.266-30.684c-16.33-12.977-29.169-22.713-36.765-32.604 c17.467-8.44,52.726-30.699,76.39-37.981c17.683-5.442,34.285-9.324,49.382-12.109c2.484-15.935,4.967-31.87,7.451-47.805 C1654.098,1562.03,1675.873,1537.256,1697.65,1512.483z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103948568690729029480000008888314318448752305_",
    gradientUnits: "userSpaceOnUse",
    x1: 423.8205,
    y1: 1675.6832,
    x2: 417.0551,
    y2: 2220.7637,
    gradientTransform: "matrix(-0.984 0.1784 0.1784 0.984 1748.4363 -244.2395)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103948568690729029480000008888314318448752305_)"
    },
    d: "M1699.229,1553.591 c0,0-6.096,60.45-64.86,71.104c-52.614,9.54-92.221-117.605-65.294-150.49c8.984-10.969,31.157-21.406,50.379-20.853 c13.517,0.388,59.181,17.779,65.555,63.473c9.094-9.582,20.425-12.338,26.013-8.325c7.087,5.091,3.289,19.888,2.428,23.239 C1710.469,1543.356,1702.885,1550.554,1699.229,1553.591z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158743569618377733490000003859784172229581995_",
    gradientUnits: "userSpaceOnUse",
    x1: 1531.205,
    y1: 1476.3253,
    x2: 1527.4126,
    y2: 1781.8689
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158743569618377733490000003859784172229581995_)"
    },
    d: "M1513.88,1534.233 c0,0,14.931,21.532,26.554,22.128c11.622,0.596,10.713-34.726,4.35-43.878c-6.362-9.154-10.733-40.058,4.633-49.147 C1564.781,1454.247,1494.792,1457.883,1513.88,1534.233z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052084840818498732990000001105808098968885428_",
    gradientUnits: "userSpaceOnUse",
    x1: 1744.3918,
    y1: 1475.6405,
    x2: 1740.478,
    y2: 1790.9758
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052084840818498732990000001105808098968885428_)"
    },
    d: "M1717.504,1465.712 c16.361,15.452,17.269,31.813,12.724,52.719c-4.545,20.906-10.642,40.55,13.894,39.641 c24.536-0.909,30.41-18.735,28.71-39.641c-0.997-12.249-24.007-43.337-40.786-55.766 C1720.19,1453.88,1710.729,1459.314,1717.504,1465.712z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000079467207426298745740000010122492757248968859_",
    gradientUnits: "userSpaceOnUse",
    x1: 847.5544,
    y1: 1694.9979,
    x2: 2753.8257,
    y2: 2393.0696
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000079467207426298745740000010122492757248968859_)"
    },
    d: "M2226.758,1910.888 c-111.888,32.226-209.955-102.297-291.399-58.28c-64.582,34.904-24.221,131.002-106.846,291.399 c-29.51,57.286-91.108,179.709-171.602,178.077c-74.887-1.518-102.175-111.216-207.217-139.224 c-29.493-7.864-58.81-7.592-86.514-2.615c-16.852,48.497-45.81,103.896-94.815,165.034c0,0,235.518,22.866,469.136,176.263 c11.451-20.433,22.895-40.052,34.267-58.957c2.115-3.512,189.963,18.237,180.314-11.351 c-58.725-180.092,14.974-290.736,50.978-428.749c100.218,32.596,245.367,36.824,323.413-66.504 c45.786-60.616,52.375-136.991,35.804-206.945C2334.578,1823.648,2292.46,1891.964,2226.758,1910.888z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000139287275017504020990000005934477962422278059_",
    gradientUnits: "userSpaceOnUse",
    x1: 2500.1421,
    y1: 3696.0505,
    x2: 2063.2786,
    y2: 3009.5508,
    gradientTransform: "matrix(0.9873 -0.1586 0.1586 0.9873 -230.7199 205.6246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40447E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#1C2C5A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000139287275017504020990000005934477962422278059_)"
    },
    d: "M2329.166,2666.287 c-66.085,19.936-76.44,148.025-82.812,226.851c-7.175,88.754-15.168,187.631,41.596,276.199 c71.4,111.404,219.268,165.949,376.362,150.315c-1.629-10.139-3.258-20.277-4.886-30.416 c-161.228-61.54-205.26-130.696-216.368-181.563c-23.623-108.176,92.044-177.64,62.166-294.948 C2482.711,2724.329,2387.683,2648.634,2329.166,2666.287z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119830759681932071070000002120940463193158043_",
    gradientUnits: "userSpaceOnUse",
    x1: 1843.5959,
    y1: 3114.896,
    x2: 1954.4933,
    y2: 3490.7141,
    gradientTransform: "matrix(0.9832 -0.1825 0.1825 0.9832 -66.6194 160.6767)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40447E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3C3B6B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000119830759681932071070000002120940463193158043_)"
    },
    d: "M2559.036,2751.443 c-35.86-52.868-70.815-106.349-105.855-159.762c-6.885-10.494-10.876-22.67-12.796-35.453 c-13.914,11.044-27.24,24.264-39.521,39.732c-33.255,123.029-64.631,286.855-68.029,482.197 c-2.121,121.903,25.429,490.53,38.73,583.166c4.873,0.999,6.641-11.686,11.629-10.736c6.085,1.16,7.626,12.209,13.567,13.237 c17.696-187.092,37.995-355.953,48.239-442.732c3.475-29.444,13.734-117.77,61.023-188.915 c0.761-1.145,70.738-96.834,94.883-135.065c8.038-12.728,18.094-29.239,29.524-51.32 C2603.317,2817.301,2581.59,2784.695,2559.036,2751.443z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031194727635253745550000006000892735346507699_",
    gradientUnits: "userSpaceOnUse",
    x1: 1761.4404,
    y1: 3716.9014,
    x2: 1754.1176,
    y2: 4078.5474,
    gradientTransform: "matrix(0.9832 -0.1825 0.1825 0.9832 -66.6194 160.6767)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB316D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#792D3D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031194727635253745550000006000892735346507699_)"
    },
    d: "M2398.049,3562.403 c-2.743-6.33-17.85,9.579-31.924,26.379c1.813,24.181,3.626,48.36,5.439,72.541c-4.997-3.177-11.297-6.648-18.405-8.288 c-8.54-1.969-23.302,1.105-24.436,5.188c-7,25.199,55.839,30.7,62.725,22.783c6.886-7.917,5.311-17.182,5.311-17.182 c-6.378-36.311-5.534-60.905-2.51-77.885C2396.375,3574.013,2399.564,3565.897,2398.049,3562.403z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124855594702958476940000012034754667128955580_",
    gradientUnits: "userSpaceOnUse",
    x1: 1799.6554,
    y1: 3717.1458,
    x2: 1792.2852,
    y2: 4081.1316,
    gradientTransform: "matrix(0.9832 -0.1825 0.1825 0.9832 -66.6194 160.6767)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB316D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#792D3D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124855594702958476940000012034754667128955580_)"
    },
    d: "M2371.565,3661.323 c4.873,1,6.641-11.686,11.629-10.735c6.085,1.16,7.626,12.208,13.567,13.236c6.469-68.389,13.284-134.316,19.83-194.714 c-21.169-2.48-42.669-3.113-63.879-3.358C2359.449,3551.591,2366.528,3626.247,2371.565,3661.323z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168104147878210489270000012704496494780296576_",
    gradientUnits: "userSpaceOnUse",
    x1: 2394.6599,
    y1: 2823.3003,
    x2: 2508.1912,
    y2: 3208.0452
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40447E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3C3B6B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.25,
      fill: "url(#SVGID_00000168104147878210489270000012704496494780296576_)"
    },
    d: "M2559.036,2751.444 c-35.859-52.869-70.815-106.349-105.855-159.764c-6.885-10.495-10.876-22.669-12.796-35.453 c-13.914,11.044-27.24,24.265-39.521,39.733c-24.45,90.451-47.839,203.026-59.885,333.893 c36.624-2.121,71.543,19.421,81.834,45.147c21.281,53.203-45.835,94.857-45.153,206.416 c0.373,61.113,22.225,76.453,12.276,132.547c-2.568,14.481-9.848,46.292-6.632,89.995c1.412,19.192,2.96,15.016,4.135,32.356 c3.35,49.407-8.436,94.827-3.329,125.681c1.835,11.09,5.609,18.822,7.075,21.64c3.931,7.556,8.539,12.97,11.781,16.329 c16.038-161.056,32.971-302.096,42.034-378.872c3.476-29.443,13.734-117.769,61.023-188.915 c0.762-1.145,70.738-96.835,94.883-135.065c8.038-12.728,18.094-29.239,29.524-51.319 C2603.317,2817.301,2581.59,2784.694,2559.036,2751.444z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000126322798438667359700000012800041158939945620_",
    gradientUnits: "userSpaceOnUse",
    x1: 724.1609,
    y1: 3078.7715,
    x2: 844.5167,
    y2: 3078.7715,
    gradientTransform: "matrix(0.8107 -0.5855 0.5855 0.8107 -444.7399 743.0767)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A03976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000126322798438667359700000012800041158939945620_)"
    },
    d: "M1982.512,2765.079l-7.938,7.737 c0,0-16.278,10.754-24.307,19.057c-8.03,8.303-9.969,16.716-3.073,26.264s19.392,2.308,30.287-3.84 c6.629-3.74,11.251-14.951,14.17-24.326c2.052-6.591,11.321-17.865,11.321-17.865L1982.512,2765.079z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070097973787239687860000001936616808718786717_",
    gradientUnits: "userSpaceOnUse",
    x1: 1608.7358,
    y1: 2612.2739,
    x2: 1801.3947,
    y2: 2717.6125,
    gradientTransform: "matrix(0.9707 -0.2402 0.2402 0.9707 -222.3646 339.9967)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070097973787239687860000001936616808718786717_)"
    },
    d: "M2172.876,2312.647 c-43.698,84.963-14.175,120.946-42.217,189.669c-27.798,68.123-68.306,60.94-124.217,158.359 c-21.231,36.993-33.835,70.168-41.232,92.752c2.991,3.094,6.324,6.315,10.022,9.576c2.508,2.212,6.246,5.379,12.204,9.819 c5.731,4.271,14.702,10.605,26.988,18.001c34.819-5.467,92.485-20.561,134.38-69.049c7.628-8.829,12.659-15.358,19.023-26.389 c21.375-37.053,20.977-73.256,66.124-165.191c34.094-69.427,39.985-75.168,43.229-105.924 c8.018-76.027-31.534-158.422-63.511-158.044C2196.99,2266.423,2184.981,2289.113,2172.876,2312.647z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160183355247306262730000002325858387348813449_",
    gradientUnits: "userSpaceOnUse",
    x1: 2419.24,
    y1: 2461.541,
    x2: 3078.8574,
    y2: 2879.5159,
    gradientTransform: "matrix(0.9995 -0.0302 0.0302 0.9995 -235.3357 118.8563)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160183355247306262730000002325858387348813449_)"
    },
    d: "M2187.969,2289.145 c-22.543,41.336-19.976,82.503-17.508,100.521c7.679,56.051,41.435,93.864,49.714,103.967 c39.115,47.73,61.352,157.585-8.856,428.102c16.108,7.095,83.962,74.384,94.096,29.845 c13.816-60.723,38.822-467.215,38.098,6.186c-0.009,6.238,12.538,1.375,19.023,1.878c46.492,3.603,100.196,0.518,157.28-16.67 c89.469-26.939,149.137-77.045,179.682-107.009c-40.97-50.131-88.902-120.139-126.897-210.91 c-72.484-173.162-70.433-330.212-62.449-416.876c-33.222-11.188-136.95-41.428-235.644,6.365 C2249.916,2226.452,2211.714,2245.605,2187.969,2289.145z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EA645E"
    },
    d: "M2983.583,2637.954l-633.936,255.252c-16.488,6.639-35.237-1.345-41.876-17.834 l-143.432-360.194c-6.639-16.489,1.345-35.237,17.834-41.876l633.936-255.252c16.489-6.639,35.237,1.345,41.876,17.834 l143.432,360.194C3008.056,2612.566,3000.071,2631.314,2983.583,2637.954z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000095327762008010801190000008362514346266066082_",
    gradientUnits: "userSpaceOnUse",
    x1: 2173.8757,
    y1: 2559.3779,
    x2: 3015.6299,
    y2: 2559.3779
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000095327762008010801190000008362514346266066082_)"
    },
    d: "M2995.458,2641.704l-633.936,255.252 c-16.489,6.639-35.237-1.345-41.876-17.834l-143.432-360.194c-6.639-16.488,1.345-35.237,17.834-41.876l633.936-255.252 c16.488-6.639,35.237,1.346,41.876,17.834l143.432,360.194C3019.931,2616.316,3011.947,2635.065,2995.458,2641.704z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2453.198,2557.482c34.389,0.607,65.538,29.367,69.543,64.109 c1.124,9.753-0.073,18.928-3.037,27.127l76.495,35.372c6.545-18.562,9.026-39.345,6.494-61.336 c-9.139-79.368-80.187-145.331-158.927-147.036c-0.205-0.005-0.405,0.006-0.609,0.002l9.434,81.782 C2452.797,2557.504,2452.992,2557.478,2453.198,2557.482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC244"
    },
    d: "M2519.704,2648.718c-7.598,21.018-27.202,35.443-51.926,35.16 c-34.474-0.394-65.89-29.15-69.925-64.103c-4.011-34.748,20.553-62.54,54.738-62.273l-9.434-81.782 c-79.037-1.375-136.169,62.583-126.89,142.869c9.301,80.476,81.748,146.416,160.938,147.003 c56.863,0.422,101.896-33.012,118.994-81.503L2519.704,2648.718z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4C53A5"
    },
    d: "M2906.563,2438.937l-264.381,108.251c-1.251,0.512-2.681-0.1-3.192-1.366l-10.184-25.193 c-0.512-1.267,0.087-2.708,1.339-3.219l264.551-107.862c1.219-0.497,2.616,0.114,3.121,1.364l10.037,24.859 C2908.359,2437.02,2907.781,2438.438,2906.563,2438.937z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4C53A5"
    },
    d: "M2884.263,2385.417l-264.38,108.251c-1.251,0.512-2.68-0.099-3.193-1.367l-10.184-25.193 c-0.512-1.267,0.088-2.708,1.34-3.219l264.551-107.862c1.219-0.497,2.616,0.114,3.121,1.364l10.037,24.859 C2886.059,2383.5,2885.481,2384.918,2884.263,2385.417z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4C53A5"
    },
    d: "M2950.048,2549.321l-264.381,108.251c-1.251,0.512-2.68-0.1-3.193-1.367l-10.184-25.193 c-0.512-1.267,0.087-2.708,1.339-3.219l264.551-107.862c1.219-0.497,2.616,0.114,3.121,1.364l10.037,24.859 C2951.844,2547.404,2951.266,2548.822,2950.048,2549.321z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4C53A5"
    },
    d: "M2927.748,2495.801l-264.381,108.251c-1.251,0.512-2.68-0.1-3.192-1.367l-10.184-25.193 c-0.512-1.267,0.088-2.708,1.339-3.219l264.551-107.862c1.219-0.497,2.616,0.114,3.121,1.364l10.037,24.859 C2929.544,2493.885,2928.966,2495.302,2927.748,2495.801z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049905221646432198770000011494849281293568156_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.2654,
    y1: 3287.2305,
    x2: 144.6227,
    y2: 3287.2305,
    gradientTransform: "matrix(0.4477 -0.8942 0.8942 0.4477 -308.2449 1340.9366)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A03976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049905221646432198770000011494849281293568156_)"
    },
    d: "M2652.23,2729.263l-3.457,10.531 c0,0-9.454,17.066-12.729,28.142c-3.276,11.076-1.101,19.432,9.429,24.705c10.531,5.273,18.259-6.928,25.073-17.42 c4.146-6.384,3.054-18.46,1.304-28.122c-1.231-6.793,1.769-21.077,1.769-21.077L2652.23,2729.263z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000048476450340416204460000011164101078091770001_",
    gradientUnits: "userSpaceOnUse",
    x1: 2630.5234,
    y1: 2084.0627,
    x2: 2903.3218,
    y2: 2396.0479,
    gradientTransform: "matrix(1.0016 -0.0159 0.0485 1.128 -247.2501 29.7581)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000048476450340416204460000011164101078091770001_)"
    },
    d: "M2417.951,2218.235 c20.636-29.063,86.891-11.925,95.591-9.582c63.795,17.182,101.636,64.356,156.217,134.302 c42.128,53.987,63.473,80.907,74.624,123.996c17.472,67.512,2.047,126.091-5.673,155.411 c-13.608,51.682-35.782,88.435-50.859,109.762c-7.497,1.492-16.469,2.653-26.64,2.742c-9.308,0.08-17.656-0.754-24.783-1.925 c-14.117-22.918-32.61-58.888-41.603-105.977c-5.703-29.861-4.118-46.039-5.839-87.998 c-3.536-86.223-5.304-129.333-16.754-150.416c-37.717-69.453-126.618-45.126-153.174-115.796 C2416.783,2266.698,2404.539,2237.123,2417.951,2218.235z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018219283980058343140000004567123969843918002_",
    gradientUnits: "userSpaceOnUse",
    x1: 2177.2295,
    y1: 3385.0471,
    x2: 2452.4351,
    y2: 3644.8496,
    gradientTransform: "matrix(0.9873 -0.1586 0.1586 0.9873 -230.7199 205.6246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB316D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#792D3D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018219283980058343140000004567123969843918002_)"
    },
    d: "M2659.426,3289.237 c-39.364-15.025-71.699-30.505-98.317-46.061c-7.561,23.832-11.026,49.682-10.568,75.392 c36.685,4.51,74.944,4.948,113.771,1.084C2662.684,3309.513,2661.055,3299.375,2659.426,3289.237z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031200662849620962060000011854636177959894194_",
    gradientUnits: "userSpaceOnUse",
    x1: 2190.1294,
    y1: 3371.3816,
    x2: 2465.335,
    y2: 3631.1843,
    gradientTransform: "matrix(0.9873 -0.1586 0.1586 0.9873 -230.7199 205.6246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB316D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#792D3D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031200662849620962060000011854636177959894194_)"
    },
    d: "M2655.902,3295.35l3.524-6.113 c0,0,6.325-3.789,9.317,4.05c2.993,7.839,19.972,48.792,20.876,67.367c-4.455,11.116-17.06,1.701-19.661-5.855 c-2.6-7.555-11.608-35.575-11.608-35.575L2655.902,3295.35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#26264F"
    },
    d: "M2361.78,1821.316c7.698,3.539,33.395,15.984,58.646,42.207 c32.596,33.849,44.309,69.743,46.841,77.931c4.537,14.677,20.87,67.497-0.894,115.414 c-35.508,78.177-154.863,104.641-154.134,106.152c0.132,0.274,4-0.728,4.083-2.252c0.263-4.787-37.335-5.06-69.159-17.234 c-30.397-11.627-46.903-32.108-82.354-70.882c-32.618-35.675-48.927-53.513-55.295-76.025 c-15.754-55.696,16.613-120.446,60.993-156.259c47.102-38.01,101.966-36.619,117.222-36.233 C2323.298,1805.036,2350.269,1816.024,2361.78,1821.316z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096031486713213756120000009119698382536449966_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.7009,
    y1: 2853.6279,
    x2: 35.2199,
    y2: 2546.802,
    gradientTransform: "matrix(-0.9261 0.3773 0.3773 0.9261 1315.5769 -288.2454)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096031486713213756120000009119698382536449966_)"
    },
    d: "M2321.523,2125.365 c-0.031,8.735,0.305,55.501,21.085,63.179c4.543,1.679,8.191,0.608,28.339,1.134c11.487,0.3,20.831,0.914,26.849,1.376 c-1.021,7.969-3.027,18.656-7.298,30.673c-25.857,72.758-109.552,123.306-137.906,105.099 c-14.766-9.483-15.905-37.926-16.378-49.729c-0.71-17.728,3.565-31.772,6.685-39.812c10.38-7.54,21-15.099,31.862-22.659 c7.096-4.939,14.153-9.782,21.169-14.529c-0.474-8.949-0.948-17.897-1.422-26.846 C2303.515,2157.29,2312.519,2141.327,2321.523,2125.365z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176005434721176164690000014982546195182745262_",
    gradientUnits: "userSpaceOnUse",
    x1: 441.8237,
    y1: 2528.8806,
    x2: 435.6568,
    y2: 2353.127,
    gradientTransform: "matrix(-0.9786 0.206 0.206 0.9786 2240.5857 -233.1068)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A03976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176005434721176164690000014982546195182745262_)"
    },
    d: "M2330.592,2142.613 c0,0,0.1,38.488-30.631,51.007c-27.516,11.209-63.604-53.388-52.728-74.351c3.629-6.993,14.49-15.205,25.006-17.105 c7.394-1.335,38.085-1.518,46.78,22.596c2.587-7.623,7.736-12.565,13.055-12.622c0.849-0.009,3.286,0.349,5.232,1.737 C2344.351,2118.898,2342.347,2130.651,2330.592,2142.613z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106129986939896020120000000953022308482618756_",
    gradientUnits: "userSpaceOnUse",
    x1: 2077.2566,
    y1: 2405.3577,
    x2: 2167.1953,
    y2: 2308.3188
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106129986939896020120000000953022308482618756_)"
    },
    d: "M2068.046,2151.795l33.565,6.713 c0,0,176.213,224.881,151.04,310.47c-25.174,85.589-151.04,20.139-151.04,20.139L2068.046,2151.795z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000149345061227249991710000010909638801182667672_",
    gradientUnits: "userSpaceOnUse",
    x1: 761.0834,
    y1: 3882.0779,
    x2: 807.4824,
    y2: 3786.043,
    gradientTransform: "matrix(-0.9802 0.1979 0.1979 0.9802 2204.0603 -227.1835)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000149345061227249991710000010909638801182667672_)"
    },
    points: "2208.977,3689.483  2203.726,3672.015 2171.161,3678.586 2176.175,3689.483  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178194154288424856080000004064787313219844993_",
    gradientUnits: "userSpaceOnUse",
    x1: 2252.8501,
    y1: 3534.9143,
    x2: 1959.3853,
    y2: 2873.3748
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000178194154288424856080000004064787313219844993_)"
    },
    d: "M2020.98,3354.059 c10.311,68.134,4.895,96.599,21.148,151.992c24.295,82.787,72.751,143.108,113.983,183.433h43.303 c5.695-1.532,11.391-3.064,17.087-4.598c-36.761-142.547-70.46-304.652-94.506-484.062 c-24.332-181.524-34.472-348.606-36.376-497.205c-78.549,16.484-157.099,32.972-235.648,49.456 c19.574,154.21,56.082,269.577,86.968,348.187C1971.31,3188.741,2004.563,3245.576,2020.98,3354.059z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010272428485466032730000008068412971705133237_",
    gradientUnits: "userSpaceOnUse",
    x1: 2252.8506,
    y1: 3534.9153,
    x2: 1959.3855,
    y2: 2873.3752
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000010272428485466032730000008068412971705133237_)"
    },
    d: "M2020.98,3354.059 c10.312,68.134,4.895,96.599,21.148,151.992c24.295,82.787,72.751,143.108,113.983,183.433h8.501 c-38.757-53.154-51.111-98.507-52.934-134.697c-1.974-39.23,7.84-78.87-13.426-137.614 c-17.021-47.018-37.741-61.499-46.99-110.763c-8.066-42.97,3.01-56.926,3.357-100.693 c0.69-87.216-42.629-116.104-57.061-187.96c-7.823-38.953,43.339-137.309,90.273-222.284 c-1.097-31.33-1.831-61.982-2.214-91.853c-78.549,16.485-157.099,32.971-235.648,49.457 c19.574,154.209,56.083,269.577,86.968,348.186C1971.31,3188.74,2004.563,3245.577,2020.98,3354.059z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013893789968292172320000001354986025288348556_",
    gradientUnits: "userSpaceOnUse",
    x1: 1575.1798,
    y1: 3709.2029,
    x2: 1281.72,
    y2: 3047.6741,
    gradientTransform: "matrix(0.9925 -0.1225 0.1225 0.9925 83.0051 108.1241)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013893789968292172320000001354986025288348556_)"
    },
    d: "M1757.625,3405.354 c8.113,76.875,3.829,120.923,22.328,195.096c8.484,34.022,19.143,63.872,29.813,89.033h77.142 c2.347-128.81,5.655-259.139,10.01-390.979c6.47-195.92,15.007-388.431,25.387-577.424 c-157.525-7.457-211.49,48.454-228.702,70.741c-53.028,68.655-29.259,179.025,18.277,399.763 C1735.302,3300.35,1748.522,3319.135,1757.625,3405.354z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029765276171067457720000006743103489340348344_",
    gradientUnits: "userSpaceOnUse",
    x1: 1686.9829,
    y1: 2791.8743,
    x2: 2027.1022,
    y2: 2424.9041
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029765276171067457720000006743103489340348344_)"
    },
    d: "M1682.392,2157.58 c44.811-12.601,110.484-27.338,190.913-31.884c118.588-6.703,177.903-9.669,212.715,17.592 c107.966,84.548,5.647,386.747,44.12,545.537c32.372,133.609,33.564,135.936,33.564,135.936 c7.652,14.937,20.053,35.692,15.104,60.416c-3.892,19.445-18.605,41.79-38.598,48.668 c-41.546,14.294-65.362-52.135-134.258-72.164c-72.016-20.937-152.59,20.657-254.475,73.25 c-64.839,33.471-86.979,54.819-109.699,44.225c-43.749-20.399-31.735-132.23-26.852-177.891 C1634.33,2619.823,1656.168,2407.385,1682.392,2157.58z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070116284852377506270000012233892576645858731_",
    gradientUnits: "userSpaceOnUse",
    x1: 1976.1212,
    y1: 2464.749,
    x2: 2107.9734,
    y2: 2464.749
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070116284852377506270000012233892576645858731_)"
    },
    d: "M1979.94,2465.622 c-3.135-0.7-8.721-21.556,5.034-27.691c62.094-27.691,110.147,27.134,116.573,44.003c6.427,16.869,6.427,16.869,6.427,16.869 s-30.837,2.41-49.961-4.016C2038.887,2488.361,2005.438,2471.307,1979.94,2465.622z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000079468468078637976830000008206575335935399065_",
    gradientUnits: "userSpaceOnUse",
    x1: 131.6589,
    y1: -45.489,
    x2: 95.3839,
    y2: -96.9995,
    gradientTransform: "matrix(0.2291 -0.9734 -0.9734 -0.2291 2020.0098 2554.8499)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000079468468078637976830000008206575335935399065_)"
    },
    d: "M2149.594,2544.142l-109.244,5.511 c-4.186,0.211-9.184-4.969-8.154-8.496l51.031-165.138c0.803-2.746,3.598-4.578,6.708-4.406l104.768,2.296 c3.414,0.201,5.284,6.924,4.357,10.246l-43.41,155.282C2154.934,2541.996,2152.355,2544.003,2149.594,2544.142z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088835476108429376150000007776730520483642784_",
    gradientUnits: "userSpaceOnUse",
    x1: 61.4998,
    y1: 48.6199,
    x2: 147.8778,
    y2: -126.8354,
    gradientTransform: "matrix(0.2291 -0.9734 -0.9734 -0.2291 2020.0098 2554.8499)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088835476108429376150000007776730520483642784_)"
    },
    d: "M2147.618,2540.623l-109.846,5.155 c-4.21,0.198-7.113-2.815-6.082-6.346l49.068-167.993c0.805-2.755,3.616-4.586,6.743-4.401l104.916,6.204 c3.431,0.203,5.742,3.506,4.811,6.841l-43.526,155.835C2152.985,2538.485,2150.393,2540.493,2147.618,2540.623z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070831738402287096020000007895459626038571963_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.5971,
    y1: -67.0524,
    x2: 200.9834,
    y2: -67.0524,
    gradientTransform: "matrix(0.2291 -0.9734 -0.9734 -0.2291 2020.0098 2554.8499)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000070831738402287096020000007895459626038571963_)"
    },
    d: "M2092.162,2440.456 c3.253,15.277,16.994,11.987,28.204,30.479c14.231,23.476,0.594,44.205,13.637,52.802c3.981,2.623,10.709,4.199,22.812,1.033 l-3.114,11.147c-0.717,2.568-3.308,4.576-6.083,4.706l-109.846,5.155c-4.209,0.197-7.112-2.815-6.082-6.346l49.068-167.993 c0.805-2.755,3.615-4.586,6.743-4.401l15.761,0.932c1.851,5.773,3.176,12.437,3.031,19.816 C2105.797,2413.117,2088.352,2422.56,2092.162,2440.456z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062184678275685974330000014578204927302164122_",
    gradientUnits: "userSpaceOnUse",
    x1: 2126.7322,
    y1: 2394.9407,
    x2: 2225.6782,
    y2: 2520.365
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062184678275685974330000014578204927302164122_)"
    },
    d: "M2197.675,2428.123 c0.615-2.642-0.689-5.363-2.653-5.504c-7.994-0.576-26.535-0.811-36.771,8.055c-13.296,11.52-30.49,32.542-16.01,43.148 l13.52,9.907c0.621,0.455,1.298,0.596,1.979,0.385c4.804-1.494,25.023-7.839,27.235-9.414 C2186.987,2473.265,2194.696,2440.906,2197.675,2428.123z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181767411125540800130000005490892833813094028_",
    gradientUnits: "userSpaceOnUse",
    x1: 1709.5302,
    y1: 2812.7712,
    x2: 2049.6497,
    y2: 2445.8005
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000181767411125540800130000005490892833813094028_)"
    },
    d: "M2106.645,2870.073 c-11.716-20.309-11.224-50.981-36.921-65.45c-14.982-8.437-26.662-4.492-46.99-5.035 c-60.598-1.616-72.198-39.74-114.119-41.955c-64.922-3.432-96.106,84.887-132.579,72.164 c-23.809-8.306-39.139-55.926-26.852-92.302c17.128-50.709,75.827-43.763,152.718-112.441 c32.894-29.378,80.088-82.398,67.129-105.728c-13.612-24.504-78.196,11.453-125.867-25.173 c-27.817-21.371-24.266-47.781-46.99-95.658c-12.314-25.944-57.406-93.397-124.47-138.872 c-21.558,206.204-40.074,385.446-56.777,541.645c-4.883,45.661-16.897,157.492,26.852,177.891 c22.72,10.594,44.86-10.754,109.699-44.225c101.885-52.593,182.459-94.187,254.475-73.25 c68.896,20.029,92.711,86.458,134.258,72.164c12.978-4.464,23.666-15.47,30.679-27.946 C2133.835,2899.235,2115.472,2885.373,2106.645,2870.073z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165919918888639199740000009320810356706555321_",
    gradientUnits: "userSpaceOnUse",
    x1: 2286.76,
    y1: 1674.067,
    x2: 2298.8989,
    y2: 1350.7324,
    gradientTransform: "matrix(0.917 0.3988 -0.3988 0.917 399.6047 -184.8945)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165919918888639199740000009320810356706555321_)"
    },
    d: "M1933.789,2035.438 c0.076,9.017-22.345,54.183-52.584,76.079c-30.514,22.095-68.899,20.893-80.336,23.729 c-26.519,6.574-29.931,6.396-30.516,9.027c-2.856,12.838,69.456,56.592,144.164,46.046 c45.723-6.453,87.324-32.539,84.77-46.237c-2.57-13.786-48.242-6.389-61.855-31.329c-9.469-17.35,1.146-41.981,13.692-62.38 C1938.971,2027.604,1945.94,2058.208,1933.789,2035.438z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155837104542390840990000015490255864567664025_",
    gradientUnits: "userSpaceOnUse",
    x1: 310.5338,
    y1: 1197.5812,
    x2: 224.0288,
    y2: 977.8743,
    gradientTransform: "matrix(-0.9052 -0.4249 -0.4249 0.9052 2628.1162 1242.0535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6B3976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000155837104542390840990000015490255864567664025_)"
    },
    d: "M2021.369,2104.555 c15.889-8.333,27.208-30.661,22.746-50.28c-3.84-16.883-18.224-25.847-26.834-31.217 c-24.952-15.556-63.48-20.321-86.578-1.516c-13.687,11.145-13.015,48.096-13.238,54.576 c-0.248,7.329,3.536,11.677,5.774,18.368c3.099,9.277,7.876,23.957,15.48,48.326c3.587-4.428,8.37-9.747,14.487-15.069 c2.355-2.049,11.677-9.991,22.509-15.107C1997.421,2102.377,2006.308,2112.45,2021.369,2104.555z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000092426212966495594210000006085427377514838413_",
    gradientUnits: "userSpaceOnUse",
    x1: 1209.5287,
    y1: 1063.3134,
    x2: 1205.5509,
    y2: 1383.793,
    gradientTransform: "matrix(0.9296 0.3687 -0.3687 0.9296 1241.8521 648.5008)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000092426212966495594210000006085427377514838413_)"
    },
    d: "M1923.167,2117.979 c0,0,3.862,36.692,39.477,50.817c31.888,12.646,69.293-54.578,56.512-78.663c-4.265-8.034-16.5-16.33-28.66-18.409 c-7.182-1.227-10.578,0.389-22.273-1.846c-10.791-2.06-12.998-4.41-17.055-3.346c-5.074,1.335-11.279,7.56-14.831,30.711 c-3.071-8.772-9.068-14.423-15.211-14.432c-0.979,0.001-3.788,0.438-6.021,2.062 C1907.025,2090.746,1909.467,2104.296,1923.167,2117.979z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078035903528377942460000016263742655085848207_",
    gradientUnits: "userSpaceOnUse",
    x1: 284.1052,
    y1: 1208.0997,
    x2: 197.5142,
    y2: 988.1743,
    gradientTransform: "matrix(-0.9052 -0.4249 -0.4249 0.9052 2628.1162 1242.0535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6B3976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078035903528377942460000016263742655085848207_)"
    },
    d: "M1951.735,2061.721 c0.965,1.819-6.234,5.224-10.306,12.941c-7.908,14.976-1.129,40.667,13.923,49.706c8.899,5.343,14.131,0.933,30.336,6.615 c10.032,3.519,17.41,8.503,21.895,11.967c-3.099,19.069-15.585,33.627-30.471,36.073 c-16.026,2.633-29.041-9.74-34.482-14.913c-3.64-3.461-15.318-14.521-16.534-30.614c-1.267-16.77,9.889-21.229,5.489-34.249 c-2.219-6.568-7.013-11.229-8.448-22.588c-0.388-3.086-0.404-5.66-0.354-7.362 C1934.773,2064.623,1950.339,2059.086,1951.735,2061.721z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096041781130183847500000013091767899994934702_",
    gradientUnits: "userSpaceOnUse",
    x1: 1739.2009,
    y1: 2580.6079,
    x2: 1788.429,
    y2: 2159.9341
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096041781130183847500000013091767899994934702_)"
    },
    d: "M1774.358,2208.854 c-18.107-27.464-54.135-54.416-87.267-52.025c-96.762,6.983-216.04,267.645-134.258,370.887 c62.429,78.81,255.286,82.636,431.302-53.703c0-15.104,0-30.208,0-45.312c-86.613,15.148-158.417,25.208-211.455,31.886 c-33.079,4.167-66.031,7.921-72.164-5.034c-9.28-19.604,56.973-47.644,82.233-120.832 C1786.23,2324.633,1808.38,2260.458,1774.358,2208.854z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170263637531898941470000017868331458344214150_",
    gradientUnits: "userSpaceOnUse",
    x1: 1152.7401,
    y1: 3368.2566,
    x2: 1294.9014,
    y2: 3881.2732
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000170263637531898941470000017868331458344214150_)"
    },
    d: "M1275.914,3689.483 c-2.072-11.334-5.263-24.263-5.263-24.263l-22.093,8.438c0,0-25.708,9.467-42.424,15.825H1275.914z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129177233642972099800000000471831485408281262_",
    gradientUnits: "userSpaceOnUse",
    x1: 1257.0909,
    y1: 3737.1091,
    x2: 1259.1515,
    y2: 3564.0405
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129177233642972099800000000471831485408281262_)"
    },
    d: "M1241.738,3639.602l6.281,34.339 c0,0,13.449,7.417,24.181,0l2.612-38.135L1241.738,3639.602z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000133524497840763749860000000698327327475451264_",
    gradientUnits: "userSpaceOnUse",
    x1: 1457.215,
    y1: 3739.4919,
    x2: 1459.2755,
    y2: 3566.4231
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000133524497840763749860000000698327327475451264_)"
    },
    points: "1472.952,3689.483  1474.613,3665.221 1441.54,3669.016 1445.284,3689.483  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132775046633892504880000009959765501059063972_",
    gradientUnits: "userSpaceOnUse",
    x1: 1157.3313,
    y1: 3180.5029,
    x2: 1341.5989,
    y2: 3180.5029
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132775046633892504880000009959765501059063972_)"
    },
    d: "M1189.268,2734.211 c-10.645,26.786-21.29,53.573-31.936,80.358c1.562,147.872,9.295,308.181,26.261,478.926 c12.622,127.033,29.081,247.011,47.912,359.361c17.169-2.17,34.339-4.346,51.509-6.515 c20.956-51.453,44.369-128.739,39.664-221.448c-4.907-96.705-35.183-107.17-40.73-199.694 c-7.189-119.921,40.457-155.888,55.665-302.047c5.815-55.896,6.938-128.384-8.241-215.003 C1282.669,2716.835,1235.969,2725.527,1189.268,2734.211z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000138557747532477428230000007500206538200293564_",
    gradientUnits: "userSpaceOnUse",
    x1: 1157.3324,
    y1: 3180.5029,
    x2: 1341.5992,
    y2: 3180.5029
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000138557747532477428230000007500206538200293564_)"
    },
    d: "M1329.371,2708.15 c-25.221,4.69-50.443,9.381-75.665,14.077c-39.399,83.342-45.537,167.293-34.563,203.329 c15.525,50.987,46.925,65.202,49.448,117.44c2.496,51.688-26.808,67.491-41.208,129.802 c-9.967,43.142-3.347,81.543,10.303,156.585c27.493,151.158,68.025,194.811,41.206,247.242 c-7.622,14.897-22.046,33.067-51.929,48.453c1.505,9.284,3.002,18.599,4.541,27.779c17.169-2.167,34.339-4.346,51.509-6.513 c20.956-51.46,44.369-128.74,39.664-221.45c-4.907-96.706-35.183-107.173-40.73-199.695 c-7.189-119.921,40.457-155.885,55.665-302.045C1343.428,2867.258,1344.551,2794.77,1329.371,2708.15z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016758158207464220210000016728990626034885266_",
    gradientUnits: "userSpaceOnUse",
    x1: 1261.364,
    y1: 3206.8279,
    x2: 1541.08,
    y2: 3206.8279
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016758158207464220210000016728990626034885266_)"
    },
    d: "M1261.364,2775.122 c34.284,128.19,66.516,265.743,94.792,412.096c34.141,176.71,58.206,343.954,74.878,499.688 c18.958-0.977,37.915-1.961,56.873-2.94c62.719-153.421,59.262-253.755,43.3-317.98 c-6.151-24.749-21.339-73.026-29.796-146.318c-5.894-51.091-5.751-90.343-5.423-137.541 c0.715-103.484,9.781-126.789,5.043-205.52c-4.444-73.889-7.133-111.24-29.938-131.341 C1411.011,2692.312,1271.907,2769.164,1261.364,2775.122z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000033338419998952560670000006189465442658772864_",
    gradientUnits: "userSpaceOnUse",
    x1: 608.572,
    y1: 2432.2676,
    x2: 781.6438,
    y2: 2608.4297
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000033338419998952560670000006189465442658772864_)"
    },
    d: "M710.955,2477.313 c0,0-41.65-3.57-47.675-10.323c-6.025-6.752-15.178-17.566-16.081-23.756c-0.903-6.191-8.95,3.056-1.655,16.481 c7.294,13.425-13.402,10.582-16.632,10.257c-7.427-0.746-35.756-1.576-34.939,0.177c0.818,1.755-3.364,9.504,16.756,18.621 c17.613,7.98,38.58,2.786,50.03,3.335c11.448,0.548,11.448,0.548,11.448,0.548l30.366,2.316L710.955,2477.313z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090996458895162065170000017653954764192752512_",
    gradientUnits: "userSpaceOnUse",
    x1: 1437.4922,
    y1: 1913.8893,
    x2: 609.2301,
    y2: 2760.6934
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#6165D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AA80F9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000090996458895162065170000017653954764192752512_)"
    },
    d: "M686.541,2457.854 c-1.834,13.884-3.668,27.767-5.503,41.65c27.585,23.01,88.573,67.117,173.423,73.732 c149.581,11.668,297.919-99.035,325.536-223.549c13.675-61.666,2.504-148.184-35.82-162.096 c-10.637-3.864-26.619-3.315-59.567,18.82c-87.928,59.065-95.406,136.636-143.982,189.108 C905.668,2433.281,836.932,2471.538,686.541,2457.854z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000063603633932453604240000011363962457911235480_",
    gradientUnits: "userSpaceOnUse",
    x1: 1823.6154,
    y1: 3239.9766,
    x2: 1199.3297,
    y2: 2343.7246
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#6165D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AA80F9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000063603633932453604240000011363962457911235480_)"
    },
    d: "M1144.969,2842.112 c-20.532-28.618-0.094-59.444,0.522-116.831c0.697-65.04-25.038-73.799-58.212-178.835 c-22.062-69.856-43.241-136.918-30.905-218.395c5.912-39.048,15.939-105.277,67.224-140.988 c26.465-18.428,64.504-19.846,139.5-21.922c92.741-2.572,139.11-3.858,175.001,11.517 c5.253,2.252,114.588,50.843,129.242,143.154c14.917,93.953-87.025,114.911-90.655,242.086 c-1.629,57.091,16.334,143.258,27.985,199.146c11.186,53.663,17.007,67.166,7.624,84.435 c-22.614,41.626-102.458,36.675-262.146,26.782C1187.51,2868.381,1160.291,2863.468,1144.969,2842.112z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000058575315783478360080000008396891859743405201_",
    gradientUnits: "userSpaceOnUse",
    x1: 1823.554,
    y1: 3240.0188,
    x2: 1199.2665,
    y2: 2343.7639
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000058575315783478360080000008396891859743405201_)"
    },
    d: "M1363.367,2550.569 c8.645,24.037,34.125,40.467,55.628,98.897c4.642,12.616,37.707,102.453,6.182,127.745c-18.21,14.606-37.48-8.76-84.473-8.247 c-81.434,0.887-114.559,72.042-168.949,57.695c-9.437-2.494-22.106-8.397-35.47-23.228c-1.268,14.431,0.136,26.763,8.684,38.68 c15.321,21.355,42.541,26.268,105.18,30.15c159.688,9.893,239.531,14.844,262.146-26.782 c9.383-17.27,3.562-30.773-7.624-84.435c-11.65-55.889-29.614-142.055-27.985-199.146 c3.629-127.176,105.571-148.134,90.655-242.086c-3.987-25.117-15.088-46.877-29.09-65.468 C1411.875,2317.663,1336.196,2475.034,1363.367,2550.569z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178922234450846642770000011237061872224839608_",
    gradientUnits: "userSpaceOnUse",
    x1: 1443.3982,
    y1: 2742.8733,
    x2: 1544.0959,
    y2: 2742.8733
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000178922234450846642770000011237061872224839608_)"
    },
    d: "M1543.239,2723.319l-24.795,18.779 c-5.126-5.042-16.865-15.102-34.125-17.476c-19.445-2.669-40.898,5.113-40.92,11.253c-0.018,4.919,13.734,8.776,15.86,9.373 c17.166,4.817,29.127-1.285,36.405,4.878c2.574,2.179,5.898,6.349,13.057,9.886c1.879,0.93,3.837,1.726,4.858,2.034 c11.475,3.435,29.011-17.468,30.518-19.291L1543.239,2723.319z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021807871777202226580000006886950359847244469_",
    gradientUnits: "userSpaceOnUse",
    x1: 1998.6888,
    y1: 3118.0283,
    x2: 1374.4006,
    y2: 2221.7725
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#6165D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AA80F9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021807871777202226580000006886950359847244469_)"
    },
    d: "M1438.57,2386.771 c-22.532-43.761-41.183-112.031-19.575-217.369c202.951,61.757,318.014,237.494,290.511,386.317 c-22.672,122.686-135.484,190.599-160.708,205.006c-7.211-13.394-14.422-26.782-21.633-40.176 c27.665-36.259,57.885-89.015,48.47-145.701C1562.585,2496.262,1484.187,2475.365,1438.57,2386.771z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026858664116741787710000002972618453297765777_",
    gradientUnits: "userSpaceOnUse",
    x1: -672.6548,
    y1: 2818.9456,
    x2: -672.6548,
    y2: 2640.4658,
    gradientTransform: "matrix(0.827 0.5622 -0.5622 0.827 3357.9539 289.0357)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026858664116741787710000002972618453297765777_)"
    },
    d: "M1260.469,2071.613 c0,0,4.311,34.291,17.06,59.208c11.521,22.52,63.474,33.093,74.182,37.467c10.711,4.374-17.649,21.943-47.114,27.31 c-29.462,5.367-114.828,5.419-131.022-4.616c-16.193-10.034,11.453-11.397,32.031-20.88 c20.577-9.481,29.513-51.926,24.262-70.445C1224.621,2081.136,1260.469,2071.613,1260.469,2071.613z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000058556014137722451670000007294881876028718739_",
    gradientUnits: "userSpaceOnUse",
    x1: 1297.5261,
    y1: 2184.4119,
    x2: 1222.8773,
    y2: 1994.8175
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3E4177"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000058556014137722451670000007294881876028718739_)"
    },
    d: "M1212.491,2062.9 c-16.626-13.908-18.918-15.504-21.017-20.604c-8.419-20.468,5.569-50.543,26.374-59.339c1.082-0.456,15.047-6.193,21.016-0.413 c5.07,4.908-1.181,12.749,2.884,22.665c3.808,9.284,12.125,9.336,28.433,20.604c13.435,9.279,21.784,15.048,24.313,23.901 c5.214,18.253-15.088,46.938-35.027,47.8C1252.297,2097.824,1250.06,2094.328,1212.491,2062.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067919689353085744900000005562962653004469666_",
    gradientUnits: "userSpaceOnUse",
    x1: -798.8148,
    y1: 2767.5093,
    x2: -715.3689,
    y2: 2605.2534,
    gradientTransform: "matrix(0.827 0.5622 -0.5622 0.827 3357.9539 289.0357)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000067919689353085744900000005562962653004469666_)"
    },
    d: "M1257.751,2100.536 c0,0-14.896,19.863-40.344,15.73c-22.785-3.699-21.193-55.44-5.497-64.944c5.236-3.169,15.166-3.737,22.909-0.743 c4.574,1.77,5.975,3.876,13.503,6.623c6.943,2.531,9.033,1.936,11.007,3.953c2.471,2.521,3.907,8.258-2.031,22.859 c4.802-4.01,10.215-5.203,13.766-3.09c0.566,0.339,2.039,1.561,2.768,3.269 C1276.472,2090.376,1270.386,2097.36,1257.751,2100.536z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000027581838185977145380000002996738717762188984_",
    gradientUnits: "userSpaceOnUse",
    x1: 1018.1363,
    y1: 3183.7949,
    x2: 980.5381,
    y2: 4029.7546,
    gradientTransform: "matrix(0.9999 0.0138 -0.0138 0.9999 63.3784 -14.86)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000027581838185977145380000002996738717762188984_)"
    },
    d: "M987.458,3425.288 c11.091,94.732-19.21,108.978-22.526,216.394c-0.508,16.447-0.298,32.408,0.471,47.802h132.331 c0.588-13.757,1.155-27.589,1.692-41.53c17.337-162.107,34.674-324.208,52.01-486.313 c-73.849-22.435-147.696-44.863-221.545-67.298c4.089,83.887,16.1,155.498,29.763,213.876 C974.352,3371.019,982.359,3381.753,987.458,3425.288z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044141241810969042530000008732226275307746494_",
    gradientUnits: "userSpaceOnUse",
    x1: 1018.1363,
    y1: 3183.7949,
    x2: 980.5383,
    y2: 4029.7517,
    gradientTransform: "matrix(0.9999 0.0138 -0.0138 0.9999 63.3784 -14.86)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000044141241810969042530000008732226275307746494_)"
    },
    d: "M1057.381,3316.493 c0.037,58.581-31.359,88.293-23.282,173.059c5.775,60.606,24.253,70.91,25.42,125.688c0.622,29.197-4.062,53.206-10.74,74.243 h48.955c0.588-13.757,1.155-27.589,1.692-41.53c17.337-162.107,34.674-324.208,52.01-486.313 c-73.849-22.435-147.696-44.863-221.545-67.298c0.27,5.555,0.665,10.908,1.002,16.359 C1035.695,3197.845,1057.351,3268.193,1057.381,3316.493z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134965443326841057090000009145910456893896611_",
    gradientUnits: "userSpaceOnUse",
    x1: 1598.1243,
    y1: 3393.0869,
    x2: 908.8456,
    y2: 3361.7556,
    gradientTransform: "matrix(0.9999 0.0138 -0.0138 0.9999 63.3784 -14.86)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000134965443326841057090000009145910456893896611_)"
    },
    d: "M1188.99,3468.729 c3.533,45.117-4.653,82.428-11.929,106.361c-10.684,30.69-20.166,66.423-25.731,106.678c-0.356,2.582-0.687,5.151-1.004,7.716 h158.027c2.275-12.894,4.475-26.019,6.581-39.377c12.488-79.211,21.995-141.327,20.411-219.936 c-1.669-82.912-16.273-213.801-87.472-369.034c-62.138,37.091-124.275,74.183-186.412,111.273 c55.871,89.88,87.35,160.891,104.557,204.788C1176.516,3403.979,1186.105,3431.902,1188.99,3468.729z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000095332723523279670610000016629046007478955939_",
    gradientUnits: "userSpaceOnUse",
    x1: 571.105,
    y1: 3724.2717,
    x2: 1059.8787,
    y2: 2679.8838,
    gradientTransform: "matrix(0.9999 0.0138 -0.0138 0.9999 63.3784 -14.86)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000095332723523279670610000016629046007478955939_)"
    },
    d: "M1076.192,2454.083 c83.186,12.457,146.604,25.919,175.707,68.723c30.739,45.213-15.83,80.741-26.536,181.613 c-16.392,154.435,73.391,210.069,51.24,365.691c-7.463,52.435-24.364,93.23-36.078,117.504 c-26.314,22.42-68.244,53.142-125.563,74.585c-83.411,31.201-125.235,15-238.169,23.887 c-184.723,14.534-211.264,68.77-295.529,37.577c-85.164-31.526-148.219-120.296-131.134-159.175 c10.233-23.281,44.379-9.614,92.301-38.956c61.761-37.816,50.188-87.375,100.016-131.17 c71.571-62.905,143.016-2.461,204.213-57.137c61.904-55.312,66.616-186.687,38.137-264.225 c-18.603-50.645-20.119-106.122-34.234-158.195c-1.175-4.327-2.173-11.245,0.362-19.171 c9.691-30.31,64.624-37.267,106.156-42.135C1020.424,2446.075,1069.351,2453.055,1076.192,2454.083z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047027401218620351770000007769345259560992132_",
    gradientUnits: "userSpaceOnUse",
    x1: 1322.7999,
    y1: 2554.8169,
    x2: 1704.5974,
    y2: 3339.9219,
    gradientTransform: "matrix(-0.9823 -0.1875 -0.1875 0.9823 3111.8684 295.6934)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000047027401218620351770000007769345259560992132_)"
    },
    d: "M589.714,3265.048 c25.24-17.612,10.334-65.689,47.709-92.183c34.689-24.589,62.811,5.993,114.347-11.023 c66.099-21.827,61.246-85.811,124.571-107.625c45.537-15.685,59.997,13.286,126.161,13.132 c66.05-0.152,152.017-29.257,205.324-100.421c22.651-30.238,34.982-62.243,41.434-91.726 c18.879,56.655,39.232,111.38,27.344,194.907c-7.463,52.435-24.364,93.23-36.078,117.504 c-26.314,22.42-68.244,53.142-125.563,74.583c-83.41,31.202-125.235,15.003-238.169,23.889 c-184.723,14.534-211.264,68.77-295.529,37.577c-54.429-20.148-99.705-63.655-120.924-102.598 C534.577,3272.667,571.396,3277.832,589.714,3265.048z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000002343187044525319780000016978816591233990050_",
    gradientUnits: "userSpaceOnUse",
    x1: 1109.7367,
    y1: 2369.3911,
    x2: 1021.5643,
    y2: 2512.0229,
    gradientTransform: "matrix(0.9999 0.0138 -0.0138 0.9999 63.3784 -14.86)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000002343187044525319780000016978816591233990050_)"
    },
    d: "M1120.988,2309.616 c0,0,23.759,42.385,25.845,72.441c2.087,30.054-31.914,28.595-31.914,28.595l1.682,18.951 c1.435,16.178,12.254,29.997,27.613,35.275l13.511,4.642c0,0-87.045,20.598-135.521-12.115l13.732-1.642 c19.444-2.325,34.556-18.033,36.126-37.553l0.655-8.141C1072.719,2410.069,1055.538,2316.615,1120.988,2309.616z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168077038529167619750000006854723625010732701_",
    gradientUnits: "userSpaceOnUse",
    x1: 1438.1145,
    y1: 2590.2305,
    x2: 1260.3909,
    y2: 2877.7246,
    gradientTransform: "matrix(0.9999 0.0138 -0.0138 0.9999 63.3784 -14.86)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168077038529167619750000006854723625010732701_)"
    },
    d: "M1260.04,2784.874l108.136-241.346 c1.336-2.981,4.461-4.737,7.7-4.329l189.082,23.841c5.048,0.636,7.975,6.05,5.739,10.62l-127.496,260.781 c-1.535,3.141-5.055,4.783-8.448,3.944l-168.344-41.63L1260.04,2784.874z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080177656069926971970000005228998151803376284_",
    gradientUnits: "userSpaceOnUse",
    x1: 1448.0646,
    y1: 2602.2607,
    x2: 1294.5404,
    y2: 2890.5098
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080177656069926971970000005228998151803376284_)"
    },
    d: "M1289.795,2755.654l87.557-195.417 c1.082-2.413,3.611-3.836,6.235-3.505l153.098,19.304c4.088,0.514,6.457,4.899,4.647,8.6l-103.233,211.152 c-1.243,2.543-4.093,3.873-6.84,3.193l-136.309-33.707L1289.795,2755.654z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044158157616176749740000014187406002216141189_",
    gradientUnits: "userSpaceOnUse",
    x1: 1419.9678,
    y1: 2571.7881,
    x2: 1462.2637,
    y2: 2484.0632,
    gradientTransform: "matrix(0.9999 0.0138 -0.0138 0.9999 63.3784 -14.86)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000044158157616176749740000014187406002216141189_)"
    },
    d: "M1409.096,2559.055l6.938-15.665 c0.965-2.177,3.234-3.472,5.599-3.194l78.68,9.254c3.653,0.43,5.831,4.29,4.31,7.639l-7.753,17.055 c-0.993,2.185-3.302,3.458-5.678,3.135l-77.866-10.645C1409.744,2566.145,1407.632,2562.36,1409.096,2559.055z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000159447813878577097790000009189990617396266423_",
    gradientUnits: "userSpaceOnUse",
    x1: 1475.7135,
    y1: 2703.8499,
    x2: 1433.069,
    y2: 2772.834,
    gradientTransform: "matrix(0.9999 0.0138 -0.0138 0.9999 63.3784 -14.86)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000159447813878577097790000009189990617396266423_)"
    },
    d: "M1474.404,2770.617 c0,0,30.812-20.957,34.405-35.73c3.594-14.774,2.692-42.571,2.692-42.571l-17.961,39.159c0,0-8.678-2.488-12.417-15.391 c-3.739-12.906-10.057-1.085-7.506,8.664C1476.17,2734.496,1474.404,2770.617,1474.404,2770.617z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134968439203626021980000013421394178582728340_",
    gradientUnits: "userSpaceOnUse",
    x1: 790.4708,
    y1: 3826.9663,
    x2: 1279.2531,
    y2: 2782.5603,
    gradientTransform: "matrix(0.9999 0.0138 -0.0138 0.9999 63.3784 -14.86)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000134968439203626021980000013421394178582728340_)"
    },
    d: "M1237.161,2508.24 c16.274,9.914,40.813,27.316,62.503,55.393c61.707,79.881,37.651,164.984,88.697,195.083 c14.597,8.611,40.222,15.599,86.484-0.762l17.732,9.431c0,0,21.658,110.159-112.108,114.278 c-133.766,4.124-200.413-162.172-200.413-162.172L1237.161,2508.24z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010295568477773915520000007848803591487896757_",
    gradientUnits: "userSpaceOnUse",
    x1: 620.0452,
    y1: 2966.8215,
    x2: 976.5093,
    y2: 2205.1465,
    gradientTransform: "matrix(0.9999 0.0138 -0.0138 0.9999 63.3784 -14.86)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000010295568477773915520000007848803591487896757_)"
    },
    d: "M1108.239,2352.545 c-4.528-0.277-8.384-5.93-11.442-4.16c-3.211,1.853-2.671,10.202,0.278,16.008c2.419,4.757,6.253,7.394,8.382,8.617 c-3.387,4.904-7.672,12.507-9.311,22.374c-3.63,21.823,8.3,39.056,13.322,49.182c22.647,45.649-9.483,119.276-45.674,156.886 c-29.411,30.572-43.692,18.838-61.109,43.666c-33.904,48.321,15.421,99.577-1.267,163.993 c-25.375,97.948-178.488,130.209-184.837,131.468c-2.501,0.498-4.181,0.812-6.786,1.282 c-68.729,12.435-172.9,31.283-247.727-23.742c-55.985-41.167-82.825-114.334-80.045-179.346 c0.729-17.101,4.513-82.038,56.199-136.079c8.205-8.577,56.786-59.253,123.859-61.293c35.526-1.082,42.959,11.285,69.968,2.961 c36.976-11.397,59.166-45.713,72.933-66.997c25.321-39.156,14.518-47.168,32.923-66.553 c36.067-37.978,79.942-9.702,118.611-43.367c38.119-33.182,13.763-76.567,50.626-105.372 c38.029-29.706,112.174-21.21,128.671,12.843C1149.993,2304.174,1122.12,2353.392,1108.239,2352.545z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129206828102736252710000011659669352847966850_",
    gradientUnits: "userSpaceOnUse",
    x1: 4660.2334,
    y1: 2280.28,
    x2: 4615.2783,
    y2: 2353.002,
    gradientTransform: "matrix(1 0 0 1 -3129.1155 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129206828102736252710000011659669352847966850_)"
    },
    d: "M1528.761,2354.49 c4.564-7.073,12.892-22.126,13.424-42.34c1.036-39.28-28.098-69.916-32.014-68.157c-2.11,0.948,0.566,12.457,2.066,17.556 c3.121,10.62,6.478,11.645,6.195,16.523c-0.577,10.041-15.073,10.428-22.719,23.753c-5.505,9.595-5.944,23.262,0,34.078 C1505.579,2353.846,1527.822,2354.479,1528.761,2354.49z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000139276991323854230480000016156622323227968692_",
    gradientUnits: "userSpaceOnUse",
    x1: 5300.5674,
    y1: 3140.9961,
    x2: 5318.7212,
    y2: 3178.3262,
    gradientTransform: "matrix(1 0 0 1 -3129.1155 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000139276991323854230480000016156622323227968692_)"
    },
    points: "2151.074,3207.64  2139.877,3169.108 2186.626,3134.467 2215.765,3123.571 2198.512,3177.485  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016045965084548468880000002085317548470154657_",
    gradientUnits: "userSpaceOnUse",
    x1: 3568.8767,
    y1: 3398.2781,
    x2: 4030.6282,
    y2: 3398.2781,
    gradientTransform: "matrix(1 0 0 1 -1879.5526 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016045965084548468880000002085317548470154657_)"
    },
    d: "M1833.659,3689.483 c-0.634-9.427-1.487-18.759-2.597-27.957c-6.541-137.378,54.515-309.644,54.515-309.644s52.334,174.447,89.405,261.672 c7.821,18.404,17.135,45.09,27.024,75.929h114.327c-6.218-42.573-12.778-81.181-19.239-108.639 c-26.167-111.21-23.987-379.422-67.599-455.743c-98.126-39.251-298.74-2.181-298.74-2.181s-41.432,37.069-41.432,189.711 c0,97.052,7.934,266.384,13.713,376.852H1833.659z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101098976249762381620000007451175832369885361_",
    gradientUnits: "userSpaceOnUse",
    x1: 3616.1492,
    y1: 3189.4958,
    x2: 3948.8147,
    y2: 3748.2456,
    gradientTransform: "matrix(1 0 0 1 -1879.5526 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000101098976249762381620000007451175832369885361_)"
    },
    d: "M1833.66,3689.483 c-0.633-9.427-1.486-18.759-2.597-27.957c-6.541-137.378,54.514-309.644,54.514-309.644s52.334,174.447,89.405,261.672 c7.821,18.404,17.135,45.09,27.024,75.929h114.327c-6.218-42.573-12.778-81.181-19.239-108.639 c-26.168-111.21-23.987-379.422-67.598-455.745c-98.126-39.249-298.74-2.179-298.74-2.179s-41.434,37.069-41.434,189.711 c0,97.052,7.934,266.384,13.713,376.852H1833.66z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000149349646961161952940000007404171555162506645_",
    gradientUnits: "userSpaceOnUse",
    x1: 3685.1631,
    y1: 3148.4067,
    x2: 4017.8286,
    y2: 3707.1565,
    gradientTransform: "matrix(1 0 0 1 -1879.5526 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.25,
      fill: "url(#SVGID_00000149349646961161952940000007404171555162506645_)"
    },
    d: "M1874.929,3357.389 c3.277-2.459,6.765-3.966,10.367-4.697c0.167-0.482,0.281-0.809,0.281-0.809s0.091,0.302,0.229,0.755 c24.691-4.505,54.576,27.559,60.178,49.966c12.918,83.975,38.757,129.192,103.353,187.328 c29.745,22.308,29.527,59.6,27.681,99.552h39.317c-6.218-42.573-12.778-81.181-19.239-108.639 c-26.168-111.21-23.987-379.423-67.598-455.745c-98.126-39.249-298.74-2.179-298.74-2.179s-41.434,37.069-41.434,189.711 c0,12.386,0.132,25.962,0.369,40.428C1732.705,3391.126,1820.675,3399.584,1874.929,3357.389z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072275078682375013050000007687759532670013603_",
    gradientUnits: "userSpaceOnUse",
    x1: -2934.1292,
    y1: -3707.6675,
    x2: -2581.8181,
    y2: -2983.1965,
    gradientTransform: "matrix(-0.9906 -0.1367 0.1367 -0.9906 -337.7953 -1269.0822)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072275078682375013050000007687759532670013603_)"
    },
    d: "M2168.231,3141.344 c5.365-14.916,38.848-112.897-15.269-202.254c-44.303-73.15-120.965-97.016-131.895-100.244 c-66.54-19.65-99.889,5.595-120.884-17.639c-35.626-39.427,4.73-173.725,82.792-200.625 c87.992-30.322,193.55,86.274,236.327,162.856c56.118,100.473,42.305,200.33,39.058,220.896 c-8.438,53.443-28.057,94.208-42.595,119.236C2199.92,3129.495,2184.076,3135.42,2168.231,3141.344z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000156587854739370713940000007446107315440368040_",
    gradientUnits: "userSpaceOnUse",
    x1: 4864.8516,
    y1: 2626.2021,
    x2: 5221.6655,
    y2: 3359.9326,
    gradientTransform: "matrix(1 0 0 1 -3129.1155 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000156587854739370713940000007446107315440368040_)"
    },
    d: "M1938.448,2601.623 c-78.544-3.141-139.115-1.896-173.331,32.297c-36.141,36.116,0.382,76.889-7.466,171.361 c-12.013,144.634-104.179,179.973-111.114,326.706c-2.338,49.441,6.029,89.851,12.526,114.187 c20.228,25.191,53.335,60.74,102.194,90.466c71.099,43.258,112.33,35.716,214.439,63.661 c167.021,45.711,181.88,100.147,264.698,86.279c83.7-14.017,157.135-84.455,148.265-123.135 c-5.313-23.165-39.054-16.603-77.902-51.935c-50.068-45.534-30.759-89.001-68.825-137.933 c-54.677-70.285-130.851-27.319-177.445-88.233c-47.132-61.62-28.437-183.042,11.292-249.228 c25.949-43.229,37.062-93.889,59.144-139.216c1.834-3.765,3.965-9.941,3.027-17.661c-3.584-29.52-52.793-45.533-90.063-57.28 C1991.045,2604.044,1944.907,2601.879,1938.448,2601.623z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035524586289113978600000012469989710662126731_",
    gradientUnits: "userSpaceOnUse",
    x1: 3770.6868,
    y1: 2534.3962,
    x2: 3838.8757,
    y2: 2642.7778,
    gradientTransform: "matrix(1 0 0 1 -1879.5526 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#E38DDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9571F6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000035524586289113978600000012469989710662126731_)"
    },
    d: "M1872.29,2598.375l15.491-4.767 c0,0,4.051,20.973,53.859,23.594c27.645,0,45.518-15.49,45.518-15.49l10.584,7.716c0,0-23.222,29.008-60.154,28.27 C1889.926,2636.745,1872.29,2598.375,1872.29,2598.375z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000037669714391821309860000010312729802213681333_",
    gradientUnits: "userSpaceOnUse",
    x1: 3853.0083,
    y1: 2517.7695,
    x2: 3778.0688,
    y2: 2638.9949,
    gradientTransform: "matrix(1 0 0 1 -1879.5526 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000037669714391821309860000010312729802213681333_)"
    },
    d: "M1903.833,2534.579 c2.985-23.034,21.194-37.792,25.167-40.951c16.636-13.223,20.023-14.554,25.736-15.64l7.803-1.183c0,0,0.42,0.01,0.852,0.036 c4.568,0.277,18.259,5.621,20.748,7.37c7.952,5.593,2.097,45.194-22.009,94.447c-0.948,4.17-1.895,8.342-2.844,12.512 c21.011,3.692,26.214,7.483,26.38,10.51c0.359,6.556-22.645,14.92-43.966,15.464c-26.737,0.682-55.124-10.821-54.581-19.406 c0.22-3.475,5.263-7.761,24.676-11.97c3.035-4.266,6.067-8.531,9.101-12.797 C1918.142,2569.631,1901.635,2551.548,1903.833,2534.579z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000130631879303707715550000006455026289633873077_",
    gradientUnits: "userSpaceOnUse",
    x1: 3001.55,
    y1: 2644.3811,
    x2: 2929.0303,
    y2: 2761.6926,
    gradientTransform: "matrix(0.9717 -0.2361 0.2361 0.9717 -1594.3406 640.4756)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000130631879303707715550000006455026289633873077_)"
    },
    d: "M1936.883,2525.906 c6.064-3.629,10.683,4.172,7.827,10.99c-2.855,6.818-12.455,11.085-18.277,7.019 C1920.611,2539.851,1928.723,2530.789,1936.883,2525.906z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000175307376287463627410000006954632332869812663_",
    gradientUnits: "userSpaceOnUse",
    x1: 5053.7686,
    y1: 1999.986,
    x2: 5681.8169,
    y2: 2998.2251,
    gradientTransform: "matrix(1 0 0 1 -3129.1155 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000175307376287463627410000006954632332869812663_)"
    },
    d: "M2722.882,2525.791 c-79.822-86.62-265.551-62.866-368.567,6.701c-47.869,32.326-72.437,70.509-128.999,73.714 c-42.999,2.436-111.402-13.732-147.427-60.311c-4.538-5.869-22.691-30.48-49.949-61.516 c-12.017-13.682-23.968-26.522-42.492-29.426c-4.706-0.737-20.362-3.285-30.711,6.826 c-8.387,8.192-10.444,22.436-7.965,32.704c1.485,6.139,3.403,6.786,3.13,10.806c-0.768,11.291-21.336,16.21-20.19,21.897 c0.817,4.063,11.521,2.576,13.365,7.677c2.02,5.59-9.736,10.399-14.788,24.457c-9.463,6.335-15.442,22.099-17.511,43.193 c-3.041,31.009,0.074,56.205,5.95,75.18c28.289,91.365,48.526,156.717,97.499,193.211 c64.837,48.316,123.22,3.706,288.153-3.35c225.841-9.66,282.15,66.891,363.32,14.521 C2767.052,2816.684,2805.76,2615.722,2722.882,2525.791z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000136411283342699450760000006411820637635837605_",
    gradientUnits: "userSpaceOnUse",
    x1: 4825.1416,
    y1: 2643.3079,
    x2: 5176.0781,
    y2: 3364.9529,
    gradientTransform: "matrix(1 0 0 1 -3129.1155 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000136411283342699450760000006411820637635837605_)"
    },
    d: "M1538.303,2348.988 c-2.013,18.897-8.825,102.489,48.834,173.071c53.877,65.95,130.178,79.124,144.361,81.267 c68.604,10.366,98.189-19.2,122.162,0.946c40.682,34.185,19.066,172.739-54.583,210.06 c-83.019,42.069-203.529-58.999-256.372-129.014c-69.331-91.855-69.301-192.663-68.896-213.48 c1.05-54.095,14.911-97.16,25.89-123.94c4.51-1.358,11.375-2.86,19.791-2.568 C1527.509,2345.61,1533.982,2347.415,1538.303,2348.988z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000032624020259685771920000005836367942646027941_",
    gradientUnits: "userSpaceOnUse",
    x1: 4813.3213,
    y1: 2651.2627,
    x2: 5170.1343,
    y2: 3384.9915,
    gradientTransform: "matrix(1 0 0 1 -3129.1155 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.25,
      fill: "url(#SVGID_00000032624020259685771920000005836367942646027941_)"
    },
    d: "M2242.907,3431.293 c-20.083-20.59,2.025-62.111-27.642-92.979c-27.533-28.649-58.707-5.504-103.031-30.155 c-56.852-31.619-41.186-89.503-95.493-120.623c-39.051-22.379-57.402,1.682-118.109-10.052 c-60.604-11.713-134.419-53.495-170.881-128.161c-15.494-31.726-21.203-63.266-21.962-91.459 c-27.257,48.697-55.529,95.366-59.252,174.123c-2.338,49.441,6.029,89.851,12.526,114.186 c20.228,25.191,53.335,60.741,102.194,90.466c71.099,43.257,112.33,35.716,214.439,63.662 c167.021,45.711,181.88,100.147,264.698,86.279c53.494-8.958,102.677-40.96,128.979-72.99 C2292.185,3447.949,2257.483,3446.237,2242.907,3431.293z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunity);
export default __webpack_public_path__ + "static/media/Community.4ca6799396655c7c8dc935ee9d2a8805.svg";
export { ForwardRef as ReactComponent };